export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const SlotGames = {
  netenttab: {
    asgardianstones: {
      redirectUrl: "/casino/ezgne-asgardian-stones",
      code: "1100096",
      casino: "ezugi",
      imgUrl: "./images/slots/asgardianstones.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Asgardian Stones",
      providerName: "slots",
    },
    secrets: {
      redirectUrl: "/casino/ezgne-secrets-of-atlantis",
      code: "1100106",
      casino: "ezugi",
      imgUrl: "./images/slots/secrets-of-atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Secrets of Atlantis",
      providerName: "slots",
    },
    SteamTower: {
      redirectUrl: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      imgUrl: "./images/slots/Steam-Tower.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Steam Tower",
      providerName: "slots",
    },
    DivinieFortuneMegaways: {
      redirectUrl: "/casino/ezgne-divine-fortune-megaways",
      code: "1100089",
      casino: "ezugi",
      imgUrl: "./images/slots/divine_fortune_megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Divine Fortune Megaways",
      providerName: "slots",
    },
    FruitShopMegaways: {
      redirectUrl: "/casino/ezgne-fruit-shop-megaways",
      code: "1100094",
      casino: "ezugi",
      imgUrl: "./images/slots/Fruit_Shop_Megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop Megaways",
      providerName: "slots",
    },
    GorillaKingdom: {
      redirectUrl: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      imgUrl: "./images/slots/Gorilla_Kingdom.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gorilla Kingdom",
      providerName: "slots",
    },
    Christmas: {
      redirectUrl: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      imgUrl: "./images/slots/Aloha-Christmas.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Christmas",
      providerName: "slots",
    },
    ClusterPays: {
      redirectUrl: "/casino/ezgne-aloha-cluster-pays",
      code: "1100033",
      casino: "ezugi",
      imgUrl: "./images/slots/Aloha-Cluster-Pays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aloha! Cluster Pays",
      providerName: "slots",
    },
    WildWest: {
      redirectUrl: "/casino/ezgne-wild-wild-west-the-great-train-heist",
      code: "1100038",
      casino: "ezugi",
      imgUrl: "./images/slots/Wild-Wild-West-The-Great-Train-Heist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild West: The Great Train Heist",
      providerName: "slots",
    },
    TwinSpinMegaways: {
      redirectUrl: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      imgUrl: "./images/slots/Twin_Spin_Megaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Twin Spin Megaways",
      providerName: "slots",
    },
    TurnFortune: {
      redirectUrl: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      imgUrl: "./images/slots/Turn_Your_Fortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Turn Your Fortune",
      providerName: "slots",
    },
    Pyramid: {
      redirectUrl: "/casino/ezgne-pyramid-quest-for-immortality",
      code: "1100078",
      casino: "ezugi",
      imgUrl: "./images/slots/Pyramid-Quest-for-Immortality.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pyramid: Quest for Immortality",
      providerName: "slots",
    },
    PiggyRiches: {
      redirectUrl: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      imgUrl: "./images/slots/Piggy-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches",
      providerName: "slots",
    },
    DarkKing: {
      redirectUrl: "/casino/ezgne-dark-king-forbidden-riches",
      code: "1100081",
      casino: "ezugi",
      imgUrl: "./images/slots/Dark-King-Forbidden-Riches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dark King: Forbidden Riches",
      providerName: "slots",
    },
    JingleSpin: {
      redirectUrl: "/casino/ezgne-jingle-spin",
      code: "1100082",
      casino: "ezugi",
      imgUrl: "./images/slots/Jingle-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Spin",
      providerName: "slots",
    },
    JackHammer: {
      redirectUrl: "/casino/ezgne-jack-hammer",
      code: "1100084",
      casino: "ezugi",
      imgUrl: "./images/slots/Jack-Hammer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack Hammer",
      providerName: "slots",
    },
    DeadorAlive: {
      redirectUrl: "/casino/ezgne-dead-or-alive",
      code: "1100085",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive",
      providerName: "slots",
    },
    DeadorAlive2: {
      redirectUrl: "/casino/ezgne-dead-or-alive-2",
      code: "1100087",
      casino: "ezugi",
      imgUrl: "./images/slots/Dead-or-Alive-2.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dead or Alive 2",
      providerName: "slots",
    },
    JackandtheBeanstalk: {
      redirectUrl: "/casino/ezgne-jack-and-the-beanstalk",
      code: "1100086",
      casino: "ezugi",
      imgUrl: "./images/slots/Jack-and-the-Beanstalk.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack and the Beanstalk",
      providerName: "slots",
    },
    Elements: {
      redirectUrl: "/casino/ezgne-elements-the-awakening",
      code: "1100091",
      casino: "ezugi",
      imgUrl: "./images/slots/Elements-The-Awakening.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Elements: The Awakening",
      providerName: "slots",
    },
    FinnandtheSwirlySpin: {
      redirectUrl: "/casino/ezgne-finn-and-the-swirly-spin",
      code: "1100093",
      casino: "ezugi",
      imgUrl: "./images/slots/Finn-and-the-Swirly-Spin.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Finn and the Swirly Spin",
      providerName: "slots",
    },
    FruitShop: {
      redirectUrl: "/casino/ezgne-fruit-shop",
      code: "1100095",
      casino: "ezugi",
      imgUrl: "./images/slots/Fruit-Shop.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fruit Shop",
      providerName: "slots",
    },
    // DeadorAlive2FeatureBuy: {
    //   redirectUrl: "/casino/ezgne-dead-or-alive-2-feature-buy",
    //   code: "1100100",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/DeadOrAlive2FeatureBuy.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Dead or Alive 2 Feature Buy",
    //   providerName: "slots",
    // },
  },

  // redtigertab: {
  //   NinjaWays: {
  //     redirectUrl: "/casino/ezgrt-ninja-ways",
  //     code: "1100166",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Ninja-Ways.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Ninja Ways",
  //     providerName: "slots",
  //   },
  //   PathofDestiny: {
  //     redirectUrl: "/casino/ezgrt-path-of-destiny",
  //     code: "1100167",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Path-of-Destiny.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Path of Destiny",
  //     providerName: "slots",
  //   },
  //   PersianFortune: {
  //     redirectUrl: "/casino/ezgrt-persian-fortune",
  //     code: "1100168",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Persian-Fortune.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Persian Fortune",
  //     providerName: "slots",
  //   },
  //   ReelHeist: {
  //     redirectUrl: "/casino/ezgrt-reel-heist",
  //     code: "1100169",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel-Heist.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel Heist",
  //     providerName: "slots",
  //   },
  //   ReelKingMegaways: {
  //     redirectUrl: "/casino/ezgrt-reel-king-mega",
  //     code: "1100052",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Reel_King_Mega.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Reel King Mega",
  //     providerName: "slots",
  //   },
  //   RobinHoodWildForest: {
  //     redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
  //     code: "1100170",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Robin-Hood`s-Wild-Forest.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Robin Hood`s Wild Forest",
  //     providerName: "slots",
  //   },
  //   SnowWild: {
  //     redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
  //     code: "1100171",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Snow-Wild-And-The-7-Features.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Snow Wild And The 7 Features",
  //     providerName: "slots",
  //   },
  //   SylvanSpirits: {
  //     redirectUrl: "/casino/ezgrt-sylvan-spirits",
  //     code: "1100172",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Sylvan-Spirits.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Sylvan Spirits",
  //     providerName: "slots",
  //   },
  //   TheGreatestTrainRobbery: {
  //     redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
  //     code: "1100173",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Greatest-Train-Robbery.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Greatest Train Robbery",
  //     providerName: "slots",
  //   },
  //   TheWildHatter: {
  //     redirectUrl: "/casino/ezgrt-the-wild-hatter",
  //     code: "1100174",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/The-Wild-Hatter.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "The Wild Hatter",
  //     providerName: "slots",
  //   },
  //   ThorLightning: {
  //     redirectUrl: "/casino/ezgrt-thors-lightning",
  //     code: "1100175",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Thor`s-Lightning.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Thor`s Lightning",
  //     providerName: "slots",
  //   },
  //   DragonLuck: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck",
  //     code: "1100001",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck",
  //     providerName: "slots",
  //   },
  //   DragonLuckReel: {
  //     redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
  //     code: "1100002",
  //     casino: "ezugi",
  //     imgUrl: "./images/slots/Dragon's-Luck-Power-Reels.webp",
  //     homeUrl: pageUrlGenerator("/Slots"),
  //     name: "Dragon's Luck Power Reels",
  //     providerName: "slots",
  //   },
  // },

  redtigertab: {
    DragonsLuck: {
      redirectUrl: "/casino/ezgrt-dragons-luck",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuck.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck",
      providerName: "slots",
    },
    DragonsLuckPowerReels: {
      redirectUrl: "/casino/ezgrt-dragons-luck-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Power Reels",
      providerName: "slots",
    },
    Nights10001: {
      redirectUrl: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/10001Nights.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "10,001 Nights",
      providerName: "slots",
    },
    GodOfWealth: {
      redirectUrl: "/casino/ezgrt-god-of-wealth",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GodOfWealth.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "God Of Wealth",
      providerName: "slots",
    },
    PiratesPlentyBattleforGold: {
      redirectUrl: "/casino/ezgrt-pirates-plenty-battle-for-gold",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlentyBattleforGold.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty Battle for Gold",
      providerName: "slots",
    },
    ChineseTreasures: {
      redirectUrl: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ChineseTreasures.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Chinese Treasures",
      providerName: "slots",
    },
    FortuneHouse: {
      redirectUrl: "/casino/ezgrt-fortune-house",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FortuneHouse.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Fortune House",
      providerName: "slots",
    },
    DragonsFire: {
      redirectUrl: "/casino/ezgrt-dragons-fire",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFire.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire",
      providerName: "slots",
    },
    MagicGate: {
      redirectUrl: "/casino/ezgrt-magic-gate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MagicGate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Magic Gate",
      providerName: "slots",
    },
    LuckyFortuneCat: {
      redirectUrl: "/casino/ezgrt-lucky-fortune-cat",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyFortuneCat.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Fortune Cat",
      providerName: "slots",
    },
    DragonsLuckDeluxe: {
      redirectUrl: "/casino/ezgrt-dragons-luck-deluxe",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsLuckDeluxe.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Luck Deluxe",
      providerName: "slots",
    },
    EpicJourney: {
      redirectUrl: "/casino/ezgrt-epic-journey",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/EpicJourney.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Epic Journey",
      providerName: "slots",
    },
    PhoenixFirePowerReels: {
      redirectUrl: "/casino/ezgrt-phoenix-fire-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PhoenixFirePowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Phoenix Fire Power Reels",
      providerName: "slots",
    },
    GoldenTemple: {
      redirectUrl: "/casino/ezgrt-golden-temple",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTemple.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Temple",
      providerName: "slots",
    },
    PiratesPlenty: {
      redirectUrl: "/casino/ezgrt-pirates-plenty",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiratesPlenty.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Pirates' Plenty",
      providerName: "slots",
    },
    GoldenOffer: {
      redirectUrl: "/casino/ezgrt-golden-offer",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenOffer.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Offer",
      providerName: "slots",
    },
    RAsLegend: {
      redirectUrl: "/casino/ezgrt-ras-legend",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RAsLegend.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "RA's Legend",
      providerName: "slots",
    },
    GonzosQuestMegaways: {
      redirectUrl: "/casino/ezgrt-gonzos-quest-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GonzosQuestMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gonzo's Quest Megaways",
      providerName: "slots",
    },
    RainbowJackpots: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpots.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots",
      providerName: "slots",
    },
    MegaPyramid: {
      redirectUrl: "/casino/ezgrt-mega-pyramid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaPyramid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Pyramid",
      providerName: "slots",
    },
    WarOfGods: {
      redirectUrl: "/casino/ezgrt-war-of-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WarOfGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "War Of Gods",
      providerName: "slots",
    },
    Strike777: {
      redirectUrl: "/casino/ezgrt-777-strike",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/777Strike.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "777 Strike",
      providerName: "slots",
    },
    AncientsBlessing: {
      redirectUrl: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AncientsBlessing.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ancients Blessing",
      providerName: "slots",
    },
    AurumCodex: {
      redirectUrl: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AurumCodex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aurum Codex",
      providerName: "slots",
    },
    BettyBorisandBoo: {
      redirectUrl: "/casino/ezgrt-betty-boris-and-boo",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BettyBorisandBoo.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Betty, Boris and Boo",
      providerName: "slots",
    },
    // ZeusLightningPowerReels: {
    //   redirectUrl: "/casino/ezgrt-zeus-lightning-power-reels",
    //   code: "",
    //   casino: "ezugi",
    //   imgUrl: "./images/slots/new/redtiger/ZeusLightningPower-Reels.webp",
    //   homeUrl: pageUrlGenerator("/Slots"),
    //   name: "Zeus Lightning Power Reels",
    //   providerName: "slots",
    // },
    WingsofRa: {
      redirectUrl: "/casino/ezgrt-wings-of-ra",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WingsofRa.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wings of Ra",
      providerName: "slots",
    },
    TreasureMine: {
      redirectUrl: "/casino/ezgrt-treasure-mine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TreasureMine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Treasure Mine",
      providerName: "slots",
    },
    ThorsVengeance: {
      redirectUrl: "/casino/ezgrt-thors-vengeance",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsVengeance.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor's Vengeance",
      providerName: "slots",
    },
    RegalStreak: {
      redirectUrl: "/casino/ezgrt-regal-streak",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalStreak.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Streak",
      providerName: "slots",
    },
    RegalBeasts: {
      redirectUrl: "/casino/ezgrt-regal-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RegalBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Regal Beasts",
      providerName: "slots",
    },
    ReelKingMega: {
      redirectUrl: "/casino/ezgrt-reel-king-mega",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKingMega.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel King Mega",
      providerName: "slots",
    },
    ReelKeeper: {
      redirectUrl: "/casino/ezgrt-reel-keeper",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelKeeper.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Keeper",
      providerName: "slots",
    },
    RainbowJackpotsPowerLines: {
      redirectUrl: "/casino/ezgrt-rainbow-jackpots-power-lines",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RainbowJackpotsPowerLines.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Rainbow Jackpots Power Lines",
      providerName: "slots",
    },
    MysteryReels: {
      redirectUrl: "/casino/ezgrt-mystery-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels",
      providerName: "slots",
    },
    PiggyRichesMegaways: {
      redirectUrl: "/casino/ezgrt-piggy-riches-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PiggyRichesMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Piggy Riches Megaways",
      providerName: "slots",
    },
    JingleBells: {
      redirectUrl: "/casino/ezgrt-jingle-bells",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBells.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells",
      providerName: "slots",
    },
    JackinaPot: {
      redirectUrl: "/casino/ezgrt-jack-in-a-pot",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JackinaPot.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jack in a Pot",
      providerName: "slots",
    },
    FiveStar: {
      redirectUrl: "/casino/ezgrt-five-star",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Star",
      providerName: "slots",
    },
    BountyRaid: {
      redirectUrl: "/casino/ezgrt-bounty-raid",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/BountyRaid.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Bounty Raid",
      providerName: "slots",
    },
    CashUltimate: {
      redirectUrl: "/casino/ezgrt-cash-ultimate",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashUltimate.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Ultimate",
      providerName: "slots",
    },
    CashVolt: {
      redirectUrl: "/casino/ezgrt-cash-volt",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CashVolt.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cash Volt",
      providerName: "slots",
    },
    DynamiteRiches: {
      redirectUrl: "/casino/ezgrt-dynamite-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DynamiteRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dynamite Riches",
      providerName: "slots",
    },
    DiamondBlitz: {
      redirectUrl: "/casino/ezgrt-diamond-blitz",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiamondBlitz.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Diamond Blitz",
      providerName: "slots",
    },
    DragonsFireMegaways: {
      redirectUrl: "/casino/ezgrt-dragons-fire-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DragonsFireMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dragon's Fire Megaways",
      providerName: "slots",
    },
    Squad4: {
      redirectUrl: "/casino/ezgrt-4-squad",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/4Squad.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "4 Squad",
      providerName: "slots",
    },
    AgentRoyale: {
      redirectUrl: "/casino/ezgrt-agent-royale",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AgentRoyale.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Agent Royale",
      providerName: "slots",
    },
    Families5: {
      redirectUrl: "/casino/ezgrt-5-families",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/5Families.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "5 Families",
      providerName: "slots",
    },
    ArcadeBomb: {
      redirectUrl: "/casino/ezgrt-arcade-bomb",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ArcadeBomb.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Arcade Bomb",
      providerName: "slots",
    },
    CinderellasBall: {
      redirectUrl: "/casino/ezgrt-cinderellas-ball",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CinderellasBall.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cinderella`s Ball",
      providerName: "slots",
    },
    Atlantis: {
      redirectUrl: "/casino/ezgrt-atlantis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Atlantis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Atlantis",
      providerName: "slots",
    },
    AztecSpins: {
      redirectUrl: "/casino/ezgrt-aztec-spins",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/AztecSpins.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Aztec Spins",
      providerName: "slots",
    },
    ClashoftheBeasts: {
      redirectUrl: "/casino/ezgrt-clash-of-the-beasts",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ClashoftheBeasts.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Clash of the Beasts",
      providerName: "slots",
    },
    CirquedelaFortune: {
      redirectUrl: "/casino/ezgrt-cirque-de-la-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CirquedelaFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Cirque de la Fortune",
      providerName: "slots",
    },
    CrazyGenie: {
      redirectUrl: "/casino/ezgrt-crazy-genie",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrazyGenie.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crazy Genie",
      providerName: "slots",
    },
    CrystalMirror: {
      redirectUrl: "/casino/ezgrt-crystal-mirror",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/CrystalMirror.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Crystal Mirror",
      providerName: "slots",
    },
    DevilsNumber: {
      redirectUrl: "/casino/ezgrt-devils-number",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DevilsNumber.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Devil`s Number",
      providerName: "slots",
    },
    DaVincisMystery: {
      redirectUrl: "/casino/ezgrt-da-vincis-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DaVincisMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Da Vinci`s Mystery",
      providerName: "slots",
    },
    DiceDiceDice: {
      redirectUrl: "/casino/ezgrt-dice-dice-dice",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/DiceDiceDice.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Dice Dice Dice",
      providerName: "slots",
    },
    FiveStarsPowerReels: {
      redirectUrl: "/casino/ezgrt-five-stars-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/FiveStarsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Five Stars Power Reels",
      providerName: "slots",
    },
    GemsGoneWild: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWild.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild",
      providerName: "slots",
    },
    GemsGoneWildPowerReels: {
      redirectUrl: "/casino/ezgrt-gems-gone-wild-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GemsGoneWildPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Gems Gone Wild Power Reels",
      providerName: "slots",
    },
    GoldenCryptex: {
      redirectUrl: "/casino/ezgrt-golden-cryptex",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenCryptex.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Cryptex",
      providerName: "slots",
    },
    GoldenLeprechaunMegaways: {
      redirectUrl: "/casino/ezgrt-golden-leprechaun-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenLeprechaunMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Leprechaun Megaways",
      providerName: "slots",
    },
    GrandWheel: {
      redirectUrl: "/casino/ezgrt-grand-wheel",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GrandWheel.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Grand Wheel",
      providerName: "slots",
    },
    GoldenTsar: {
      redirectUrl: "/casino/ezgrt-golden-tsar",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/GoldenTsar.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Golden Tsar",
      providerName: "slots",
    },
    HoardofPoseidon: {
      redirectUrl: "/casino/ezgrt-hoard-of-poseidon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/HoardofPoseidon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Hoard of Poseidon",
      providerName: "slots",
    },
    JewelScarabs: {
      redirectUrl: "/casino/ezgrt-jewel-scarabs",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JewelScarabs.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jewel Scarabs",
      providerName: "slots",
    },
    LegendofAthena: {
      redirectUrl: "/casino/ezgrt-legend-of-athena",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LegendofAthena.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Legend of Athena",
      providerName: "slots",
    },
    JingleBellsPowerReels: {
      redirectUrl: "/casino/ezgrt-jingle-bells-power-reels",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/JingleBellsPowerReels.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Jingle Bells Power Reels",
      providerName: "slots",
    },
    LuckyHalloween: {
      redirectUrl: "/casino/ezgrt-lucky-halloween",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyHalloween.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Halloween",
      providerName: "slots",
    },
    LuckyLittleDevil: {
      redirectUrl: "/casino/ezgrt-lucky-little-devil",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyLittleDevil.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Little Devil",
      providerName: "slots",
    },
    LuckyValentine: {
      redirectUrl: "/casino/ezgrt-lucky-valentine",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyValentine.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Valentine",
      providerName: "slots",
    },
    LuckyWizard: {
      redirectUrl: "/casino/ezgrt-lucky-wizard",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/LuckyWizard.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Lucky Wizard",
      providerName: "slots",
    },
    Masquerade: {
      redirectUrl: "/casino/ezgrt-masquerade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/Masquerade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Masquerade",
      providerName: "slots",
    },
    MayanGods: {
      redirectUrl: "/casino/ezgrt-mayan-gods",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MayanGods.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mayan Gods",
      providerName: "slots",
    },
    MegaDragon: {
      redirectUrl: "/casino/ezgrt-mega-dragon",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaDragon.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Dragon",
      providerName: "slots",
    },
    MegaJade: {
      redirectUrl: "/casino/ezgrt-mega-jade",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaJade.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Jade",
      providerName: "slots",
    },
    MegaRise: {
      redirectUrl: "/casino/ezgrt-mega-rise",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MegaRise.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mega Rise",
      providerName: "slots",
    },
    MultiplierRiches: {
      redirectUrl: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MultiplierRiches.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Multiplier Riches",
      providerName: "slots",
    },
    MysteryReelsMegaways: {
      redirectUrl: "/casino/ezgrt-mystery-reels-megaways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/MysteryReelsMegaways.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Mystery Reels Megaways",
      providerName: "slots",
    },
    NinjaWays: {
      redirectUrl: "/casino/ezgrt-ninja-ways",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/NinjaWays.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Ninja Ways",
      providerName: "slots",
    },
    PathofDestiny: {
      redirectUrl: "/casino/ezgrt-path-of-destiny",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PathofDestiny.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Path of Destiny",
      providerName: "slots",
    },
    PersianFortune: {
      redirectUrl: "/casino/ezgrt-persian-fortune",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/PersianFortune.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Persian Fortune",
      providerName: "slots",
    },
    ReelHeist: {
      redirectUrl: "/casino/ezgrt-reel-heist",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ReelHeist.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Reel Heist",
      providerName: "slots",
    },
    RobinHoodsWildForest: {
      redirectUrl: "/casino/ezgrt-robin-hoods-wild-forest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/RobinHoodsWildForest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Robin Hood`s Wild Forest",
      providerName: "slots",
    },
    SnowWildAndThe7Features: {
      redirectUrl: "/casino/ezgrt-snow-wild-and-the-7-features",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SnowWildAndThe7Features.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Snow Wild And The 7 Features",
      providerName: "slots",
    },
    SylvanSpirits: {
      redirectUrl: "/casino/ezgrt-sylvan-spirits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/SylvanSpirits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Sylvan Spirits",
      providerName: "slots",
    },
    TheGreatestTrainRobbery: {
      redirectUrl: "/casino/ezgrt-the-greatest-train-robbery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheGreatestTrainRobbery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Greatest Train Robbery",
      providerName: "slots",
    },
    TheWildHatter: {
      redirectUrl: "/casino/ezgrt-the-wild-hatter",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TheWildHatter.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "The Wild Hatter",
      providerName: "slots",
    },
    ThorsLightning: {
      redirectUrl: "/casino/ezgrt-thors-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/ThorsLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Thor`s Lightning",
      providerName: "slots",
    },
    TikiFruits: {
      redirectUrl: "/casino/ezgrt-tiki-fruits",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TikiFruits.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Tiki Fruits",
      providerName: "slots",
    },
    VaultCracker: {
      redirectUrl: "/casino/ezgrt-vault-cracker",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultCracker.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault Cracker",
      providerName: "slots",
    },
    TotemLightning: {
      redirectUrl: "/casino/ezgrt-totem-lightning",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/TotemLightning.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Totem Lightning",
      providerName: "slots",
    },
    WellofWishes: {
      redirectUrl: "/casino/ezgrt-well-of-wishes",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WellofWishes.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Well of Wishes",
      providerName: "slots",
    },
    VaultofAnubis: {
      redirectUrl: "/casino/ezgrt-vault-of-anubis",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/VaultofAnubis.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Vault of Anubis",
      providerName: "slots",
    },
    WildOClock: {
      redirectUrl: "/casino/ezgrt-wild-oclock",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildOClock.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild O`Clock",
      providerName: "slots",
    },
    WildCatsMultiline: {
      redirectUrl: "/casino/ezgrt-wild-cats-multiline",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildCatsMultiline.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Cats Multiline",
      providerName: "slots",
    },
    YucatansMystery: {
      redirectUrl: "/casino/ezgrt-yucatans-mystery",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/YucatansMystery.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Yucatan`s Mystery",
      providerName: "slots",
    },
    WildWildChest: {
      redirectUrl: "/casino/ezgrt-wild-wild-chest",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WildWildChest.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Wild Wild Chest",
      providerName: "slots",
    },
    WinEscalator: {
      redirectUrl: "/casino/ezgrt-win-escalator",
      code: "",
      casino: "ezugi",
      imgUrl: "./images/slots/new/redtiger/WinEscalator.webp",
      homeUrl: pageUrlGenerator("/Slots"),
      name: "Win Escalator",
      providerName: "slots",
    },
  },

  turboGamingtab: {
    TapMines1: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "1Tap Mines",
      name: "1Tap Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/1tapmines.jpg",
      redirectUrl: "/casino/aggapturbogames-1tap-mines",
    },
    aero: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Aero",
      name: "Aero",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/aero.jpg",
      redirectUrl: "/casino/aggapturbogames-aero",
    },
    bookofmines: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "BOOK OF MINES",
      name: "BOOK OF MINES",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bookofmines.jpg",
      redirectUrl: "/casino/aggapturbogames-book-of-mines",
    },
    bubbles: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bubbles",
      name: "Bubbles",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/bubbles.jpg",
      redirectUrl: "/casino/aggapturbogames-bubbles",
    },
    catanza: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Catanza",
      name: "Catanza",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/catanza.jpg",
      redirectUrl: "/casino/aggapturbogames-catanza",
    },
    cricketboom: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Boom",
      name: "Cricket Boom",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/cricketboom.jpg",
      redirectUrl: "/casino/aggapturbogames-cricket-boom",
    },
    crystalpoker: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crystal Poker",
      name: "Crystal Poker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/crystalpoker.jpg",
      redirectUrl: "/casino/aggapturbogames-crystal-poker",
    },
    dicethrice: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dice Thrice",
      name: "Dice Thrice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dicethrice.jpg",
      redirectUrl: "/casino/aggapturbogames-dice-thrice",
    },
    dogsstreet: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dogs Street",
      name: "Dogs Street",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/dogsstreet.jpg",
      redirectUrl: "/casino/aggapturbogames-dogs-street-u4503",
    },
    donnyking: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "",
      name: "Donny King",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/donnyking.jpg",
      redirectUrl: "/casino/aggapturbogames-donny-king",
    },
    doubleroll: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Double Roll",
      name: "Double Roll",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/doubleroll.jpg",
      redirectUrl: "/casino/aggapturbogames-double-roll",
    },
    fastfielder: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fast Fielder",
      name: "Fast Fielder",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fastfielder.jpg",
      redirectUrl: "/casino/aggapturbogames-fast-fielder",
    },
    fruitstowers: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fruit Towers",
      name: "Fruit Towers",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/fruitstowers.jpg",
      redirectUrl: "/casino/aggapturbogames-fruit-towers",
    },
    hilo: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Hi-Lo",
      name: "Hi-Lo",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/hi-lo.jpg",
      redirectUrl: "/casino/aggapturbogames-hi-lo",
    },
    jewelclicker: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jewel Clicker",
      name: "Jewel Clicker",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/jewelclicker.jpg",
      redirectUrl: "/casino/aggapturbogames-jewel-clicker",
    },
    magickeno: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Magic Keno",
      name: "Magic Keno",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/magickeno.jpg",
      redirectUrl: "/casino/aggapturbogames-magic-keno",
    },
    multiplayermines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Multiplayer Mines",
      name: "Multiplayer Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/multiplayermines.jpg",
      redirectUrl: "/casino/aggapturbogames-multiplayer-mines",
    },
    pumpedX: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "PumpedX",
      name: "PumpedX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/pumpedX.jpg",
      redirectUrl: "/casino/aggapturbogames-pumpedx",
    },
    spinstrike: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Spin Strike",
      name: "Spin Strike",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/spinstrike.jpg",
      redirectUrl: "/casino/aggapturbogames-spin-strike",
    },
    takemyplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Take My Plinko",
      name: "Take My Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/takemyplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-take-my-plinko",
    },
    tradingdice: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Trading Dice",
      name: "Trading Dice",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/tradingdice.jpg",
      redirectUrl: "/casino/aggapturbogames-trading-dice",
    },
    turbomines: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Mines",
      name: "Turbo Mines",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turbomines.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-mines",
    },
    turboplinko: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Turbo Plinko",
      name: "Turbo Plinko",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/turboplinko.jpg",
      redirectUrl: "/casino/aggapturbogames-turbo-plinko",
    },
    vortex: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "VORTEX",
      name: "VORTEX",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/vortex.jpg",
      redirectUrl: "/casino/aggapturbogames-vortex",
    },
    wicketblast: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wicket Blast",
      name: "Wicket Blast",
      providerName: "Turbo Games",
      imgUrl: "./images/alt-gaming/turbogames/wicketblast.jpg",
      redirectUrl: "/casino/aggapturbogames-wicket-blast",
    },
  },

  hacksaw: {
    WantedDeadOrAWild: {
      redirectUrl: "/casino/aggaphacksawgaming-wanted-dead-or-a-wild",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/WantedDeadOrAWild.webp",
      alt: "Wanted Dead or a Wild",
      name: "Wanted Dead or a Wild",
    },
    ChaosCrew: {
      redirectUrl: "/casino/aggaphacksawgaming-chaos-crew",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ChaosCrew.webp",
      alt: "Chaos Crew",
      name: "Chaos Crew",
    },
    StackEM: {
      redirectUrl: "/casino/aggaphacksawgaming-stackem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/StackEM.webp",
      alt: "Stack'EM",
      name: "Stack'EM",
    },
    ChaosCrewII: {
      redirectUrl: "/casino/aggaphacksawgaming-chaos-crew-ii",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ChaosCrewII.webp",
      alt: "Chaos Crew II",
      name: "Chaos Crew II",
    },
    ChaosCrewScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-chaos-crew-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ChaosCrewScratch.webp",
      alt: "Chaos Crew Scratch",
      name: "Chaos Crew Scratch",
    },

    StackEmScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-stackem-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/StackEmScratch.webp",
      alt: "Stack'Em Scratch",
      name: "Stack'Em Scratch",
    },
    SCRATCHPlatinum: {
      redirectUrl: "/casino/qt-scratch-platinum",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SCRATCHPlatinum.webp",
      alt: "SCRATCH! Platinum",
      name: "SCRATCH! Platinum",
    },
    SCRATCHGold: {
      redirectUrl: "/casino/qt-scratch-gold",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SCRATCHGold.webp",
      alt: "SCRATCH! Gold",
      name: "SCRATCH! Gold",
    },
    SCRATCHSilver: {
      redirectUrl: "/casino/qt-scratch-silver",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SCRATCHSilver.webp",
      alt: "SCRATCH! Silver",
      name: "SCRATCH! Silver",
    },
    SCRATCHBronze: {
      redirectUrl: "/casino/qt-scratch-bronze",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SCRATCHBronze.webp",
      alt: "SCRATCH! Bronze",
      name: "SCRATCH! Bronze",
    },
    SnowScratcher: {
      redirectUrl: "/casino/aggaphacksawgaming-snow-scratcher",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SnowScratcher.webp",
      alt: "Snow Scratcher",
      name: "Snow Scratcher",
    },
    SummerScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-summer-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SummerScratch.webp",
      alt: "Summer Scratch",
      name: "Summer Scratch",
    },
    Express200Scratch: {
      redirectUrl: "/casino/qt-express-200-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Express200Scratch.webp",
      alt: "Express 200 Scratch",
      name: "Express 200 Scratch",
    },
    ScratchyMini: {
      redirectUrl: "/casino/aggaphacksawgaming-scratchy-mini",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ScratchyMini.webp",
      alt: "Scratchy Mini",
      name: "Scratchy Mini",
    },
    Scratchy: {
      redirectUrl: "/casino/aggaphacksawgaming-scratchy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Scratchy.webp",
      alt: "Scratchy",
      name: "Scratchy",
    },
    // ScratchyBig: {
    //   redirectUrl: "/casino/aggaphacksawgaming-scratchy-big",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/hacksaw/ScratchyBig.webp",
    //   alt: "Scratchy Big",
    //   name: "Scratchy Big",
    // },
    KingTreasure: {
      redirectUrl: "/casino/aggaphacksawgaming-king-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/KingTreasure.webp",
      alt: "King Treasure",
      name: "King Treasure",
    },
    QueenTreasure: {
      redirectUrl: "/casino/aggaphacksawgaming-queen-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/QueenTreasure.webp",
      alt: "Queen Treasure",
      name: "Queen Treasure",
    },
    PrinceTreasure: {
      redirectUrl: "/casino/aggaphacksawgaming-prince-treasure",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/PrinceTreasure.webp",
      alt: "Prince Treasure",
      name: "Prince Treasure",
    },
    HappyScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-happy-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Happyscratch.webp",
      alt: "Happy Scratch",
      name: "Happy Scratch",
    },
    LOVEIsAllYouNeed: {
      redirectUrl: "/casino/aggaphacksawgaming-love-is-all-you-need",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LoveIsAllYouNeed.webp",
      alt: "LOVE is all you need",
      name: "LOVE is all you need",
    },
    LuckyScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-lucky-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Luckyscratch.webp",
      alt: "Lucky Scratch",
      name: "Lucky Scratch",
    },
    CashPool: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-pool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Cashpool.webp",
      alt: "Cash Pool",
      name: "Cash Pool",
    },
    CashScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashScratch.webp",
      alt: "Cash Scratch",
      name: "Cash Scratch",
    },
    DreamCarUrban: {
      redirectUrl: "/casino/aggaphacksawgaming-dream-car-urban",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DreamCarUrban.webp",
      alt: "Dream Car Urban",
      name: "Dream Car Urban",
    },
    DreamCarSUV: {
      redirectUrl: "/casino/aggaphacksawgaming-dream-car-suv",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DreamCarSUV.webp",
      alt: "Dream Car SUV",
      name: "Dream Car SUV",
    },
    DreamCarSpeed: {
      redirectUrl: "/casino/aggaphacksawgaming-dream-car-speed",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DreamCarSpeed.webp",
      alt: "Dream Car Speed",
      name: "Dream Car Speed",
    },
    // EggstraCash: {
    //   redirectUrl: "/casino/aggaphacksawgaming-eggstra-cash",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/hacksaw/EggstraCash.webp",
    //   alt: "Eggstra Cash",
    //   name: "Eggstra Cash",
    // },
    FootballScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-football-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FootballScratch.webp",
      alt: "Football Scratch",
      name: "Football Scratch",
    },
    GoldRush: {
      redirectUrl: "/casino/aggaphacksawgaming-gold-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
    },
    RubyRush: {
      redirectUrl: "/casino/aggaphacksawgaming-ruby-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RubyRush.webp",
      alt: "Ruby Rush",
      name: "Ruby Rush",
    },
    DiamondRush: {
      redirectUrl: "/casino/aggaphacksawgaming-diamond-rush",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DiamondRush.webp",
      alt: "Diamond Rush",
      name: "Diamond Rush",
    },
    // LuckyShot: {
    //   redirectUrl: "/casino/aggaphacksawgaming-lucky-shot",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/hacksaw/LuckyShot.webp",
    //   alt: "Lucky Shot",
    //   name: "Lucky Shot",
    // },
    CashVaultI: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-vault-i",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashVaultI.webp",
      alt: "Cash Vault I",
      name: "Cash Vault I",
    },
    CashVaultII: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-vault-ii",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashVaultII.webp",
      alt: "Cash Vault II",
      name: "Cash Vault II",
    },
    CrazyDonuts: {
      redirectUrl: "/casino/aggaphacksawgaming-crazy-donuts",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CrazyDonuts.webp",
      alt: "Crazy Donuts",
      name: "Crazy Donuts",
    },
    LuckyNumbersX8: {
      redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x8",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LuckyNumbersX8.webp",
      alt: "Lucky Numbers x8",
      name: "Lucky Numbers x8",
    },
    LuckyNumbersX12: {
      redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x12",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LuckyNumbersX12.webp",
      alt: "Lucky Numbers x12",
      name: "Lucky Numbers x12",
    },
    LuckyNumbersX16: {
      redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x16",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LuckyNumbersX16.webp",
      alt: "Lucky Numbers x16",
      name: "Lucky Numbers x16",
    },
    LuckyNumbersX20: {
      redirectUrl: "/casino/aggaphacksawgaming-lucky-numbers-x20",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LuckyNumbersx20.webp",
      alt: "Lucky Numbers x20",
      name: "Lucky Numbers x20",
    },
    ItsBananas: {
      redirectUrl: "/casino/aggaphacksawgaming-its-bananas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Itsbananas.webp",
      alt: "It's bananas",
      name: "It's bananas",
    },
    DoubleSalary1Year: {
      redirectUrl: "/casino/qt-double-salary-1-year",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DoubleSalary1Year.webp",
      alt: "Double Salary - 1 Year",
      name: "Double Salary - 1 Year",
    },
    ShaveTheBeard: {
      redirectUrl: "/casino/aggaphacksawgaming-shave-the-beard",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ShaveTheBeard.webp",
      alt: "Shave the Beard",
      name: "Shave the Beard",
    },
    CutTheGrass: {
      redirectUrl: "/casino/aggaphacksawgaming-cut-the-grass",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CutTheGrass.webp",
      alt: "Cut the Grass",
      name: "Cut the Grass",
    },
    Scratchem: {
      redirectUrl: "/casino/qt-scratchem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Scratchem.webp",
      alt: "Scratch’em",
      name: "Scratch’em",
    },
    KoiCash: {
      redirectUrl: "/casino/aggaphacksawgaming-koi-cash",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/KoiCash.webp",
      alt: "Koi Cash",
      name: "Koi Cash",
    },
    BreakTheIce: {
      redirectUrl: "/casino/aggaphacksawgaming-break-the-ice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BreakTheIce.webp",
      alt: "Break the Ice",
      name: "Break the Ice",
    },
    GoldCoins: {
      redirectUrl: "/casino/aggaphacksawgaming-gold-coins",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GoldCoins.webp",
      alt: "Gold Coins",
      name: "Gold Coins",
    },
    FrogsScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-frogs-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FrogsScratch.webp",
      alt: "Frogs Scratch",
      name: "Frogs Scratch",
    },
    ShaveTheSheep: {
      redirectUrl: "/casino/aggaphacksawgaming-shave-the-sheep",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ShaveTheSheep.webp",
      alt: "Shave the Sheep",
      name: "Shave the Sheep",
    },
    SpookyScaryScratchy: {
      redirectUrl: "/casino/aggaphacksawgaming-spooky-scary-scratchy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SpookyScaryScratchy.webp",
      alt: "Spooky Scary Scratchy",
      name: "Spooky Scary Scratchy",
    },
    ThePerfectScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-the-perfect-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ThePerfectScratch.webp",
      alt: "The perfect Scratch",
      name: "The perfect Scratch",
    },
    TigerScratch: {
      redirectUrl: "/casino/aggaphacksawgaming-tiger-scratch",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TigerScratch.webp",
      alt: "Tiger Scratch",
      name: "Tiger Scratch",
    },
    RatRiches: {
      redirectUrl: "/casino/aggaphacksawgaming-rat-riches",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RatRiches.webp",
      alt: "Rat Riches",
      name: "Rat Riches",
    },
    GoPanda: {
      redirectUrl: "/casino/aggaphacksawgaming-go-panda",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GoPanda.webp",
      alt: "Go Panda",
      name: "Go Panda",
    },
    Wild2Die2: {
      redirectUrl: "/casino/aggaphacksawgaming-2-wild-2-die",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/2Wild2Die.webp",
      alt: "2 Wild 2 Die",
      name: "2 Wild 2 Die",
    },
    Coins: {
      redirectUrl: "/casino/qt-coins",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Coins.webp",
      alt: "Coins",
      name: "Coins",
    },
    Colors: {
      redirectUrl: "/casino/aggaphacksawgaming-colors",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Colors.webp",
      alt: "Colors",
      name: "Colors",
    },
    Blocks: {
      redirectUrl: "/casino/aggaphacksawgaming-blocks",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Blocks.webp",
      alt: "Blocks",
      name: "Blocks",
    },
    Boxes: {
      redirectUrl: "/casino/qt-boxes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Boxes.webp",
      alt: "Boxes",
      name: "Boxes",
    },
    HiLo: {
      redirectUrl: "/casino/aggaphacksawgaming-hi-lo",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/HiLo.webp",
      alt: "Hi-Lo",
      name: "Hi-Lo",
    },
    Lines: {
      redirectUrl: "/casino/aggaphacksawgaming-lines",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Lines.webp",
      alt: "Lines",
      name: "Lines",
    },
    Plinko: {
      redirectUrl: "/casino/qt-plinko",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Plinko.webp",
      alt: "Plinko",
      name: "Plinko",
    },
    TwentyOne: {
      redirectUrl: "/casino/aggaphacksawgaming-twenty-one",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TwentyOne.webp",
      alt: "Twenty-One",
      name: "Twenty-One",
    },
    Wheel: {
      redirectUrl: "/casino/aggaphacksawgaming-wheel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Wheel.webp",
      alt: "Wheel",
      name: "Wheel",
    },
    XmasDrop: {
      redirectUrl: "/casino/aggaphacksawgaming-xmas-drop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/XmasDrop.webp",
      alt: "Xmas Drop",
      name: "Xmas Drop",
    },
    DarkSummoning: {
      redirectUrl: "/casino/aggaphacksawgaming-dark-summoning",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DarkSummoning.webp",
      alt: "Dark Summoning",
      name: "Dark Summoning",
    },
    ImmortalDesire: {
      redirectUrl: "/casino/aggaphacksawgaming-immortal-desire",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ImmortalDesire.webp",
      alt: "Immortal Desire",
      name: "Immortal Desire",
    },
    EyeOfThePanda: {
      redirectUrl: "/casino/aggaphacksawgaming-eye-of-the-panda",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/EyeOfThePanda.webp",
      alt: "Eye of the Panda",
      name: "Eye of the Panda",
    },
    BennyTheBeer: {
      redirectUrl: "/casino/aggaphacksawgaming-benny-the-beer",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BennyTheBeer.webp",
      alt: "Benny the Beer",
      name: "Benny the Beer",
    },
    Densho: {
      redirectUrl: "/casino/aggaphacksawgaming-densho",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Densho.webp",
      alt: "Densho",
      name: "Densho",
    },
    LeBandit: {
      redirectUrl: "/casino/aggaphacksawgaming-le-bandit",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LeBandit.webp",
      alt: "Le Bandit",
      name: "Le Bandit",
    },
    RoninStackways: {
      redirectUrl: "/casino/aggaphacksawgaming-ronin-stackways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RoninStackways.webp",
      alt: "Ronin Stackways",
      name: "Ronin Stackways",
    },
    Dropem: {
      redirectUrl: "/casino/aggaphacksawgaming-dropem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Dropem.webp",
      alt: "Drop'EM",
      name: "Drop'EM",
    },
    VendingMachine: {
      redirectUrl: "/casino/aggaphacksawgaming-vending-machine",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/VendingMachine.webp",
      alt: "Vending Machine",
      name: "Vending Machine",
    },
    BeastBelow: {
      redirectUrl: "/casino/aggaphacksawgaming-beast-below",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BeastBelow.webp",
      alt: "Beast Below",
      name: "Beast Below",
    },
    MightyMasks: {
      redirectUrl: "/casino/aggaphacksawgaming-mighty-masks",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MightyMasks.webp",
      alt: "Mighty Masks",
      name: "Mighty Masks",
    },
    AlphaEagle: {
      redirectUrl: "/casino/aggaphacksawgaming-alpha-eagle",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/AlphaEagle.webp",
      alt: "Alpha Eagle",
      name: "Alpha Eagle",
    },
    AztecTwist: {
      redirectUrl: "/casino/aggaphacksawgaming-aztec-twist",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/AztecTwist.webp",
      alt: "Aztec Twist",
      name: "Aztec Twist",
    },
    Bloodthirst: {
      redirectUrl: "/casino/aggaphacksawgaming-bloodthirst",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Bloodthirst.webp",
      alt: "Bloodthirst",
      name: "Bloodthirst",
    },
    BookOfTime: {
      redirectUrl: "/casino/aggaphacksawgaming-book-of-time",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BookOfTime.webp",
      alt: "Book of Time",
      name: "Book of Time",
    },
    BornWild: {
      redirectUrl: "/casino/aggaphacksawgaming-born-wild",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BornWild.webp",
      alt: "Born Wild",
      name: "Born Wild",
    },
    BreakBones: {
      redirectUrl: "/casino/aggaphacksawgaming-break-bones",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BreakBones.webp",
      alt: "Break Bones",
      name: "Break Bones",
    },
    BuffaloStackNSync: {
      redirectUrl: "/casino/aggaphacksawgaming-buffalo-stacknsync",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BuffaloStackNSync.webp",
      alt: "Buffalo Stack'n'Sync",
      name: "Buffalo Stack'n'Sync",
    },
    Cubes: {
      redirectUrl: "/casino/aggaphacksawgaming-cubes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Cubes.webp",
      alt: "Cubes",
      name: "Cubes",
    },
    Cubes2: {
      redirectUrl: "/casino/aggaphacksawgaming-cubes-2",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Cubes2.webp",
      alt: "Cubes 2",
      name: "Cubes 2",
    },
    CursedSeas: {
      redirectUrl: "/casino/aggaphacksawgaming-cursed-seas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CursedSeas.webp",
      alt: "Cursed Seas",
      name: "Cursed Seas",
    },
    CashCompass: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-compass",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashCompass.webp",
      alt: "Cash Compass",
      name: "Cash Compass",
    },
    CashQuest: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-quest",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashQuest.webp",
      alt: "Cash Quest",
      name: "Cash Quest",
    },

    DorkUnit: {
      redirectUrl: "/casino/aggaphacksawgaming-dork-unit",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DorkUnit.webp",
      alt: "Dork Unit",
      name: "Dork Unit",
    },
    DoubleRainbow: {
      redirectUrl: "/casino/aggaphacksawgaming-double-rainbow",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DoubleRainbow.webp",
      alt: "Double Rainbow",
      name: "Double Rainbow",
    },
    FearTheDark: {
      redirectUrl: "/casino/aggaphacksawgaming-fear-the-dark",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FearTheDark.webp",
      alt: "Fear the Dark",
      name: "Fear the Dark",
    },
    ForestFortune: {
      redirectUrl: "/casino/aggaphacksawgaming-forest-fortune",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ForestFortune.webp",
      alt: "Forest Fortune",
      name: "Forest Fortune",
    },
    FranksFarm: {
      redirectUrl: "/casino/aggaphacksawgaming-franks-farm",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FranksFarm.webp",
      alt: "Frank's Farm",
      name: "Frank's Farm",
    },
    FruitDuel: {
      redirectUrl: "/casino/aggaphacksawgaming-fruit-duel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FruitDuel.webp",
      alt: "Fruit Duel",
      name: "Fruit Duel",
    },
    Frutz: {
      redirectUrl: "/casino/aggaphacksawgaming-frutz",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Frutz.webp",
      alt: "Frutz",
      name: "Frutz",
    },
    GladiatorLegends: {
      redirectUrl: "/casino/aggaphacksawgaming-gladiator-legends",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GladiatorLegends.webp",
      alt: "Gladiator Legends",
      name: "Gladiator Legends",
    },
    GronksGems: {
      redirectUrl: "/casino/aggaphacksawgaming-gronks-gems",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GronksGems.webp",
      alt: "Gronk's Gems",
      name: "Gronk's Gems",
    },
    HandOfAnubis: {
      redirectUrl: "/casino/aggaphacksawgaming-hand-of-anubis",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/HandOfAnubis.webp",
      alt: "Hand Of Anubis",
      name: "Hand Of Anubis",
    },
    HarvestWilds: {
      redirectUrl: "/casino/aggaphacksawgaming-harvest-wilds",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/HarvestWilds.webp",
      alt: "Harvest Wilds",
      name: "Harvest Wilds",
    },
    HopNpop: {
      redirectUrl: "/casino/aggaphacksawgaming-hopnpop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/HopNpop.webp",
      alt: "Hop'n'pop",
      name: "Hop'n'pop",
    },
    Itero: {
      redirectUrl: "/casino/aggaphacksawgaming-itero",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Itero.webp",
      alt: "Itero",
      name: "Itero",
    },
    JokerBombs: {
      redirectUrl: "/casino/aggaphacksawgaming-joker-bombs",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/JokerBombs.webp",
      alt: "Joker Bombs",
      name: "Joker Bombs",
    },
    KeepemCool: {
      redirectUrl: "/casino/aggaphacksawgaming-keepem-cool",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/KeepemCool.webp",
      alt: "Keep'em Cool",
      name: "Keep'em Cool",
    },
    KingCarrot: {
      redirectUrl: "/casino/aggaphacksawgaming-king-carrot",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/KingCarrot.webp",
      alt: "King Carrot",
      name: "King Carrot",
    },
    LetItSnow: {
      redirectUrl: "/casino/aggaphacksawgaming-let-it-snow",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LetItSnow.webp",
      alt: "Let it Snow",
      name: "Let it Snow",
    },
    MagicPiggy: {
      redirectUrl: "/casino/aggaphacksawgaming-magic-piggy",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MagicPiggy.webp",
      alt: "Magic Piggy",
      name: "Magic Piggy",
    },
    MayanStackways: {
      redirectUrl: "/casino/aggaphacksawgaming-mayan-stackways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MayanStackways.webp",
      alt: "Mayan Stackways",
      name: "Mayan Stackways",
    },
    MiamiMultiplier: {
      redirectUrl: "/casino/qt-miami-multiplier",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MiamiMultiplier.webp",
      alt: "Miami Multiplier",
      name: "Miami Multiplier",
    },
    MysteryMotel: {
      redirectUrl: "/casino/aggaphacksawgaming-mystery-motel",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MysteryMotel.webp",
      alt: "Mystery Motel",
      name: "Mystery Motel",
    },
    OmNom: {
      redirectUrl: "/casino/aggaphacksawgaming-omnom",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/OmNom.webp",
      alt: "OmNom",
      name: "OmNom",
    },
    OutlawsInc: {
      redirectUrl: "/casino/aggaphacksawgaming-outlaws-inc",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/OutlawsInc.webp",
      alt: "Outlaws Inc",
      name: "Outlaws Inc",
    },
    PugLife: {
      redirectUrl: "/casino/aggaphacksawgaming-pug-life",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/PugLife.webp",
      alt: "Pug Life",
      name: "Pug Life",
    },
    RIPCity: {
      redirectUrl: "/casino/aggaphacksawgaming-rip-city",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RIPCity.webp",
      alt: "RIP City",
      name: "RIP City",
    },
    RocketReels: {
      redirectUrl: "/casino/aggaphacksawgaming-rocket-reels",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RocketReels.webp",
      alt: "Rocket Reels",
      name: "Rocket Reels",
    },
    Rotten: {
      redirectUrl: "/casino/aggaphacksawgaming-rotten",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Rotten.webp",
      alt: "Rotten",
      name: "Rotten",
    },
    Stickem: {
      redirectUrl: "/casino/qt-stick-em",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Stickem.webp",
      alt: "Stick ‘em",
      name: "Stick ‘em",
    },
    Stormforged: {
      redirectUrl: "/casino/aggaphacksawgaming-stormforged",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Stormforged.webp",
      alt: "Stormforged",
      name: "Stormforged",
    },
    TastyTreats: {
      redirectUrl: "/casino/aggaphacksawgaming-tasty-treats",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TastyTreats.webp",
      alt: "Tasty Treats",
      name: "Tasty Treats",
    },
    TempleOfTorment: {
      redirectUrl: "/casino/aggaphacksawgaming-temple-of-torment",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TempleOfTorment.webp",
      alt: "Temple of Torment",
      name: "Temple of Torment",
    },
    TheBoweryBoys: {
      redirectUrl: "/casino/aggaphacksawgaming-the-bowery-boys",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TheBoweryBoys.webp",
      alt: "The Bowery Boys",
      name: "The Bowery Boys",
    },
    TheRespinners: {
      redirectUrl: "/casino/aggaphacksawgaming-the-respinners",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TheRespinners.webp",
      alt: "The Respinners",
      name: "The Respinners",
    },
    TimeSpinners: {
      redirectUrl: "/casino/aggaphacksawgaming-time-spinners",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TimeSpinners.webp",
      alt: "Time Spinners",
      name: "Time Spinners",
    },
    ToshiVideoClub: {
      redirectUrl: "/casino/aggaphacksawgaming-toshi-video-club",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ToshiVideoClub.webp",
      alt: "Toshi Video Club",
      name: "Toshi Video Club",
    },
    UndeadFortune: {
      redirectUrl: "/casino/aggaphacksawgaming-undead-fortune",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/UndeadFortune.webp",
      alt: "Undead Fortune",
      name: "Undead Fortune",
    },
    WarriorWays: {
      redirectUrl: "/casino/aggaphacksawgaming-warrior-ways",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/WarriorWays.webp",
      alt: "Warrior Ways",
      name: "Warrior Ways",
    },
    Xpander: {
      redirectUrl: "/casino/aggaphacksawgaming-xpander",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Xpander.webp",
      alt: "Xpander",
      name: "Xpander",
    },
    FeelTheBeat: {
      redirectUrl: "/casino/aggaphacksawgaming-feel-the-beat",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FeelTheBeat.webp",
      alt: "Feel the Beat",
      name: "Feel the Beat",
    },
    BeamBoys: {
      redirectUrl: "/casino/aggaphacksawgaming-beam-boys",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BeamBoys.webp",
      alt: "Beam Boys",
      name: "Beam Boys",
    },
    Baccarat: {
      redirectUrl: "/casino/aggaphacksawgaming-baccarat",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    FistOfDestruction: {
      redirectUrl: "/casino/aggaphacksawgaming-fist-of-destruction",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FistOfDestruction.webp",
      alt: "Fist of Destruction",
      name: "Fist of Destruction",
    },
    DawnOfKings: {
      redirectUrl: "/casino/aggaphacksawgaming-dawn-of-kings",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DawnOfKings.webp",
      alt: "Dawn of Kings",
      name: "Dawn of Kings",
    },
    BouncyBombs: {
      redirectUrl: "/casino/aggaphacksawgaming-bouncy-bombs",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/BouncyBombs.webp",
      alt: "Bouncy Bombs",
      name: "Bouncy Bombs",
    },
    RustyAndCurly: {
      redirectUrl: "/casino/aggaphacksawgaming-rusty-and-curly",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RustyAndCurly.webp",
      alt: "Rusty and Curly",
      name: "Rusty and Curly",
    },
    // ScratchAMillion: {
    //   redirectUrl: "/casino/qtechhacksawgaming-scratch-a-million-u8239",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/hacksaw/ScratchAMillion.webp",
    //   alt: "Scratch a Million",
    //   name: "Scratch a Million",
    // },
    // InstaCubes: {
    //   redirectUrl: "/casino/qtechhacksawgaming-insta-cubes-u4725",
    //   code: "",
    //   casino: "Slots",
    //   provider: "Hacksaw",
    //   category: "hacksaw",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/hacksaw/InstaCubes.webp",
    //   alt: "Insta Cubes",
    //   name: "Insta Cubes",
    // },
    LePharaoh: {
      redirectUrl: "/casino/aggaphacksawgaming-le-pharaoh",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LePharaoh.webp",
      alt: "Le Pharaoh",
      name: "Le Pharaoh",
    },
    OctoAttack: {
      redirectUrl: "/casino/aggaphacksawgaming-octo-attack",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/OctoAttack.webp",
      alt: "Octo Attack",
      name: "Octo Attack",
    },
    EvilEyes: {
      redirectUrl: "/casino/aggaphacksawgaming-evil-eyes",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/EvilEyes.webp",
      alt: "Evil Eyes",
      name: "Evil Eyes",
    },
    SpeedCrash: {
      redirectUrl: "/casino/aggaphacksawgaming-speed-crash",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SpeedCrash.webp",
      alt: "Speed Crash",
      name: "Speed Crash",
    },
    Limbo: {
      redirectUrl: "/casino/aggaphacksawgaming-limbo",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
    DonnyDough: {
      redirectUrl: "/casino/aggaphacksawgaming-donny-dough",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DonnyDough.webp",
      alt: "Donny Dough",
      name: "Donny Dough",
    },
    DragonsDomain: {
      redirectUrl: "/casino/aggaphacksawgaming-dragons-domain",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DragonsDomain.webp",
      alt: "Dragon's Domain",
      name: "Dragon's Domain",
    },
    SixSixSix: {
      redirectUrl: "/casino/aggaphacksawgaming-sixsixsix",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SixSixSix.webp",
      alt: "SixSixSix",
      name: "SixSixSix",
    },
    Dice: {
      redirectUrl: "/casino/aggaphacksawgaming-dice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Dice.webp",
      alt: "Dice",
      name: "Dice",
    },
    TaiTheToad: {
      redirectUrl: "/casino/aggaphacksawgaming-tai-the-toad",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TaiTheToad.webp",
      alt: "Tai the Toad",
      name: "Tai the Toad",
    },
    TwistedLab: {
      redirectUrl: "/casino/aggaphacksawgaming-twisted-lab",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/TwistedLabs.webp",
      alt: "Twisted Lab",
      name: "Twisted Lab",
    },
    ZeZeus: {
      redirectUrl: "/casino/aggaphacksawgaming-ze-zeus",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ZeZeus.webp",
      alt: "Ze Zeus",
      name: "Ze Zeus",
    },
    CursedCrypt: {
      redirectUrl: "/casino/aggaphacksawgaming-cursed-crypt",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CursedCrypt.webp",
      alt: "Cursed Crypt",
      name: "Cursed Crypt",
    },
    SlayersInc: {
      redirectUrl: "/casino/aggaphacksawgaming-slayers-inc",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SlayersInc.webp",
      alt: "Slayers Inc",
      name: "Slayers Inc",
    },
    JellySlice: {
      redirectUrl: "/casino/aggaphacksawgaming-jelly-slice",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/JellySlice.webp",
      alt: "Jelly Slice",
      name: "Jelly Slice",
    },
    KeepEm: {
      redirectUrl: "/casino/aggaphacksawgaming-keepem",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/KeepEm.webp",
      alt: "Keep'Em",
      name: "Keep'Em",
    },
    DivineDrop: {
      redirectUrl: "/casino/aggaphacksawgaming-divine-drop",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DivineDrop.webp",
      alt: "Divine Drop",
      name: "Divine Drop",
    },
    OrbOfDestiny: {
      redirectUrl: "/casino/aggaphacksawgaming-orb-of-destiny",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/OrbOfDestiny.webp",
      alt: "Orb of Destiny",
      name: "Orb of Destiny",
    },
    CashCrew: {
      redirectUrl: "/casino/aggaphacksawgaming-cash-crew",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CashCrew.webp",
      alt: "Cash Crew",
      name: "Cash Crew",
    },
    CloudPrincess: {
      redirectUrl: "/casino/aggaphacksawgaming-cloud-princess",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/CloudPrincess.webp",
      alt: "Cloud Princess",
      name: "Cloud Princess",
    },
    GetTheCheese: {
      redirectUrl: "/casino/aggaphacksawgaming-get-the-cheese",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/GetTheCheese.webp",
      alt: "Get The Cheese",
      name: "Get The Cheese",
    },
    RiseOfYmir: {
      redirectUrl: "/casino/aggaphacksawgaming-rise-of-ymir",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/RiseOfYmir.webp",
      alt: "Rise of Ymir",
      name: "Rise of Ymir",
    },
    WingsOfHorus: {
      redirectUrl: "/casino/aggaphacksawgaming-wings-of-horus",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/WingsOfHorus.webp",
      alt: "Wings of Horus",
      name: "Wings of Horus",
    },
    DuelAtDawn: {
      redirectUrl: "/casino/aggaphacksawgaming-duel-at-dawn",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DuelAtDawn.webp",
      alt: "Duel at Dawn",
      name: "Duel at Dawn",
    },
    SnowSlingers: {
      redirectUrl: "/casino/aggaphacksawgaming-snow-slingers",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/SnowSlingers.webp",
      alt: "Snow Slingers",
      name: "Snow Slingers",
    },
    ShaolinMaster: {
      redirectUrl: "/casino/aggaphacksawgaming-shaolin-master",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/ShaolinMaster.webp",
      alt: "Shaolin Master",
      name: "Shaolin Master",
    },
    DonutDivision: {
      redirectUrl: "/casino/aggaphacksawgaming-donut-division",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/DonutDivision.webp",
      alt: "Donut Division",
      name: "Donut Division",
    },
    FireMyLaser: {
      redirectUrl: "/casino/aggaphacksawgaming-fire-my-laser",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FireMyLaser.webp",
      alt: "Fire My Laser",
      name: "Fire My Laser",
    },
    Klowns: {
      redirectUrl: "/casino/aggaphacksawgaming-klowns",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Klowns.webp",
      alt: "Klowns",
      name: "Klowns",
    },
    LeViking: {
      redirectUrl: "/casino/aggaphacksawgaming-le-viking",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/LeViking.webp",
      alt: "Le Viking",
      name: "Le Viking",
    },
    PhoenixDuelReels: {
      redirectUrl: "/casino/aggaphacksawgaming-phoenix-duelreels",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/PhoenixDuelReels.webp",
      alt: "Phoenix DuelReels",
      name: "Phoenix DuelReels",
    },
    MarlinMasters: {
      redirectUrl: "/casino/aggaphacksawgaming-marlin-masters",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/MarlinMasters.webp",
      alt: "Marlin Masters",
      name: "Marlin Masters",
    },
    FRKNBananas: {
      redirectUrl: "/casino/aggaphacksawgaming-frkn-bananas",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/FRKNBananas.webp",
      alt: "FRKN Bananas",
      name: "FRKN Bananas",
    },
    HoundsOfHell: {
      redirectUrl: "/casino/aggaphacksawgaming-hounds-of-hell",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "hacksaw",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/HoundsOfHell.webp",
      alt: "Hounds of Hell",
      name: "Hounds of Hell",
    },
    MinesHS: {
      redirectUrl: "/casino/aggaphacksawgaming-mines-dare2win",
      code: "",
      casino: "Slots",
      provider: "Hacksaw",
      category: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/hacksaw/Mines.webp",
      alt: "Mines",
      name: "Mines",
    },
  },

  playngo: {
    BookOfDead: {
      redirectUrl: "/casino/aggapplayngo-book-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BookofDead.webp",
      alt: "book of dead",
      name: "Book of Dead",
    },
    LegacyOfDead: {
      redirectUrl: "/casino/aggapplayngo-legacy-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegacyOfDead.webp",
      alt: "Legacy of Dead",
      name: "Legacy of Dead",
    },
    Reactoonz: {
      redirectUrl: "/casino/aggapplayngo-reactoonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Reactoonz.webp",
      alt: "Reactoonz",
      name: "Reactoonz",
    },
    SuperWheel: {
      redirectUrl: "/casino/aggapplayngo-super-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SuperWheel.webp",
      alt: "super wheel",
      name: "Super Wheel",
    },
    MoneyWheel: {
      redirectUrl: "/casino/aggapplayngo-money-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoneyWheel.webp",
      alt: "money wheel",
      name: "Money Wheel",
    },
    RainforestMagicBingo: {
      redirectUrl: "/casino/aggapplayngo-rainforest-magic-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RainforestMagicBingo.webp",
      alt: "rainforest magic bingo",
      name: "Rainforest Magic Bingo",
    },
    SweetAlchemyBingo: {
      redirectUrl: "/casino/aggapplayngo-sweet-alchemy-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SweetAlchemyBingo.webp",
      alt: "sweet alchemy bingo",
      name: "Sweet Alchemy Bingo",
    },
    VikingRunecraftBingo: {
      redirectUrl: "/casino/aggapplayngo-viking-runecraft-bingo",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/VikingRunecraftBingo.webp",
      alt: "viking runecraft bingo",
      name: "Viking Runecraft Bingo",
    },
    Clown3MontyII: {
      redirectUrl: "/casino/aggapplayngo-3-clown-monty-ii",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/3ClownMontyII.webp",
      alt: "3 clown monty ii",
      name: "3 Clown Monty II",
    },
    PandasticAdventure: {
      redirectUrl: "/casino/aggapplayngo-pandastic-adventure",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PandasticAdventure.webp",
      alt: "pandastic adventure",
      name: "Pandastic Adventure",
    },
    TalesOfMithruneSynsFortune: {
      redirectUrl: "/casino/aggapplayngo-tales-of-mithrune-syns-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TalesofMithruneSynsFortune.webp",
      alt: "tales of mithrune syn's fortune",
      name: "Tales of Mithrune Syn's Fortune",
    },
    VikingRunecraft100: {
      redirectUrl: "/casino/aggapplayngo-viking-runecraft-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/VikingRunecraft100.webp",
      alt: "viking runecraft 100",
      name: "Viking Runecraft 100",
    },
    Gargantoonz: {
      redirectUrl: "/casino/aggapplayngo-gargantoonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Gargantoonz.webp",
      alt: "gargantoonz",
      name: "Gargantoonz",
    },
    MegaDonFeedingFrenzy: {
      redirectUrl: "/casino/aggapplayngo-mega-don-feeding-frenzy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MegaDonFeedingFrenzy.webp",
      alt: "mega don feeding frenzy",
      name: "Mega Don: Feeding Frenzy",
    },
    InvadingVegasLasChristmas: {
      redirectUrl: "/casino/aggapplayngo-invading-vegas-las-christmas",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/InvadingVegasLasChristmas.webp",
      alt: "invading vegas las christmas",
      name: "Invading Vegas: Las Christmas",
    },
    LegacyOfDynasties: {
      redirectUrl: "/casino/aggapplayngo-legacy-of-dynasties",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegacyofDynasties.webp",
      alt: "legacy of dynasties",
      name: "Legacy of Dynasties",
    },
    MonkeyBattlefortheScrolls: {
      redirectUrl: "/casino/aggapplayngo-monkey-battle-for-the-scrolls",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MonkeyBattlefortheScrolls.webp",
      alt: "monkey battle for the scrolls",
      name: "Monkey: Battle for the Scrolls",
    },
    SherwoodGold: {
      redirectUrl: "/casino/aggapplayngo-sherwood-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SherwoodGold.webp",
      alt: "sherwood gold",
      name: "Sherwood Gold",
    },
    RagingRex3: {
      redirectUrl: "/casino/aggapplayngo-raging-rex-3",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RagingRex3.webp",
      alt: "raging rex 3",
      name: "Raging Rex 3",
    },
    RuffHeist: {
      redirectUrl: "/casino/aggapplayngo-ruff-heist",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RuffHeist.webp",
      alt: "ruff heist",
      name: "Ruff Heist",
    },
    PiggyBlitz: {
      redirectUrl: "/casino/aggapplayngo-piggy-blitz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PiggyBlitz.webp",
      alt: "piggy blitz",
      name: "Piggy Blitz",
    },
    ReturnoftheGreenKnight: {
      redirectUrl: "/casino/aggapplayngo-return-of-the-green-knight",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ReturnoftheGreenKnight.webp",
      alt: "return of the green knight",
      name: "Return of the Green Knight",
    },
    TempleOfProsperity: {
      redirectUrl: "/casino/aggapplayngo-temple-of-prosperity",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TempleofProsperity.webp",
      alt: "temple of prosperity",
      name: "Temple of Prosperity",
    },
    ScalesOfDead: {
      redirectUrl: "/casino/aggapplayngo-scales-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ScalesofDead.webp",
      alt: "scales of dead",
      name: "Scales of Dead",
    },
    BoatBonanzaColossalCatch: {
      redirectUrl: "/casino/aggapplayngo-boat-bonanza-colossal-catch",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BoatBonanzaColossalCatch.webp",
      alt: "boat bonanza colossal catch",
      name: "Boat Bonanza Colossal Catch",
    },
    HoneyRush100: {
      redirectUrl: "/casino/aggapplayngo-honey-rush-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HoneyRush100.webp",
      alt: "honey rush 100",
      name: "Honey Rush 100",
    },
    HugoLegacy: {
      redirectUrl: "/casino/aggapplayngo-hugo-legacy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HugoLegacy.webp",
      alt: "hugo legacy",
      name: "Hugo Legacy",
    },
    SweetAlchemy100: {
      redirectUrl: "/casino/aggapplayngo-sweet-alchemy-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SweetAlchemy100.webp",
      alt: "sweet alchemy 100",
      name: "Sweet Alchemy 100",
    },
    ScrollOfSeth: {
      redirectUrl: "/casino/aggapplayngo-scroll-of-seth",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ScrollofSeth.webp",
      alt: "scroll of seth",
      name: "Scroll of Seth",
    },
    MerlinJourneyOfFlame: {
      redirectUrl: "/casino/aggapplayngo-merlin-journey-of-flame",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MerlinJourneyofFlame.webp",
      alt: "merlin journey of flame",
      name: "Merlin: Journey of Flame",
    },
    SparkyAndShortsHiddenJoules: {
      redirectUrl: "/casino/aggapplayngo-sparky-and-shorts-hidden-joules",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SparkyAndShortzHiddenJoules.webp",
      alt: "sparky & shorts hidden joules",
      name: "Sparky & Shorts Hidden Joules",
    },
    FoxMayhem: {
      redirectUrl: "/casino/aggapplayngo-fox-mayhem",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FoxMayhem.webp",
      alt: "fox mayhem",
      name: "Fox Mayhem",
    },
    RichWildeAndTheAmuletOfDead: {
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-amulet-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichWildeandtheAmuletofDead.webp",
      alt: "rich wilde and the amulet of dead",
      name: "Rich Wilde and the Amulet of Dead",
    },
    SweetAlchemy2: {
      redirectUrl: "/casino/aggapplayngo-sweet-alchemy-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SweetAlchemy2.webp",
      alt: "sweet alchemy 2",
      name: "Sweet Alchemy 2",
    },
    RascalRiches: {
      redirectUrl: "/casino/aggapplayngo-rascal-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RascalRiches.webp",
      alt: "rascal riches",
      name: "Rascal Riches",
    },
    Ternion: {
      redirectUrl: "/casino/aggapplayngo-ternion",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Ternion.webp",
      alt: "ternion",
      name: "Ternion",
    },
    VikingRunecraftApocalypse: {
      redirectUrl: "/casino/aggapplayngo-viking-runecraft-apocalypse",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/VikingRunecraftApocalypse.webp",
      alt: "viking runecraft apocalypse",
      name: "Viking Runecraft: Apocalypse",
    },
    Crystal15RosesATaleOfLove: {
      redirectUrl: "/casino/aggapplayngo-15-crystal-roses-a-tale-of-love",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/15CrystalRosesATaleOfLove.webp",
      alt: "15 crystal roses a tale of love",
      name: "15 Crystal Roses A Tale Of Love",
    },
    Dragon24k: {
      redirectUrl: "/casino/aggapplayngo-24k-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/24kDragon.webp",
      alt: "24k dragon",
      name: "24k Dragon",
    },
    Clown3Monty: {
      redirectUrl: "/casino/aggapplayngo-3-clown-monty",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/3ClownMonty.webp",
      alt: "3 clown monty",
      name: "3 Clown Monty",
    },
    Magic5x: {
      redirectUrl: "/casino/aggapplayngo-5x-magic",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/5xMagic.webp",
      alt: "5x magic",
      name: "5x Magic",
    },
    Sins7: {
      redirectUrl: "/casino/aggapplayngo-7-sins",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/7Sins.webp",
      alt: "7 sins",
      name: "7 Sins",
    },
    AceOfSpades: {
      redirectUrl: "/casino/aggapplayngo-ace-of-spades",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AceofSpades.webp",
      alt: "ace of spades",
      name: "Ace of Spades",
    },
    AgentDestiny: {
      redirectUrl: "/casino/aggapplayngo-agent-destiny",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AgentDestiny.webp",
      alt: "agent destiny",
      name: "Agent Destiny",
    },
    AgentOfHearts: {
      redirectUrl: "/casino/aggapplayngo-agent-of-hearts",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AgentofHearts.webp",
      alt: "agent of hearts",
      name: "Agent of Hearts",
    },
    AnimalMadness: {
      redirectUrl: "/casino/aggapplayngo-animal-madness",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AnimalMadness.webp",
      alt: "animal madness",
      name: "Animal Madness",
    },
    AnkhOfAnubis: {
      redirectUrl: "/casino/aggapplayngo-ankh-of-anubis",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AnkhofAnubis.webp",
      alt: "ankh of anubis",
      name: "Ankh of Anubis",
    },
    Annihilator: {
      redirectUrl: "/casino/aggapplayngo-annihilator",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Annihilator.webp",
      alt: "annihilator",
      name: "Annihilator",
    },
    AthenaAscending: {
      redirectUrl: "/casino/aggapplayngo-athena-ascending",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AthenaAscending.webp",
      alt: "athena ascending",
      name: "Athena Ascending",
    },
    AztecIdols: {
      redirectUrl: "/casino/aggapplayngo-aztec-idols",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AztecIdols.webp",
      alt: "aztec idols",
      name: "Aztec Idols",
    },
    AztecWarriorPrincess: {
      redirectUrl: "/casino/aggapplayngo-aztec-warrior-princess",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AztecWarriorPrincess.webp",
      alt: "aztec warrior princess",
      name: "Aztec Warrior Princess",
    },
    BakersTreat: {
      redirectUrl: "/casino/aggapplayngo-bakers-treat",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BakersTreat.webp",
      alt: "bakers treat",
      name: "Baker's Treat",
    },
    BananaRock: {
      redirectUrl: "/casino/aggapplayngo-banana-rock",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BananaRock.webp",
      alt: "banana rock",
      name: "Banana Rock",
    },
    BattleRoyal: {
      redirectUrl: "/casino/aggapplayngo-battle-royal",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BattleRoyal.webp",
      alt: "battle royal",
      name: "Battle Royal",
    },
    BeastsOfFire: {
      redirectUrl: "/casino/aggapplayngo-beasts-of-fire",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BeastsOfFire.webp",
      alt: "beasts of fire",
      name: "Beasts Of Fire",
    },
    BigWin777: {
      redirectUrl: "/casino/aggapplayngo-big-win-777",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BigWin777.webp",
      alt: "big win 777",
      name: "Big Win 777",
    },
    BigWinCat: {
      redirectUrl: "/casino/aggapplayngo-big-win-cat",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BigWinCat.webp",
      alt: "big win cat",
      name: "Big Win Cat",
    },
    BlackMamba: {
      redirectUrl: "/casino/aggapplayngo-black-mamba",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BlackMamba.webp",
      alt: "black mamba",
      name: "Black Mamba",
    },
    BlazinBullfrog: {
      redirectUrl: "/casino/aggapplayngo-blazin-bullfrog",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BlazinBullfrog.webp",
      alt: "blazin bullfrog",
      name: "Blazin' Bullfrog",
    },
    Blinged: {
      redirectUrl: "/casino/aggapplayngo-blinged",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Blinged.webp",
      alt: "blinged",
      name: "Blinged",
    },
    BoatBonanza: {
      redirectUrl: "/casino/aggapplayngo-boat-bonanza",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BoatBonanza.webp",
      alt: "boat bonanza",
      name: "Boat Bonanza",
    },
    BullInAChinaShop: {
      redirectUrl: "/casino/aggapplayngo-bull-in-a-china-shop",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BullinaChinaShop.webp",
      alt: "bull in a china shop",
      name: "Bull in a China Shop",
    },
    BullInARodeo: {
      redirectUrl: "/casino/aggapplayngo-bull-in-a-rodeo",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BullinaRodeo.webp",
      alt: "bull in a rodeo",
      name: "Bull in a Rodeo",
    },
    CandyIslandPrincess: {
      redirectUrl: "/casino/aggapplayngo-candy-island-princess",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CandyIslandPrincess.webp",
      alt: "candy island princess",
      name: "Candy Island Princess",
    },
    CanineCarnage: {
      redirectUrl: "/casino/aggapplayngo-canine-carnage",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CanineCarnage.webp",
      alt: "canine carnage",
      name: "Canine Carnage",
    },
    CaptainGlumPirateHunter: {
      redirectUrl: "/casino/aggapplayngo-captain-glum-pirate-hunter",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CaptainGlumPirateHunter.webp",
      alt: "captain glum pirate hunter",
      name: "Captain Glum: Pirate Hunter",
    },
    CaptainXenosEarthAdventure: {
      redirectUrl: "/casino/aggapplayngo-captain-xenos-earth-adventure",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CaptainXenosEarthAdventure.webp",
      alt: "captain xenos earth adventure",
      name: "Captain Xeno's Earth Adventure",
    },
    CashACabana: {
      redirectUrl: "/casino/aggapplayngo-cash-a-cabana",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CashaCabana.webp",
      alt: "cash a cabana",
      name: "Cash-a-Cabana",
    },
    CashOfCommand: {
      redirectUrl: "/casino/aggapplayngo-cash-of-command",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CashofCommand.webp",
      alt: "cash of command",
      name: "Cash of Command",
    },
    CashPump: {
      redirectUrl: "/casino/aggapplayngo-cash-pump",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CashPump.webp",
      alt: "cash pump",
      name: "Cash Pump",
    },
    CashVandal: {
      redirectUrl: "/casino/aggapplayngo-cash-vandal",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CashVandal.webp",
      alt: "cash vandal",
      name: "Cash Vandal",
    },
    CatWildeAndTheDoomOfDead: {
      redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-doom-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CatWildeandtheDoomofDead.webp",
      alt: "cat wilde and the doom of dead",
      name: "Cat Wilde and the Doom of Dead",
    },
    CatWildeAndTheLostChapter: {
      redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-lost-chapter",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CatWildeandtheLostChapter.webp",
      alt: "cat wilde and the lost chapter",
      name: "Cat Wilde and the Lost Chapter",
    },
    CatWildeAndThePyramidsOfDead: {
      redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-pyramids-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CatWildeandthePyramidsofDead.webp",
      alt: "cat wilde and the pyramids of dead",
      name: "Cat Wilde and the Pyramids of Dead",
    },
    // CatWildeInTheEclipseOfTheSunGod: {
    //   redirectUrl: "/casino/aggapplayngo-cat-wilde-in-the-eclipse-of-the-sun-god",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "/images/slots/new/play-n-go/CatWildeintheEclipseoftheSunGod.webp",
    //   alt: "cat wilde in the eclipse of the sun god",
    //   name: "Cat Wilde in the Eclipse of the Sun God",
    // },
    CatsAndCash: {
      redirectUrl: "/casino/aggapplayngo-cats-and-cash",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CatsandCash.webp",
      alt: "cats and cash",
      name: "Cats and Cash",
    },
    ChampionsOfMithrune: {
      redirectUrl: "/casino/aggapplayngo-champions-of-mithrune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ChampionsofMithrune.webp",
      alt: "champions of mithrune",
      name: "Champions of Mithrune",
    },
    CharlieChance: {
      redirectUrl: "/casino/aggapplayngo-charlie-chance",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CharlieChance.webp",
      alt: "charlie chance",
      name: "Charlie Chance",
    },
    // CharlieChanceAndTheCurseOfCleopatra: {
    //   redirectUrl: "/casino/aggapplayngo-charlie-chance-and-the-curse-of-cleopatra",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "/images/slots/new/play-n-go/CharlieChanceandTheCurseofCleopatra.webp",
    //   alt: "charlie chance and the curse of cleopatra",
    //   name: "Charlie Chance and The Curse of Cleopatra",
    // },
    // CharlieChanceInHellToPay: {
    //   redirectUrl: "/casino/qtechplayngo-charlie-chance-in-hell-to-pay",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/CharlieChanceinHelltoPay.webp",
    //   alt: "charlie chance in hell to pay",
    //   name: "Charlie Chance in Hell to Pay",
    // },
    ChineseNewYear: {
      redirectUrl: "/casino/aggapplayngo-chinese-new-year",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ChineseNewYear.webp",
      alt: "chinese new year",
      name: "Chinese New Year",
    },
    ChronosJoker: {
      redirectUrl: "/casino/aggapplayngo-chronos-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ChronosJoker.webp",
      alt: "chronos joker",
      name: "Chronos Joker",
    },
    ClashOfCamelot: {
      redirectUrl: "/casino/aggapplayngo-clash-of-camelot",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ClashofCamelot.webp",
      alt: "clash of camelot",
      name: "Clash of Camelot",
    },
    CloudQuest: {
      redirectUrl: "/casino/aggapplayngo-cloud-quest",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CloudQuest.webp",
      alt: "cloud quest",
      name: "Cloud Quest",
    },
    CoilsOfCash: {
      redirectUrl: "/casino/aggapplayngo-coils-of-cash",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CoilsofCash.webp",
      alt: "coils of cash",
      name: "Coils of Cash",
    },
    ColtLightning: {
      redirectUrl: "/casino/aggapplayngo-colt-lightning",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ColtLightning.webp",
      alt: "colt lightning",
      name: "Colt Lightning",
    },
    Contact: {
      redirectUrl: "/casino/aggapplayngo-contact",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Contact.webp",
      alt: "contact",
      name: "Contact",
    },
    CopsNRobbers: {
      redirectUrl: "/casino/aggapplayngo-copsnrobbers",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CopsnRobbers.webp",
      alt: "copsnrobbers",
      name: "Cops'n'Robbers",
    },
    CountJokula: {
      redirectUrl: "/casino/aggapplayngo-count-jokula",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CountJokula.webp",
      alt: "count jokula",
      name: "Count Jokula",
    },
    CourtOfHearts: {
      redirectUrl: "/casino/aggapplayngo-court-of-hearts",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CourtofHearts.webp",
      alt: "court of hearts",
      name: "Court of Hearts",
    },
    CoywolfCash: {
      redirectUrl: "/casino/aggapplayngo-coywolf-cash",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CoywolfCash.webp",
      alt: "coywolf cash",
      name: "Coywolf Cash",
    },
    CrazyCows: {
      redirectUrl: "/casino/aggapplayngo-crazy-cows",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CrazyCows.webp",
      alt: "crazy cows",
      name: "Crazy Cows",
    },
    CrystalSun: {
      redirectUrl: "/casino/aggapplayngo-crystal-sun",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CrystalSun.webp",
      alt: "crystal sun",
      name: "Crystal Sun",
    },
    DawnOfEgypt: {
      redirectUrl: "/casino/aggapplayngo-dawn-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DawnofEgypt.webp",
      alt: "dawn of egypt",
      name: "Dawn of Egypt",
    },
    Demon: {
      redirectUrl: "/casino/aggapplayngo-demon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Demon.webp",
      alt: "demon",
      name: "Demon",
    },
    DerbyWheel: {
      redirectUrl: "/casino/aggapplayngo-derby-wheel",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DerbyWheel.webp",
      alt: "derby wheel",
      name: "Derby Wheel",
    },
    DiamondsOfTheRealm: {
      redirectUrl: "/casino/aggapplayngo-diamonds-of-the-realm",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DiamondsoftheRealm.webp",
      alt: "diamonds of the realm",
      name: "Diamonds of the Realm",
    },
    DiamondVortex: {
      redirectUrl: "/casino/aggapplayngo-diamond-vortex",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DiamondVortex.webp",
      alt: "diamond-vortex",
      name: "Diamond Vortex",
    },
    DiscoDiamonds: {
      redirectUrl: "/casino/aggapplayngo-disco-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DiscoDiamonds.webp",
      alt: "disco diamonds",
      name: "Disco Diamonds",
    },
    DivineShowdown: {
      redirectUrl: "/casino/aggapplayngo-divine-showdown",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DivineShowdown.webp",
      alt: "divine showdown",
      name: "Divine Showdown",
    },
    DrToonz: {
      redirectUrl: "/casino/aggapplayngo-dr-toonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DrToonz.webp",
      alt: "dr toonz",
      name: "Dr Toonz",
    },
    DoomOfEgypt: {
      redirectUrl: "/casino/aggapplayngo-doom-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DoomofEgypt.webp",
      alt: "doom of egypt",
      name: "Doom of Egypt",
    },
    DragonMaiden: {
      redirectUrl: "/casino/aggapplayngo-dragon-maiden",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DragonMaiden.webp",
      alt: "Dragon Maiden",
      name: "Dragon Maiden",
    },
    DragonShip: {
      redirectUrl: "/casino/aggapplayngo-dragon-ship",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DragonShip.webp",
      alt: "Dragon Ship",
      name: "Dragon Ship",
    },
    EasterEggs: {
      redirectUrl: "/casino/aggapplayngo-easter-eggs",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EasterEggs.webp",
      alt: "Easter Eggs",
      name: "Easter Eggs",
    },
    EnchantedCrystals: {
      redirectUrl: "/casino/aggapplayngo-enchanted-crystals",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EnchantedCrystals.webp",
      alt: "Enchanted Crystals",
      name: "Enchanted Crystals",
    },
    EnchantedMeadow: {
      redirectUrl: "/casino/aggapplayngo-enchanted-meadow",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EnchantedMeadow.webp",
      alt: "Enchanted Meadow",
      name: "Enchanted Meadow",
    },
    Energoonz: {
      redirectUrl: "/casino/aggapplayngo-energoonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Energoonz.webp",
      alt: "Energoonz",
      name: "Energoonz",
    },
    EyeOfAtum: {
      redirectUrl: "/casino/aggapplayngo-eye-of-atum",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EyeOfAtum.webp",
      alt: "Eye Of Atum",
      name: "Eye Of Atum",
    },
    EyeOfTheKraken: {
      redirectUrl: "/casino/aggapplayngo-eye-of-the-kraken",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EyeOfTheKraken.webp",
      alt: "Eye of the Kraken",
      name: "Eye of the Kraken",
    },
    FatFrankies: {
      redirectUrl: "/casino/aggapplayngo-fat-frankies",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FatFrankies.webp",
      alt: "Fat Frankies",
      name: "Fat Frankies",
    },
    FelineFury: {
      redirectUrl: "/casino/aggapplayngo-feline-fury",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FelineFury.webp",
      alt: "Feline Fury",
      name: "Feline Fury",
    },
    FireJoker: {
      redirectUrl: "/casino/aggapplayngo-fire-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FireJoker.webp",
      alt: "Fire Joker",
      name: "Fire Joker",
    },
    FireJokerFreeze: {
      redirectUrl: "/casino/aggapplayngo-fire-joker-freeze",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FireJokerFreeze.webp",
      alt: "Fire Joker Freeze",
      name: "Fire Joker Freeze",
    },
    FireflyFrenzy: {
      redirectUrl: "/casino/aggapplayngo-firefly-frenzy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FireflyFrenzy.webp",
      alt: "Firefly Frenzy",
      name: "Firefly Frenzy",
    },

    ForgeOfFortunes: {
      redirectUrl: "/casino/aggapplayngo-forge-of-fortunes",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ForgeOfFortunes.webp",
      alt: "Forge of Fortunes",
      name: "Forge of Fortunes",
    },
    ForgeOfGems: {
      redirectUrl: "/casino/aggapplayngo-forge-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ForgeOfGems.webp",
      alt: "Forge Of Gems",
      name: "Forge Of Gems",
    },
    FortuneRewind: {
      redirectUrl: "/casino/aggapplayngo-fortune-rewind",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FortuneRewind.webp",
      alt: "Fortune Rewind",
      name: "Fortune Rewind",
    },
    FortunesOfAliBaba: {
      redirectUrl: "/casino/aggapplayngo-fortunes-of-ali-baba",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FortunesOfAliBaba.webp",
      alt: "Fortunes of Ali Baba",
      name: "Fortunes of Ali Baba",
    },
    FreeReelinJoker1000: {
      redirectUrl: "/casino/aggapplayngo-free-reelin-joker-1000",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FreeReelinJoker1000.webp",
      alt: "Free Reelin' Joker 1000",
      name: "Free Reelin' Joker 1000",
    },
    FreeReelinJoker: {
      redirectUrl: "/casino/aggapplayngo-free-reelin-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FreeReelinJoker.webp",
      alt: "Free Reelin' Joker",
      name: "Free Reelin' Joker",
    },
    FrozenGems: {
      redirectUrl: "/casino/aggapplayngo-frozen-gems",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FrozenGems.webp",
      alt: "Frozen Gems",
      name: "Frozen Gems",
    },
    FUERDAI: {
      redirectUrl: "/casino/aggapplayngo-fu-er-dai",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/FUERDAI.webp",
      alt: "FU ER DAI",
      name: "FU ER DAI",
    },
    GameOfGladiators: {
      redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GameOfGladiators.webp",
      alt: "Game of Gladiators",
      name: "Game of Gladiators",
    },
    GameOfGladiatorsUprising: {
      redirectUrl: "/casino/aggapplayngo-game-of-gladiators",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GameOfGladiatorsUprising.webp",
      alt: "Game of Gladiators: Uprising",
      name: "Game of Gladiators: Uprising",
    },
    GatesOfTroy: {
      redirectUrl: "/casino/aggapplayngo-gates-of-troy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GatesOfTroy.webp",
      alt: "Gates of Troy",
      name: "Gates of Troy",
    },
    Gemix: {
      redirectUrl: "/casino/aggapplayngo-gemix",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Gemix.webp",
      alt: "Gemix",
      name: "Gemix",
    },
    Gemix2: {
      redirectUrl: "/casino/aggapplayngo-gemix-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Gemix2.webp",
      alt: "Gemix 2",
      name: "Gemix 2",
    },
    GerardsGambit: {
      redirectUrl: "/casino/aggapplayngo-gerards-gambit",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GerardsGambit.webp",
      alt: "Gerard's Gambit",
      name: "Gerard's Gambit",
    },
    GhostOfDead: {
      redirectUrl: "/casino/aggapplayngo-ghost-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GhostOfDead.webp",
      alt: "Ghost of Dead",
      name: "Ghost of Dead",
    },
    Gigantoonz: {
      redirectUrl: "/casino/aggapplayngo-gigantoonz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Gigantoonz.webp",
      alt: "Gigantoonz",
      name: "Gigantoonz",
    },
    GoldKing: {
      redirectUrl: "/casino/aggapplayngo-gold-king",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldKing.webp",
      alt: "Gold King",
      name: "Gold King",
    },
    GoldTrophy2: {
      redirectUrl: "/casino/aggapplayngo-gold-trophy-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldTrophy2.webp",
      alt: "Gold Trophy 2",
      name: "Gold Trophy 2",
    },
    GoldVolcano: {
      redirectUrl: "/casino/aggapplayngo-gold-volcano",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldVolcano.webp",
      alt: "Gold Volcano",
      name: "Gold Volcano",
    },
    GoldenCaravan: {
      redirectUrl: "/casino/aggapplayngo-golden-caravan",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenCaravan.webp",
      alt: "Golden Caravan",
      name: "Golden Caravan",
    },
    GoldenColts: {
      redirectUrl: "/casino/aggapplayngo-golden-colts",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenColts.webp",
      alt: "Golden Colts",
      name: "Golden Colts",
    },
    GoldenLegend: {
      redirectUrl: "/casino/aggapplayngo-golden-legend",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenLegend.webp",
      alt: "Golden Legend",
      name: "Golden Legend",
    },
    GoldenOsiris: {
      redirectUrl: "/casino/aggapplayngo-golden-osiris",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenOsiris.webp",
      alt: "Golden Osiris",
      name: "Golden Osiris",
    },
    GoldenTicket: {
      redirectUrl: "/casino/aggapplayngo-golden-ticket",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenTicket.webp",
      alt: "Golden Ticket",
      name: "Golden Ticket",
    },
    GoldenTicket2: {
      redirectUrl: "/casino/aggapplayngo-golden-ticket-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldenTicket2.webp",
      alt: "Golden Ticket 2",
      name: "Golden Ticket 2",
    },
    GrimMuerto: {
      redirectUrl: "/casino/aggapplayngo-grim-muerto",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GrimMuerto.webp",
      alt: "Grim Muerto",
      name: "Grim Muerto",
    },
    HappyHalloween: {
      redirectUrl: "/casino/aggapplayngo-happy-halloween",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HappyHalloween.webp",
      alt: "Happy Halloween",
      name: "Happy Halloween",
    },
    HighwayLegends: {
      redirectUrl: "/casino/aggapplayngo-highway-legends",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HighwayLegends.webp",
      alt: "Highway Legends",
      name: "Highway Legends",
    },
    HolidaySeason: {
      redirectUrl: "/casino/aggapplayngo-holiday-season",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HolidaySeason.webp",
      alt: "Holiday Season",
      name: "Holiday Season",
    },
    HolidaySpirits: {
      redirectUrl: "/casino/aggapplayngo-holiday-spirits",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HolidaySpirits.webp",
      alt: "Holiday Spirits",
      name: "Holiday Spirits",
    },
    HoneyRush: {
      redirectUrl: "/casino/aggapplayngo-honey-rush",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HoneyRush.webp",
      alt: "Honey Rush",
      name: "Honey Rush",
    },
    HooliganHustle: {
      redirectUrl: "/casino/aggapplayngo-hooligan-hustle",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HooliganHustle.webp",
      alt: "Hooligan Hustle",
      name: "Hooligan Hustle",
    },
    HotelYetiWay: {
      redirectUrl: "/casino/aggapplayngo-hotel-yeti-way",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HotelYetiWay.webp",
      alt: "Hotel Yeti-Way",
      name: "Hotel Yeti-Way",
    },
    HouseOfDoom: {
      redirectUrl: "/casino/aggapplayngo-house-of-doom",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HouseofDoom.webp",
      alt: "House of Doom",
      name: "House of Doom",
    },
    HouseOfDoom2TheCrypt: {
      redirectUrl: "/casino/aggapplayngo-house-of-doom-2-the-crypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HouseofDoom2TheCrypt.webp",
      alt: "House of Doom 2 The Crypt",
      name: "House of Doom 2 The Crypt",
    },
    IceJoker: {
      redirectUrl: "/casino/aggapplayngo-ice-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/IceJoker.webp",
      alt: "Ice Joker",
      name: "Ice Joker",
    },
    IdolOfFortune: {
      redirectUrl: "/casino/aggapplayngo-idol-of-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/IdolofFortune.webp",
      alt: "Idol of Fortune",
      name: "Idol of Fortune",
    },
    ImmorTailsOfEgypt: {
      redirectUrl: "/casino/aggapplayngo-immortails-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ImmorTailsOfEgypt.webp",
      alt: "ImmorTails of Egypt",
      name: "ImmorTails of Egypt",
    },
    // ImperialOpera: {
    //   redirectUrl: "/casino/qtechplayngo-imperial-opera",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/ImperialOpera.webp",
    //   alt: "Imperial Opera",
    //   name: "Imperial Opera",
    // },
    InfernoJoker: {
      redirectUrl: "/casino/aggapplayngo-inferno-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/InfernoJoker.webp",
      alt: "Inferno Joker",
      name: "Inferno Joker",
    },
    InvadingVegas: {
      redirectUrl: "/casino/aggapplayngo-invading-vegas",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/InvadingVegas.webp",
      alt: "Invading Vegas",
      name: "Invading Vegas",
    },
    InfernoStar: {
      redirectUrl: "/casino/aggapplayngo-inferno-star",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/InfernoStar.webp",
      alt: "Inferno Star",
      name: "Inferno Star",
    },
    IrishGold: {
      redirectUrl: "/casino/aggapplayngo-irish-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/IrishGold.webp",
      alt: "Irish Gold",
      name: "Irish Gold",
    },
    IronGirl: {
      redirectUrl: "/casino/aggapplayngo-iron-girl",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/IronGirl.webp",
      alt: "Iron Girl",
      name: "Iron Girl",
    },
    JadeMagician: {
      redirectUrl: "/casino/aggapplayngo-jade-magician",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JadeMagician.webp",
      alt: "Jade Magician",
      name: "Jade Magician",
    },
    JewelBox: {
      redirectUrl: "/casino/aggapplayngo-jewel-box",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JewelBox.webp",
      alt: "Jewel Box",
      name: "Jewel Box",
    },
    // JollyRoger: {
    //   redirectUrl: "/casino/qtechplayngo-jolly-roger",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/JollyRoger.webp",
    //   alt: "Jolly Roger",
    //   name: "Jolly Roger",
    // },
    JollyRoger2: {
      redirectUrl: "/casino/aggapplayngo-jolly-roger-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JollyRoger2.webp",
      alt: "Jolly Roger 2",
      name: "Jolly Roger 2",
    },
    KingsMask: {
      redirectUrl: "/casino/aggapplayngo-kings-mask",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/KingsMask.webp",
      alt: "King's Mask",
      name: "King's Mask",
    },
    LadyOfFortune: {
      redirectUrl: "/casino/aggapplayngo-lady-of-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LadyOfFortune.webp",
      alt: "Lady of Fortune",
      name: "Lady of Fortune",
    },
    LegacyOfEgypt: {
      redirectUrl: "/casino/aggapplayngo-legacy-of-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegacyOfEgypt.webp",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
    },
    LegacyOfInca: {
      redirectUrl: "/casino/aggapplayngo-legacy-of-inca",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegacyOfInca.webp",
      alt: "Legacy of Inca",
      name: "Legacy of Inca",
    },
    LegendOfTheIceDragon: {
      redirectUrl: "/casino/aggapplayngo-legend-of-the-ice-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegendOfTheIceDragon.webp",
      alt: "Legend Of The Ice Dragon",
      name: "Legend Of The Ice Dragon",
    },
    LegionGold: {
      redirectUrl: "/casino/aggapplayngo-legion-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegionGold.webp",
      alt: "Legion Gold",
      name: "Legion Gold",
    },
    LeprechaunGoesEgypt: {
      redirectUrl: "/casino/aggapplayngo-leprechaun-goes-egypt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LeprechaunGoesEgypt.webp",
      alt: "Leprechaun goes Egypt",
      name: "Leprechaun goes Egypt",
    },
    LeprechaunGoesWild: {
      redirectUrl: "/casino/aggapplayngo-leprechaun-goes-wild",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LeprechaunGoesWild.webp",
      alt: "Leprechaun Goes Wild",
      name: "Leprechaun Goes Wild",
    },
    LeprechaunsVault: {
      redirectUrl: "/casino/aggapplayngo-leprechauns-vault",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LeprechaunsVault.webp",
      alt: "Leprechaun's Vault",
      name: "Leprechaun's Vault",
    },
    LordMerlinAndTheLadyOfTheLake: {
      redirectUrl: "/casino/aggapplayngo-lord-merlin-and-the-lady-of-the-lake",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LordMerlinAndTheLadyOfTheLake.webp",
      alt: "Lord Merlin and The Lady of The Lake",
      name: "Lord Merlin and The Lady of The Lake",
    },
    LoveJoker: {
      redirectUrl: "/casino/aggapplayngo-love-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LoveJoker.webp",
      alt: "Love Joker",
      name: "Love Joker",
    },
    Luchamigos: {
      redirectUrl: "/casino/aggapplayngo-luchamigos",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Luchamigos.webp",
      alt: "Luchamigos",
      name: "Luchamigos",
    },
    LuckyDiamonds: {
      redirectUrl: "/casino/aggapplayngo-lucky-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LuckyDiamonds.webp",
      alt: "Lucky Diamonds",
      name: "Lucky Diamonds",
    },
    MadameInk: {
      redirectUrl: "/casino/aggapplayngo-madame-ink",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MadameInk.webp",
      alt: "Madame Ink",
      name: "Madame Ink",
    },
    MegaDon: {
      redirectUrl: "/casino/aggapplayngo-mega-don",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MegaDon.webp",
      alt: "Mega Don",
      name: "Mega Don",
    },
    Mahjong88: {
      redirectUrl: "/casino/aggapplayngo-mahjong-88",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Mahjong88.webp",
      alt: "Mahjong 88",
      name: "Mahjong 88",
    },
    Matsuri: {
      redirectUrl: "/casino/aggapplayngo-matsuri",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Matsuri.webp",
      alt: "Matsuri",
      name: "Matsuri",
    },
    MerlinAndIceQueenMorgana: {
      redirectUrl: "/casino/aggapplayngo-merlin-and-ice-queen-morgana",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MerlinAndTheIceQueenMorgana.webp",
      alt: "Merlin and Ice Queen Morgana",
      name: "Merlin and Ice Queen Morgana",
    },
    MerlinsGrimoire: {
      redirectUrl: "/casino/aggapplayngo-merlins-grimoire",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MerlinsGrimoire.webp",
      alt: "Merlin's Grimoire",
      name: "Merlin's Grimoire",
    },
    MermaidsDiamond: {
      redirectUrl: "/casino/aggapplayngo-mermaids-diamond",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MermaidsDiamond.webp",
      alt: "Mermaid's Diamond",
      name: "Mermaid's Diamond",
    },
    MerryXmas: {
      redirectUrl: "/casino/aggapplayngo-merry-xmas",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MerryXmas.webp",
      alt: "Merry Xmas",
      name: "Merry Xmas",
    },
    MinerDonkeyTrouble: {
      redirectUrl: "/casino/aggapplayngo-miner-donkey-trouble",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MinerDonkeyTrouble.webp",
      alt: "Miner Donkey Trouble",
      name: "Miner Donkey Trouble",
    },
    MissionCash: {
      redirectUrl: "/casino/aggapplayngo-mission-cash",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MissionCash.webp",
      alt: "Mission Cash",
      name: "Mission Cash",
    },
    MoonPrincess100: {
      redirectUrl: "/casino/aggapplayngo-moon-princess-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoonPrincess100.webp",
      alt: "Moon Princess 100",
      name: "Moon Princess 100",
    },
    MoonPrincess: {
      redirectUrl: "/casino/aggapplayngo-moon-princess",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoonPrincess.webp",
      alt: "Moon Princess",
      name: "Moon Princess",
    },
    MoonPrincessChristmasKingdom: {
      redirectUrl: "/casino/aggapplayngo-moon-princess-christmas-kingdom",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoonPrincessChristmasKingdom.webp",
      alt: "Moon Princess Christmas Kingdom",
      name: "Moon Princess Christmas Kingdom",
    },
    MoonPrincessTrinity: {
      redirectUrl: "/casino/aggapplayngo-moon-princess-trinity",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoonPrincessTrinity.webp",
      alt: "Moon Princess Trinity",
      name: "Moon Princess Trinity",
    },
    MountM: {
      redirectUrl: "/casino/aggapplayngo-mount-m",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MountM.webp",
      alt: "Mount M",
      name: "Mount M",
    },
    MuertoEnMictlán: {
      redirectUrl: "/casino/aggapplayngo-muerto-en-mictlan",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MuertoEnMictlán.webp",
      alt: "Muerto en Mictlán",
      name: "Muerto en Mictlán",
    },
    // MultiFruit81: {
    //   redirectUrl: "/casino/qtechplayngo-multifruit-81",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/MultiFruit81.webp",
    //   alt: "MultiFruit 81",
    //   name: "MultiFruit 81",
    // },
    MysteryJoker: {
      redirectUrl: "/casino/aggapplayngo-mystery-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MysteryJoker.webp",
      alt: "Mystery Joker",
      name: "Mystery Joker",
    },
    MysteryJoker6000: {
      redirectUrl: "/casino/aggapplayngo-mystery-joker-6000",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MysteryJoker6000.webp",
      alt: "Mystery Joker 6000",
      name: "Mystery Joker 6000",
    },
    Myth: {
      redirectUrl: "/casino/aggapplayngo-myth",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Myth.webp",
      alt: "Myth",
      name: "Myth",
    },
    NaughtyNicksBook: {
      redirectUrl: "/casino/aggapplayngo-naughty-nicks-book",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/NaughtyNicksBook.webp",
      alt: "Naughty Nick's Book",
      name: "Naughty Nick's Book",
    },
    NewYearRiches: {
      redirectUrl: "/casino/aggapplayngo-new-year-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/NewYearRiches.webp",
      alt: "New Year Riches",
      name: "New Year Riches",
    },
    NinjaFruits: {
      redirectUrl: "/casino/aggapplayngo-ninja-fruits",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/NinjaFruits.webp",
      alt: "Ninja Fruits",
      name: "Ninja Fruits",
    },
    OctopusTreasure: {
      redirectUrl: "/casino/aggapplayngo-octopus-treasure",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/OctopusTreasure.webp",
      alt: "Octopus Treasure",
      name: "Octopus Treasure",
    },
    OdinProtectorOfRealms: {
      redirectUrl: "/casino/aggapplayngo-odin-protector-of-realms",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/OdinProtectorOfRealms.webp",
      alt: "Odin: Protector of Realms",
      name: "Odin: Protector of Realms",
    },
    PackAndCash: {
      redirectUrl: "/casino/aggapplayngo-pack-and-cash",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PackAndCash.webp",
      alt: "Pack & Cash",
      name: "Pack & Cash",
    },
    PandorasBoxOfEvil: {
      redirectUrl: "/casino/aggapplayngo-pandoras-box-of-evil",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PandorasBoxOfEvil.webp",
      alt: "Pandora's Box of Evil",
      name: "Pandora's Box of Evil",
    },
    PearlLagoon: {
      redirectUrl: "/casino/aggapplayngo-pearl-lagoon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PearlLagoon.webp",
      alt: "Pearl Lagoon",
      name: "Pearl Lagoon",
    },
    PearlsOfIndia: {
      redirectUrl: "/casino/aggapplayngo-pearls-of-india",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PearlsOfIndia.webp",
      alt: "Pearls of India",
      name: "Pearls of India",
    },
    PerfectGems: {
      redirectUrl: "/casino/aggapplayngo-perfect-gems",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PerfectGems.webp",
      alt: "Perfect Gems",
      name: "Perfect Gems",
    },
    PhoenixReborn: {
      redirectUrl: "/casino/aggapplayngo-phoenix-reborn",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PhoenixReborn.webp",
      alt: "Phoenix Reborn",
      name: "Phoenix Reborn",
    },
    PhotoSafari: {
      redirectUrl: "/casino/aggapplayngo-photo-safari",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PhotoSafari.webp",
      alt: "Photo Safari",
      name: "Photo Safari",
    },
    PiggyBankFarm: {
      redirectUrl: "/casino/aggapplayngo-piggy-bank-farm",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PiggyBankFarm.webp",
      alt: "Piggy Bank Farm",
      name: "Piggy Bank Farm",
    },
    PilgrimOfDead: {
      redirectUrl: "/casino/aggapplayngo-pilgrim-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PilgrimOfDead.webp",
      alt: "Pilgrim of Dead",
      name: "Pilgrim of Dead",
    },
    Pimped: {
      redirectUrl: "/casino/aggapplayngo-pimped",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Pimped.webp",
      alt: "Pimped",
      name: "Pimped",
    },
    PlanetFortune: {
      redirectUrl: "/casino/aggapplayngo-planet-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PlanetFortune.webp",
      alt: "Planet Fortune",
      name: "Planet Fortune",
    },
    PrismOfGems: {
      redirectUrl: "/casino/aggapplayngo-prism-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PrismOfGems.webp",
      alt: "Prism of Gems",
      name: "Prism of Gems",
    },
    PrissyPrincess: {
      redirectUrl: "/casino/aggapplayngo-prissy-princess",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PrissyPrincess.webp",
      alt: "Prissy Princess",
      name: "Prissy Princess",
    },
    ProsperityPalace: {
      redirectUrl: "/casino/aggapplayngo-prosperity-palace",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ProsperityPalace.webp",
      alt: "Prosperity Palace",
      name: "Prosperity Palace",
    },
    PueblaParade: {
      redirectUrl: "/casino/aggapplayngo-puebla-parade",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PueblaParade.webp",
      alt: "Puebla Parade",
      name: "Puebla Parade",
    },
    QueensDayTilt: {
      redirectUrl: "/casino/aggapplayngo-queens-day-tilt",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/QueensDayTilt.webp",
      alt: "Queens Day Tilt",
      name: "Queens Day Tilt",
    },
    RabbitHoleRiches: {
      redirectUrl: "/casino/aggapplayngo-rabbit-hole-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RabbitHoleRiches.webp",
      alt: "Rabbit Hole Riches",
      name: "Rabbit Hole Riches",
    },
    RageToRiches: {
      redirectUrl: "/casino/aggapplayngo-rage-to-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RageToRiches.webp",
      alt: "Rage to Riches",
      name: "Rage to Riches",
    },
    RagingRex: {
      redirectUrl: "/casino/aggapplayngo-raging-rex",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RagingRex.webp",
      alt: "Raging Rex",
      name: "Raging Rex",
    },
    RagingRex2: {
      redirectUrl: "/casino/aggapplayngo-raging-rex-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RagingRex2.webp",
      alt: "Raging Rex 2",
      name: "Raging Rex 2",
    },
    RainforestMagic: {
      redirectUrl: "/casino/aggapplayngo-rainforest-magic",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RainforestMagic.webp",
      alt: "Rainforest Magic",
      name: "Rainforest Magic",
    },
    Rally4Riches: {
      redirectUrl: "/casino/aggapplayngo-rally-4-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Rally4Riches.webp",
      alt: "Rally 4 Riches",
      name: "Rally 4 Riches",
    },
    Reactoonz2: {
      redirectUrl: "/casino/aggapplayngo-reactoonz-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Reactoonz2.webp",
      alt: "Reactoonz 2",
      name: "Reactoonz 2",
    },
    RichWildeAndTheWanderingCity: {
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-wandering-city",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichWildeAndTheWanderingCity.webp",
      alt: "Rich Wilde And The Wandering City",
      name: "Rich Wilde And The Wandering City",
    },
    RichWildeAndTheShieldOfAthena: {
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-shield-of-athena",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichWildeAndTheShieldOfAthena.webp",
      alt: "Rich Wilde and the Shield of Athena",
      name: "Rich Wilde and the Shield of Athena",
    },
    RichesOfRA: {
      redirectUrl: "/casino/aggapplayngo-riches-of-ra",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichesOfRA.webp",
      alt: "Riches of RA",
      name: "Riches of RA",
    },
    RichesOfRobin: {
      redirectUrl: "/casino/aggapplayngo-riches-of-robin",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichesOfRobin.webp",
      alt: "Riches of Robin",
      name: "Riches of Robin",
    },
    RiddleReelsACaseOfRiches: {
      redirectUrl: "/casino/aggapplayngo-riddle-reels-a-case-of-riches",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiddleReelsACaseOfRiches.webp",
      alt: "Riddle Reels a case of riches",
      name: "Riddle Reels a case of riches",
    },
    RingOfOdin: {
      redirectUrl: "/casino/aggapplayngo-ring-of-odin",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RingOfOdin.webp",
      alt: "Ring of Odin",
      name: "Ring of Odin",
    },
    RiseOfAthena: {
      redirectUrl: "/casino/aggapplayngo-rise-of-athena",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfAthena.webp",
      alt: "Rise of Athena",
      name: "Rise of Athena",
    },
    RiseOfDead: {
      redirectUrl: "/casino/aggapplayngo-rise-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfDead.webp",
      alt: "Rise of Dead",
      name: "Rise of Dead",
    },
    RiseOfGodsReckoning: {
      redirectUrl: "/casino/aggapplayngo-rise-of-gods-reckoning",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfGodsReckoning.webp",
      alt: "Rise of Gods Reckoning",
      name: "Rise of Gods Reckoning",
    },
    RiseOfMerlin: {
      redirectUrl: "/casino/aggapplayngo-rise-of-merlin",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfMerlin.webp",
      alt: "Rise of Merlin",
      name: "Rise of Merlin",
    },
    // RiseOfOlympus: {
    //   redirectUrl: "/casino/aggapplayngo-rise-of-olympus",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "ALT_GAMING_GAP",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/RiseOfOlympus.webp",
    //   alt: "Rise of Olympus",
    //   name: "Rise of Olympus",
    // },
    RiseOfOlympus100: {
      redirectUrl: "/casino/aggapplayngo-rise-of-olympus-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfOlympus100.webp",
      alt: "Rise of Olympus 100",
      name: "Rise of Olympus 100",
    },
    RoccoGallo: {
      redirectUrl: "/casino/aggapplayngo-rocco-gallo",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RoccoGallo.webp",
      alt: "Rocco Gallo",
      name: "Rocco Gallo",
    },
    RoninsHonour: {
      redirectUrl: "/casino/aggapplayngo-ronins-honour",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RoninsHonour.webp",
      alt: "Ronin's Honour",
      name: "Ronin's Honour",
    },
    Rotiki: {
      redirectUrl: "/casino/aggapplayngo-rotiki",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Rotiki.webp",
      alt: "Rotiki",
      name: "Rotiki",
    },
    RoyalMasquerade: {
      redirectUrl: "/casino/aggapplayngo-royal-masquerade",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RoyalMasquerade.webp",
      alt: "Royal Masquerade",
      name: "Royal Masquerade",
    },
    Sabaton: {
      redirectUrl: "/casino/aggapplayngo-sabaton",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Sabaton.webp",
      alt: "Sabaton",
      name: "Sabaton",
    },
    SafariOfWealth: {
      redirectUrl: "/casino/aggapplayngo-safari-of-wealth",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SafariOfWealth.webp",
      alt: "Safari Of Wealth",
      name: "Safari Of Wealth",
    },
    SailsOfGold: {
      redirectUrl: "/casino/aggapplayngo-sails-of-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SailsOfGold.webp",
      alt: "Sails of Gold",
      name: "Sails of Gold",
    },
    SambaCarnival: {
      redirectUrl: "/casino/aggapplayngo-samba-carnival",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SambaCarnival.webp",
      alt: "Samba Carnival",
      name: "Samba Carnival",
    },
    ScrollOfDead: {
      redirectUrl: "/casino/aggapplayngo-scroll-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ScrollOfDead.webp",
      alt: "Scroll of Dead",
      name: "Scroll of Dead",
    },
    SeaHunter: {
      redirectUrl: "/casino/aggapplayngo-sea-hunter",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SeaHunter.webp",
      alt: "Sea Hunter",
      name: "Sea Hunter",
    },
    SecretOfDead: {
      redirectUrl: "/casino/aggapplayngo-secret-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SecretOfDead.webp",
      alt: "Secret Of Dead",
      name: "Secret Of Dead",
    },
    ShamrockMiner: {
      redirectUrl: "/casino/aggapplayngo-shamrock-miner",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ShamrockMiner.webp",
      alt: "Shamrock Miner",
      name: "Shamrock Miner",
    },
    SistersOfTheSun: {
      redirectUrl: "/casino/aggapplayngo-sisters-of-the-sun",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SistersOfTheSun.webp",
      alt: "Sisters of The Sun",
      name: "Sisters of The Sun",
    },
    SizzlingSpins: {
      redirectUrl: "/casino/aggapplayngo-sizzling-spins",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SizzlingSpins.webp",
      alt: "Sizzling Spins",
      name: "Sizzling Spins",
    },
    Slashimi: {
      redirectUrl: "/casino/aggapplayngo-slashimi",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Slashimi.webp",
      alt: "Slashimi",
      name: "Slashimi",
    },
    SpaceRace: {
      redirectUrl: "/casino/aggapplayngo-space-race",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SpaceRace.webp",
      alt: "Space Race",
      name: "Space Race",
    },
    SparkyAndShortz: {
      redirectUrl: "/casino/aggapplayngo-sparky-and-shortz",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SparkyAndShortz.webp",
      alt: "Sparky & Shortz",
      name: "Sparky & Shortz",
    },
    SpinParty: {
      redirectUrl: "/casino/aggapplayngo-spin-party",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SpinParty.webp",
      alt: "Spin Party",
      name: "Spin Party",
    },
    StarJoker: {
      redirectUrl: "/casino/aggapplayngo-star-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/StarJoker.webp",
      alt: "Star Joker",
      name: "Star Joker",
    },
    StickyJoker: {
      redirectUrl: "/casino/aggapplayngo-sticky-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/StickyJoker.webp",
      alt: "Sticky Joker",
      name: "Sticky Joker",
    },
    StreetMagic: {
      redirectUrl: "/casino/aggapplayngo-street-magic",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/StreetMagic.webp",
      alt: "Street Magic",
      name: "Street Magic",
    },
    SuperFlip: {
      redirectUrl: "/casino/aggapplayngo-super-flip",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SuperFlip.webp",
      alt: "Super Flip",
      name: "Super Flip",
    },
    Sweet27: {
      redirectUrl: "/casino/aggapplayngo-sweet-27",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Sweet27.webp",
      alt: "Sweet 27",
      name: "Sweet 27",
    },
    SweetAlchemy: {
      redirectUrl: "/casino/aggapplayngo-sweet-alchemy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SweetAlchemy.webp",
      alt: "Sweet Alchemy",
      name: "Sweet Alchemy",
    },
    TaleOfKyubiko: {
      redirectUrl: "/casino/aggapplayngo-tale-of-kyubiko",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TaleOfKyubiko.webp",
      alt: "Tale Of Kyubiko",
      name: "Tale Of Kyubiko",
    },
    TalesOfAsgardFreyasWedding: {
      redirectUrl: "/casino/aggapplayngo-tales-of-asgard-freyas-wedding",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TalesOfAsgardFreyasWedding.webp",
      alt: "Tales of Asgard Freya's Wedding",
      name: "Tales of Asgard Freya's Wedding",
    },
    TalesOfAsgardLokisFortune: {
      redirectUrl: "/casino/aggapplayngo-tales-of-asgard-lokis-fortune",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TalesOfAsgardLokisFortune.webp",
      alt: "Tales Of Asgard Loki's Fortune",
      name: "Tales Of Asgard Loki's Fortune",
    },
    Testament: {
      redirectUrl: "/casino/aggapplayngo-testament",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Testament.webp",
      alt: "Testament",
      name: "Testament",
    },
    ThatsRich: {
      redirectUrl: "/casino/aggapplayngo-thats-rich",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ThatsRich.webp",
      alt: "That's Rich",
      name: "That's Rich",
    },
    TheFacesOfFreya: {
      redirectUrl: "/casino/aggapplayngo-the-faces-of-freya",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheFacesOfFreya.webp",
      alt: "The Faces of Freya",
      name: "The Faces of Freya",
    },
    TheGreenKnight: {
      redirectUrl: "/casino/aggapplayngo-the-green-knight",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheGreenKnight.webp",
      alt: "The Green Knight",
      name: "The Green Knight",
    },
    TheLastSundown: {
      redirectUrl: "/casino/aggapplayngo-the-last-sundown",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheLastSundown.webp",
      alt: "The Last Sundown",
      name: "The Last Sundown",
    },
    ThePayingPianoClub: {
      redirectUrl: "/casino/aggapplayngo-the-paying-piano-club",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ThePayingPianoClub.webp",
      alt: "The Paying Piano Club",
      name: "The Paying Piano Club",
    },
    ShimmeringWoods: {
      redirectUrl: "/casino/aggapplayngo-shimmering-woods",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheShimmeringWoods.webp",
      alt: "Shimmering Woods",
      name: "Shimmering Woods",
    },
    TheSwordAndTheGrail: {
      redirectUrl: "/casino/aggapplayngo-the-sword-and-the-grail",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheSwordAndTheGrail.webp",
      alt: "The Sword and The Grail",
      name: "The Sword and The Grail",
    },
    TheWildClass: {
      redirectUrl: "/casino/aggapplayngo-the-wild-class",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheWildClass.webp",
      alt: "The Wild Class",
      name: "The Wild Class",
    },
    ThunderScreech: {
      redirectUrl: "/casino/aggapplayngo-thunder-screech",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ThunderScreech.webp",
      alt: "Thunder Screech",
      name: "Thunder Screech",
    },
    // TomeOfMadness: {
    //   redirectUrl: "/casino/qtechplayngo-tome-of-madness",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/TomeOfMadness.webp",
    //   alt: "Tome of Madness",
    //   name: "Tome of Madness",
    // },
    TrollHunters: {
      redirectUrl: "/casino/aggapplayngo-troll-hunters",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TrollHunters.webp",
      alt: "Troll Hunters",
      name: "Troll Hunters",
    },
    TrollHunters2: {
      redirectUrl: "/casino/aggapplayngo-troll-hunters-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TrollHunters2.webp",
      alt: "Troll Hunters 2",
      name: "Troll Hunters 2",
    },
    USAFlip: {
      redirectUrl: "/casino/aggapplayngo-usa-flip",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/USAFlip.webp",
      alt: "USA Flip",
      name: "USA Flip",
    },
    VikingRunecraft: {
      redirectUrl: "/casino/aggapplayngo-viking-runecraft",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/VikingRunecraft.webp",
      alt: "Viking Runecraft",
      name: "Viking Runecraft",
    },
    WildBandolier: {
      redirectUrl: "/casino/aggapplayngo-wild-bandolier",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildBandolier.webp",
      alt: "Wild Bandolier",
      name: "Wild Bandolier",
    },
    WildBlood: {
      redirectUrl: "/casino/aggapplayngo-wild-blood",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildBlood.webp",
      alt: "Wild Blood",
      name: "Wild Blood",
    },
    WildBlood2: {
      redirectUrl: "/casino/aggapplayngo-wild-blood-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildBlood2.webp",
      alt: "Wild Blood 2",
      name: "Wild Blood 2",
    },
    WildFalls: {
      redirectUrl: "/casino/aggapplayngo-wild-falls",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildFalls.webp",
      alt: "Wild Falls",
      name: "Wild Falls",
    },
    WildFalls2: {
      redirectUrl: "/casino/aggapplayngo-wild-falls-2",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildFalls2.webp",
      alt: "Wild Falls 2",
      name: "Wild Falls 2",
    },
    WildFrames: {
      redirectUrl: "/casino/aggapplayngo-wild-frames",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildFrames.webp",
      alt: "Wild Frames",
      name: "Wild Frames",
    },
    WildMelon: {
      redirectUrl: "/casino/aggapplayngo-wild-melon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildMelon.webp",
      alt: "Wild Melon",
      name: "Wild Melon",
    },
    WildNorth: {
      redirectUrl: "/casino/aggapplayngo-wild-north",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildNorth.webp",
      alt: "Wild North",
      name: "Wild North",
    },
    WildRails: {
      redirectUrl: "/casino/aggapplayngo-wild-rails",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildRails.webp",
      alt: "Wild Rails",
      name: "Wild Rails",
    },
    WildTrigger: {
      redirectUrl: "/casino/aggapplayngo-wild-trigger",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildTrigger.webp",
      alt: "Wild Trigger",
      name: "Wild Trigger",
    },
    WildhoundDerby: {
      redirectUrl: "/casino/aggapplayngo-wildhound-derby",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildhoundDerby.webp",
      alt: "Wildhound Derby",
      name: "Wildhound Derby",
    },
    WinABeest: {
      redirectUrl: "/casino/aggapplayngo-win-a-beest",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WinABeest.webp",
      alt: "Win-A-Beest",
      name: "Win-A-Beest",
    },
    WizardOfGems: {
      redirectUrl: "/casino/aggapplayngo-wizard-of-gems",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WizardOfGems.webp",
      alt: "Wizard of Gems",
      name: "Wizard of Gems",
    },
    XmasJoker: {
      redirectUrl: "/casino/aggapplayngo-xmas-joker-3-reel",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/XmasJoker.webp",
      alt: "Xmas Joker",
      name: "Xmas Joker",
    },
    XmasMagic: {
      redirectUrl: "/casino/aggapplayngo-xmas-magic",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/XmasMagic.webp",
      alt: "Xmas Magic",
      name: "Xmas Magic",
    },
    Hand3CasinoHoldem: {
      redirectUrl: "/casino/aggapplayngo-3-hand-casino-holdem",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/3HandCasinoHoldem.webp",
      alt: "3-Hand Casino Hold'em",
      name: "3-Hand Casino Hold'em",
    },
    BlackJackMH: {
      redirectUrl: "/casino/aggapplayngo-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BlackJackMH.webp",
      alt: "BlackJack MH",
      name: "BlackJack MH",
    },
    DeucesWild: {
      redirectUrl: "/casino/aggapplayngo-deuces-wild-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DeucesWild.webp",
      alt: "Deuces Wild",
      name: "Deuces Wild",
    },
    DoubleExposureBlackJackMH: {
      redirectUrl: "/casino/aggapplayngo-double-exposure-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DoubleExposureBlackJackMH.webp",
      alt: "Double Exposure BlackJack MH",
      name: "Double Exposure BlackJack MH",
    },
    EuropeanBlackJackMH: {
      redirectUrl: "/casino/aggapplayngo-european-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EuropeanBlackJackMH.webp",
      alt: "European BlackJack MH",
      name: "European BlackJack MH",
    },
    EuropeanRoulette: {
      redirectUrl: "/casino/aggapplayngo-european-roulette",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EuropeanRoulettePro.webp",
      alt: "European Roulette",
      name: "European Roulette",
    },
    JacksOrBetterMH: {
      redirectUrl: "/casino/aggapplayngo-jacks-or-better-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JacksOrBetterMH.webp",
      alt: "Jacks or Better MH",
      name: "Jacks or Better MH",
    },
    JokerPokerMH: {
      redirectUrl: "/casino/aggapplayngo-joker-poker-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JokerPokerMH.webp",
      alt: "Joker Poker MH",
      name: "Joker Poker MH",
    },
    // Keno: {
    //   redirectUrl: "/casino/qtechplayngo-keno",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/Keno.webp",
    //   alt: "Keno",
    //   name: "Keno",
    // },
    // MiniBaccarat: {
    //   redirectUrl: "/casino/qtechplayngo-mini-baccarat",
    //   code: "",
    //   casino: "Play'n GO",
    //   provider: "QTECH",
    //   category: "playNGo",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/play-n-go/MiniBaccarat.webp",
    //   alt: "Mini Baccarat",
    //   name: "Mini Baccarat",
    // },
    SingleDeckBlackJackMH: {
      redirectUrl: "/casino/aggapplayngo-single-deck-blackjack-mh",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SingleDeckBlackJackMH.webp",
      alt: "Single Deck BlackJack MH",
      name: "Single Deck BlackJack MH",
    },
    MoonPrincessPowerOfLove: {
      redirectUrl: "/casino/aggapplayngo-moon-princess-power-of-love",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MoonPrincessPowerOfLove.webp",
      alt: "Moon Princess - Power of Love",
      name: "Moon Princess - Power of Love",
    },
    LoveIsInTheFair: {
      redirectUrl: "/casino/aggapplayngo-love-is-in-the-fair",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LoveIsInTheFair.webp",
      alt: "Love is in the Fair",
      name: "Love is in the Fair",
    },
    CatWildeAndTheIncanQuest: {
      redirectUrl: "/casino/aggapplayngo-cat-wilde-and-the-incan-quest",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CatWildeAndTheIncanQuest.webp",
      alt: "Cat Wilde and the Incan Quest",
      name: "Cat Wilde and the Incan Quest",
    },
    BoatBonanzaDownUnder: {
      redirectUrl: "/casino/aggapplayngo-boat-bonanza-down-under",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BoatBonanzaDownUnder.webp",
      alt: "Boat Bonanza Down Under",
      name: "Boat Bonanza Down Under",
    },
    HugoCarts: {
      redirectUrl: "/casino/aggapplayngo-hugo-carts",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HugoCarts.webp",
      alt: "Hugo Carts",
      name: "Hugo Carts",
    },
    AliceCooperAndTheTomeOfMadness: {
      redirectUrl: "/casino/aggapplayngo-alice-cooper-and-the-tome-of-madness",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AliceCooperAndTheTomeOfMadness.webp",
      alt: "Alice Cooper And The Tome Of Madness",
      name: "Alice Cooper And The Tome Of Madness",
    },
    Snakebite: {
      redirectUrl: "/casino/qt-snakebite",
      code: "",
      casino: "Play'n GO",
      provider: "WorldCasino",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Snakebite.webp",
      alt: "Snakebite",
      name: "Snakebite",
    },
    kissReelsOfRock: {
      redirectUrl: "/casino/aggapplayngo-kiss-reels-of-rock",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/kissReelsOfRock.webp",
      alt: "kiss Reels Of Rock",
      name: "kiss Reels Of Rock",
    },
    DefLeppardHysteria: {
      redirectUrl: "/casino/aggapplayngo-def-leppard-hysteria",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DefleppardHysteria.webp",
      alt: "Def Leppard Hysteria",
      name: "Def Leppard Hysteria",
    },
    DioKillingTheDragon: {
      redirectUrl: "/casino/aggapplayngo-dio-killing-the-dragon",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DioKillingTheDragon.webp",
      alt: "DIO Killing the Dragon",
      name: "DIO Killing the Dragon",
    },
    DivineDivas: {
      redirectUrl: "/casino/aggapplayngo-divine-divas",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DivineDivas.webp",
      alt: "Divine Divas",
      name: "Divine Divas",
    },
    Gemix100: {
      redirectUrl: "/casino/aggapplayngo-gemix-100",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Gemix100.webp",
      alt: "Gemix 100",
      name: "Gemix 100",
    },
    KingdomBelow: {
      redirectUrl: "/casino/aggapplayngo-kingdom-below",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/KingdomBelow.webp",
      alt: "Kingdom Below",
      name: "Kingdom Below",
    },
    MirrorJoker: {
      redirectUrl: "/casino/aggapplayngo-mirror-joker",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MirrorJoker.webp",
      alt: "Mirror Joker",
      name: "Mirror Joker",
    },
    BuildinBucks: {
      redirectUrl: "/casino/aggapplayngo-buildin-bucks",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BuildinBucks.webp",
      alt: "Buildin' Bucks",
      name: "Buildin' Bucks",
    },
    AnkhOfAnubisAwakening: {
      redirectUrl: "/casino/aggapplayngo-ankh-of-anubis-awakening",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/AnkhOfAnubisAwakening.webp",
      alt: "Ankh of Anubis Awakening",
      name: "Ankh of Anubis Awakening",
    },
    ScourgeOfRome: {
      redirectUrl: "/casino/aggapplayngo-scourge-of-rome",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ScourgeOfRome.webp",
      alt: "Scourge of Rome",
      name: "Scourge of Rome",
    },
    MafiaGold: {
      redirectUrl: "/casino/aggapplayngo-mafia-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MafiaGold.webp",
      alt: "Mafia Gold",
      name: "Mafia Gold",
    },
    RiseOfOlympusOrigin: {
      redirectUrl: "/casino/aggapplayngo-rise-of-olympus-origin",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RiseOfOlympusOrigins.webp",
      alt: "Rise of Olympus Origin",
      name: "Rise of Olympus Origin",
    },
    KingsMaskEclipseOfGods: {
      redirectUrl: "/casino/aggapplayngo-kings-mask-eclipse-of-gods",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/KingsMaskEclipseOfGods.webp",
      alt: "King’s Mask Eclipse of Gods",
      name: "King’s Mask Eclipse of Gods",
    },
    WhisperingWinds: {
      redirectUrl: "/casino/aggapplayngo-whispering-winds",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WhisperingWinds.webp",
      alt: "Whispering Winds",
      name: "Whispering Winds",
    },
    DansbandPaTurne: {
      redirectUrl: "/casino/aggapplayngo-dansband-pa-turne",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/DansbandPaTurne.webp",
      alt: "Dansband Pa Turne",
      name: "Dansband Pa Turne",
    },
    OasisOfDead: {
      redirectUrl: "/casino/aggapplayngo-oasis-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/OasisOfDead.webp",
      alt: "Oasis of Dead",
      name: "Oasis of Dead",
    },
    JourneyToParis: {
      redirectUrl: "/casino/aggapplayngo-journey-to-paris",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JourneyToParis.webp",
      alt: "Journey to Paris",
      name: "Journey to Paris",
    },
    TempleOfTollan: {
      redirectUrl: "/casino/aggapplayngo-temple-of-tollan",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TempleOfTollan.webp",
      alt: "Temple of Tollan",
      name: "Temple of Tollan",
    },
    MerlinRealmOfCharm: {
      redirectUrl: "/casino/aggapplayngo-merlin-realm-of-charm",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MerlinRealmOfCharm.webp",
      alt: "Merlin Realm of Charm",
      name: "Merlin Realm of Charm",
    },
    GoldOfFortuneGod: {
      redirectUrl: "/casino/aggapplayngo-gold-of-fortune-god",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/GoldOfFortuneGod.webp",
      alt: "Gold of Fortune God",
      name: "Gold of Fortune God",
    },
    RichWildeAndTheTomeOfInsanity: {
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-tome-of-insanity",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichWildeAndTheTomeOfInsanity.webp",
      alt: "Rich Wilde and the Tome of Insanity",
      name: "Rich Wilde and the Tome of Insanity",
    },
    ColtLightningFirestorm: {
      redirectUrl: "/casino/aggapplayngo-colt-lightning-firestorm",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ColtLightningFirestorm.webp",
      alt: "Colt Lightning Firestorm",
      name: "Colt Lightning Firestorm",
    },
    SparkOfGenius: {
      redirectUrl: "/casino/aggapplayngo-spark-of-genius",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SparkOfGenius.webp",
      alt: "Spark of Genius",
      name: "Spark of Genius",
    },
    WildSurvivor: {
      redirectUrl: "/casino/aggapplayngo-wild-survivor",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildSurvivor.webp",
      alt: "Wild Survivor",
      name: "Wild Survivor",
    },
    Fulong88: {
      redirectUrl: "/casino/aggapplayngo-fulong-88",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/Fulong88.webp",
      alt: "Fulong 88",
      name: "Fulong 88",
    },
    TheSwordAndTheGrailExcalibur: {
      redirectUrl: "/casino/aggapplayngo-the-sword-and-the-grail-excalibur",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TheSwordAndTheGrailExcalibur.webp",
      alt: "The Sword and the Grail Excalibur",
      name: "The Sword and the Grail Excalibur",
    },
    BoatBonanzaDownUnder: {
      redirectUrl: "/casino/aggapplayngo-boat-bonanza-down-under",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BoatBonanzaDownUnder.webp",
      alt: "Boat Bonanza Down Under",
      name: "Boat Bonanza Down Under",
    },
    TombOfGold: {
      redirectUrl: "/casino/aggapplayngo-tomb-of-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TombOfGold.webp",
      alt: "Tomb of Gold",
      name: "Tomb of Gold",
    },
    MysteryGenieFortunesOfTheLamp: {
      redirectUrl: "/casino/aggapplayngo-mystery-genie-fortunes-of-the-lamp",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MysteryGenieFortunesOfTheLamp.webp",
      alt: "Mystery Genie Fortunes of the Lamp",
      name: "Mystery Genie Fortunes of the Lamp",
    },
    EasterEggspedition: {
      redirectUrl: "/casino/aggapplayngo-easter-eggspedition",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/EasterEggspedition.webp",
      alt: "Easter Eggspedition",
      name: "Easter Eggspedition",
    },
    PiranhaPays: {
      redirectUrl: "/casino/aggapplayngo-piranha-pays",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PiranhaPays.webp",
      alt: "Piranha Pays",
      name: "Piranha Pays",
    },
    ChambersOfAncients: {
      redirectUrl: "/casino/aggapplayngo-chambers-of-ancients",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/ChambersOfAncients.webp",
      alt: "Chambers of Ancients",
      name: "Chambers of Ancients",
    },
    BanquetOfDead: {
      redirectUrl: "/casino/aggapplayngo-banquet-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BanquetOfDead.webp",
      alt: "Banquet of Dead",
      name: "Banquet of Dead",
    },
    LegionGoldUnleashed: {
      redirectUrl: "/casino/aggapplayngo-legion-gold-unleashed",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegionGoldUnleashed.webp",
      alt: "Legion Gold Unleashed",
      name: "Legion Gold Unleashed",
    },
    UndefeatedXerxes: {
      redirectUrl: "/casino/aggapplayngo-undefeated-xerxes",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/UndefeatedXerxes.webp",
      alt: "Undefeated Xerxes",
      name: "Undefeated Xerxes",
    },
    LadyOfFortuneRemastered: {
      redirectUrl: "/casino/aggapplayngo-lady-of-fortune-remastered",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LadyOfFortuneRemastered.webp",
      alt: "Lady of Fortune Remastered",
      name: "Lady of Fortune Remastered",
    },
    SteppingDiamonds: {
      redirectUrl: "/casino/aggapplayngo-stepping-diamonds",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/SteppingDiamonds.webp",
      alt: "Stepping Diamonds",
      name: "Stepping Diamonds",
    },
    BaronLordOfSaturday: {
      redirectUrl: "/casino/aggapplayngo-baron-lord-of-saturday",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BaronLordOfSaturday.webp",
      alt: "Baron Lord of Saturday",
      name: "Baron Lord of Saturday",
    },
    BeastsOfFireMaximum: {
      redirectUrl: "/casino/aggapplayngo-beasts-of-fire-maximum",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BeastsOfFireMaximum.webp",
      alt: "Beasts of Fire Maximum",
      name: "Beasts of Fire Maximum",
    },
    LegionGoldAndTheSphinxOfDead: {
      redirectUrl: "/casino/aggapplayngo-legion-gold-and-the-sphinx-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegionGoldAndTheSphinxOfDead.webp",
      alt: "Legion Gold and the Sphinx of Dead",
      name: "Legion Gold and the Sphinx of Dead",
    },
    PiggyBlitzDiscoGold: {
      redirectUrl: "/casino/aggapplayngo-piggy-blitz-disco-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PiggyBlitzDiscoGold.webp",
      alt: "Piggy Blitz Disco Gold",
      name: "Piggy Blitz Disco Gold",
    },
    RichWildeAndThePearlsOfVishnu: {
      redirectUrl: "/casino/aggapplayngo-rich-wilde-and-the-pearls-of-vishnu",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/RichWildeAndThePearlsOfVishnu.webp",
      alt: "Rich Wilde and the Pearls of Vishnu",
      name: "Rich Wilde and the Pearls of Vishnu",
    },
    BoatBonanzaChristmas: {
      redirectUrl: "/casino/aggapplayngo-boat-bonanza-christmas",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/BoatBonanzaChristmas.webp",
      alt: "Boat Bonanza Christmas",
      name: "Boat Bonanza Christmas",
    },
    WildestGambit: {
      redirectUrl: "/casino/aggapplayngo-wildest-gambit",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/WildestGambit.webp",
      alt: "Wildest Gambit",
      name: "Wildest Gambit",
    },
    LionSagaOdyssey: {
      redirectUrl: "/casino/aggapplayngo-lion-saga-odyssey",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LionSagaOdyssey.webp",
      alt: "Lion Saga Odyssey",
      name: "Lion Saga Odyssey",
    },
    HotDogHeist: {
      redirectUrl: "/casino/aggapplayngo-hot-dog-heist",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/HotDogHeist.webp",
      alt: "Hot Dog Heist",
      name: "Hot Dog Heist",
    },
    JollyRogerWildKraken: {
      redirectUrl: "/casino/aggapplayngo-jolly-roger-wild-kraken",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/JollyRogerWildKraken.webp",
      alt: "Jolly Roger Wild Kraken",
      name: "Jolly Roger Wild Kraken",
    },
    MidnightGold: {
      redirectUrl: "/casino/aggapplayngo-midnight-gold",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MidnightGold.webp",
      alt: "Midnight Gold",
      name: "Midnight Gold",
    },
    TreasuresOfKongar: {
      redirectUrl: "/casino/aggapplayngo-treasures-of-kongar",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TreasuresOfKongar.webp",
      alt: "Treasures of Kongar",
      name: "Treasures of Kongar",
    },
    TowerQuestLegacy: {
      redirectUrl: "/casino/aggapplayngo-tower-quest-legacy",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/TowerQuestLegacy.webp",
      alt: "Tower Quest Legacy",
      name: "Tower Quest Legacy",
    },
    LegacyOfGemsBlitzways: {
      redirectUrl: "/casino/aggapplayngo-legacy-of-gems-blitzways",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegacyOfGemsBlitzways.webp",
      alt: "Legacy of Gems Blitzways",
      name: "Legacy of Gems Blitzways",
    },
    PotionOfMadness: {
      redirectUrl: "/casino/aggapplayngo-potion-of-madness",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/PotionOfMadness.webp",
      alt: "Potion of Madness",
      name: "Potion of Madness",
    },
    InvadingVegasRevengeOnMars: {
      redirectUrl: "/casino/aggapplayngo-invading-vegas-revenge-on-mars",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/InvadingVegasRevengeOnMars.webp",
      alt: "Invading Vegas Revenge on Mars",
      name: "Invading Vegas Revenge on Mars",
    },
    CrystalHall: {
      redirectUrl: "/casino/aggapplayngo-crystal-hall",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/CrystalHall.webp",
      alt: "Crystal Hall",
      name: "Crystal Hall",
    },
    MythOfDead: {
      redirectUrl: "/casino/aggapplayngo-myth-of-dead",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/MythOfDead.webp",
      alt: "Myth of Dead",
      name: "Myth of Dead",
    },
    LegionGoldVictory: {
      redirectUrl: "/casino/aggapplayngo-legion-gold-victory",
      code: "",
      casino: "Play'n GO",
      provider: "ALT_GAMING_GAP",
      category: "playNGo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/play-n-go/LegionGoldVictory.webp",
      alt: "Legion Gold Victory",
      name: "Legion Gold Victory",
    },
  },

  relaxGaming: {
    MoneyTrain2: {
      redirectUrl: "/casino/qt-money-train-2",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyTrain2.webp",
      alt: "money train 2",
      name: "Money Train 2",
    },
    // SnakeArena: {
    //   redirectUrl: "/casino/qt-snake-arena",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/SnakeArena.webp",
    //   alt: "snake arena",
    //   name: "Snake Arena",
    // },
    TempleTumble: {
      redirectUrl: "/casino/qt-temple-tumble-megaways",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TempleTumbleMegaways.webp",
      alt: "temple tumble",
      name: "Temple Tumble",
    },
    SnakeArenaDreamDrop: {
      redirectUrl: "/casino/qt-snake-arena-dream-drop",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SnakeArenaDreamDrop.webp",
      alt: "snake arena dream drop",
      name: "Snake Arena Dream Drop",
    },
    BillAndCoin: {
      redirectUrl: "/casino/qt-bill-and-coin",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BillAndCoin.webp",
      alt: "bill and coin",
      name: "Bill & Coin",
    },
    LureOfFortune: {
      redirectUrl: "/casino/qt-lure-of-fortune",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/LureOfFortune.webp",
      alt: "lure of fortune",
      name: "Lure Of Fortune",
    },
    TitanStrike: {
      redirectUrl: "/casino/qt-titan-strike",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TitanStrike.webp",
      alt: "titan strike",
      name: "Titan Strike",
    },
    MoneyTrain4: {
      redirectUrl: "/casino/qt-money-train-4",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyTrain4.webp",
      alt: "money train 4",
      name: "Money Train 4",
    },
    JokerSplit: {
      redirectUrl: "/casino/qt-joker-split",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/JokerSplit.webp",
      alt: "joker split",
      name: "Joker Split",
    },
    ToriiTumble: {
      redirectUrl: "/casino/qt-torii-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/ToriiTumble.webp",
      alt: "torii tumble",
      name: "Torii Tumble",
    },
    SlothTumble: {
      redirectUrl: "/casino/qt-sloth-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SlothTumble.webp",
      alt: "sloth tumble",
      name: "Sloth Tumble",
    },
    SharkWash: {
      redirectUrl: "/casino/qt-shark-wash",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SharkWash.webp",
      alt: "shark wash",
      name: "Shark Wash",
    },
    BananaTown: {
      redirectUrl: "/casino/qt-banana-town",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BananaTown.webp",
      alt: "banana town",
      name: "Banana Town",
    },
    BeastMode: {
      redirectUrl: "/casino/qt-beast-mode",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BeastMode.webp",
      alt: "beast mode",
      name: "Beast Mode",
    },
    BlenderBlitz: {
      redirectUrl: "/casino/qt-blender-blitz",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BlenderBlitz.webp",
      alt: "blender blitz",
      name: "Blender Blitz",
    },
    BookOf99: {
      redirectUrl: "/casino/qt-book-of-99",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Bookof99.webp",
      alt: "book of 99",
      name: "Book of 99",
    },
    BookOfPower: {
      redirectUrl: "/casino/qt-book-of-power",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BookOfPower.webp",
      alt: "book of power",
      name: "Book Of Power",
    },
    CavemanBob: {
      redirectUrl: "/casino/qt-caveman-bob",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/CavemanBob.webp",
      alt: "caveman bob",
      name: "Caveman Bob",
    },
    ChipSpin: {
      redirectUrl: "/casino/qt-chip-spin",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/ChipSpin.webp",
      alt: "chip spin",
      name: "Chip Spin",
    },
    ClusterTumble: {
      redirectUrl: "/casino/qt-cluster-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/ClusterTumble.webp",
      alt: "cluster tumble",
      name: "Cluster Tumble",
    },
    DeadMansTrail: {
      redirectUrl: "/casino/qt-dead-mans-trail",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/DeadMansTrail.webp",
      alt: "dead mans trail",
      name: "Dead Man's Trail",
    },
    DeadRidersTrail: {
      redirectUrl: "/casino/qt-dead-riders-trail",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/DeadRidersTrail.webp",
      alt: "dead riders trail",
      name: "Dead Riders Trail",
    },
    DeepDescent: {
      redirectUrl: "/casino/qt-deep-descent",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/DeepDescent.webp",
      alt: "deep descent",
      name: "Deep Descent",
    },
    DragonsAwakening: {
      redirectUrl: "/casino/qt-dragons-awakening",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/DragonsAwakening.webp",
      alt: "dragons awakening",
      name: "Dragons Awakening",
    },
    EmeraldsInfinityReels: {
      redirectUrl: "/casino/qt-emeralds-infinity-reels",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/EmeraldsInfinityReels.webp",
      alt: "emeralds infinity reels",
      name: "Emerald's Infinity Reels",
    },
    ErikTheRed: {
      redirectUrl: "/casino/qt-erik-the-red",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/EriktheRed.webp",
      alt: "erik the red",
      name: "Erik the Red",
    },
    EpicJoker: {
      redirectUrl: "/casino/qt-epic-joker",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/EpicJoker.webp",
      alt: "epic joker",
      name: "Epic Joker",
    },
    FrequentFlyer: {
      redirectUrl: "/casino/qt-frequent-flyer",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/FrequentFlyer.webp",
      alt: "frequent flyer",
      name: "Frequent Flyer",
    },
    HazakuraWays: {
      redirectUrl: "/casino/qt-hazakura-ways",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/HazakuraWays.webp",
      alt: "hazakura ways",
      name: "Hazakura Ways",
    },
    HeliosFury: {
      redirectUrl: "/casino/qt-helios-fury",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/HeliosFury.webp",
      alt: "helios fury",
      name: "Helios' Fury",
    },
    Hellcatraz: {
      redirectUrl: "/casino/qt-hellcatraz",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Hellcatraz.webp",
      alt: "hellcatraz",
      name: "Hellcatraz",
    },
    HeroesGathering: {
      redirectUrl: "/casino/qt-heroes-gathering",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/HeroesGathering.webp",
      alt: "heroes gathering",
      name: "Heroes Gathering",
    },
    Hex: {
      redirectUrl: "/casino/qt-hex",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Hex.webp",
      alt: "hex",
      name: "Hex",
    },
    HorrorHotel: {
      redirectUrl: "/casino/qt-horror-hotel",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/HorrorHotel.webp",
      alt: "horror hotel",
      name: "Horror Hotel",
    },
    HotRodRacers: {
      redirectUrl: "/casino/qt-hot-rod-racers",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/HotRodRacers.webp",
      alt: "hot rod racers",
      name: "Hot Rod Racers",
    },
    IgniteTheNight: {
      redirectUrl: "/casino/qt-ignite-the-night",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/IgniteTheNight.webp",
      alt: "ignite the night",
      name: "Ignite The Night",
    },
    IronBank: {
      redirectUrl: "/casino/qt-iron-bank",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/IronBank.webp",
      alt: "iron bank",
      name: "Iron Bank",
    },
    ItsTime: {
      redirectUrl: "/casino/qt-its-time",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/ItsTime.webp",
      alt: "its time",
      name: "It's Time",
    },
    JurassicParty: {
      redirectUrl: "/casino/qt-jurassic-party",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/JurassicParty.webp",
      alt: "jurassic party",
      name: "Jurassic Party",
    },
    KingOfKings: {
      redirectUrl: "/casino/qt-king-of-kings",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/KingofKings.webp",
      alt: "king of kings",
      name: "King of Kings",
    },
    KlusterKrystalsMegaclusters: {
      redirectUrl: "/casino/qt-kluster-krystals-megaclusters",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/KlusterKrystalsMegaclusters.webp",
      alt: "kluster krystals megaclusters",
      name: "Kluster Krystals Megaclusters",
    },
    LaFiesta: {
      redirectUrl: "/casino/qt-la-fiesta",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/LaFiesta.webp",
      alt: "la fiesta",
      name: "La Fiesta",
    },
    LetsGetReadyToRumble: {
      redirectUrl: "/casino/qt-lets-get-ready-to-rumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/LetsgetreadytoRumble.webp",
      alt: "lets get ready to rumble",
      name: "Let's get ready to Rumble",
    },
    MarchingLegions: {
      redirectUrl: "/casino/qt-marching-legions",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MarchingLegions.webp",
      alt: "marching legions",
      name: "Marching Legions",
    },
    MegaFlip: {
      redirectUrl: "/casino/qt-mega-flip",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MegaFlip.webp",
      alt: "mega flip",
      name: "Mega Flip",
    },
    MegaHeist: {
      redirectUrl: "/casino/qt-mega-heist",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MegaHeist.webp",
      alt: "mega heist",
      name: "Mega Heist",
    },
    MegaMasks: {
      redirectUrl: "/casino/qt-mega-masks",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MegaMasks.webp",
      alt: "mega masks",
      name: "Mega Masks",
    },
    MegaMine: {
      redirectUrl: "/casino/qt-mega-mine",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MegaMine.webp",
      alt: "mega mine",
      name: "Mega Mine",
    },
    MidnightMarauder: {
      redirectUrl: "/casino/qt-midnight-marauder",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MidnightMarauder.webp",
      alt: "midnight marauder",
      name: "Midnight Marauder",
    },
    MoneyCart: {
      redirectUrl: "/casino/qt-money-cart",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyCart.webp",
      alt: "money cart",
      name: "Money Cart",
    },
    MoneyCart2: {
      redirectUrl: "/casino/qt-money-cart-2",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyCart2.webp",
      alt: "money cart 2",
      name: "Money Cart 2",
    },
    MoneyCart3: {
      redirectUrl: "/casino/qt-money-cart-3",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyCart3.webp",
      alt: "money cart 3",
      name: "Money Cart 3",
    },
    MoneyTrain: {
      redirectUrl: "/casino/qt-money-train",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyTrain.webp",
      alt: "money train",
      name: "Money Train",
    },
    MoneyTrain3: {
      redirectUrl: "/casino/qt-money-train-3",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MoneyTrain3.webp",
      alt: "money train 3",
      name: "Money Train 3",
    },
    MultiplierOdyssey: {
      redirectUrl: "/casino/qt-multiplier-odyssey",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MultiplierOdyssey.webp",
      alt: "multiplier odyssey",
      name: "Multiplier Odyssey",
    },
    NetGains: {
      redirectUrl: "/casino/qt-net-gains",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/NetGains.webp",
      alt: "net gains",
      name: "Net Gains",
    },
    Plunderland: {
      redirectUrl: "/casino/qt-plunderland",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Plunderland.webp",
      alt: "plunderland",
      name: "Plunderland",
    },
    Powerspin: {
      redirectUrl: "/casino/qt-powerspin",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Powerspin.webp",
      alt: "powerspin",
      name: "Powerspin",
    },
    RamsesRevenge: {
      redirectUrl: "/casino/qt-ramses-revenge",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/RamsesRevenge.webp",
      alt: "ramses revenge",
      name: "Ramses Revenge",
    },
    SailsOfFortune: {
      redirectUrl: "/casino/qt-sails-of-fortune",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SailsOfFortune.webp",
      alt: "sails of fortune",
      name: "Sails Of Fortune",
    },
    SantasStack: {
      redirectUrl: "/casino/qt-santas-stack",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SantasStack.webp",
      alt: "santas stack",
      name: "Santa's Stack",
    },
    SpaceMiners: {
      redirectUrl: "/casino/qt-space-miners",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SpaceMiners.webp",
      alt: "space miners",
      name: "Space Miners",
    },
    TemplarTumble: {
      redirectUrl: "/casino/qt-templar-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TemplarTumble.webp",
      alt: "templar tumble",
      name: "Templar Tumble",
    },
    SpiritOfTheBeast: {
      redirectUrl: "/casino/qt-spirit-of-the-beast",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SpiritoftheBeast.webp",
      alt: "spirit of the beast",
      name: "Spirit of the Beast",
    },
    // TheGreatPigsbyMegaways: {
    //   redirectUrl: "/casino/qt-the-great-pigsby-megaways",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/TheGreatPigsbyMegaways.webp",
    //   alt: "the great pigsby megaways",
    //   name: "The Great Pigsby Megaways",
    // },
    TheGreatPigsby: {
      redirectUrl: "/casino/qt-the-great-pigsby",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TheGreatPigsby.webp",
      alt: "the great pigsby",
      name: "The Great Pigsby",
    },
    TigerKingdomInfinityReels: {
      redirectUrl: "/casino/qt-tiger-kingdom-infinity-reels",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TigerKingdomInfinityReels.webp",
      alt: "tiger kingdom infinity reels",
      name: "Tiger Kingdom Infinity Reels",
    },
    TNTTumble: {
      redirectUrl: "/casino/qt-tnt-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TNTTumble.webp",
      alt: "tnt tumble",
      name: "TNT Tumble",
    },
    TopDawgs: {
      redirectUrl: "/casino/qt-top-dawgdollar",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TopDawg.webp",
      alt: "top dawg$",
      name: "Top Dawg$",
    },
    TowerTumble: {
      redirectUrl: "/casino/qt-tower-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TowerTumble.webp",
      alt: "tower tumble",
      name: "Tower Tumble",
    },
    TrollsGold: {
      redirectUrl: "/casino/qt-trolls-gold",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TrollsGold.webp",
      alt: "trolls gold",
      name: "Troll's Gold",
    },
    VolatileVikings: {
      redirectUrl: "/casino/qt-volatile-vikings",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/VolatileVikings.webp",
      alt: "volatile vikings",
      name: "Volatile Vikings",
    },
    WildChapo: {
      redirectUrl: "/casino/qt-wild-chapo",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/WildChapo.webp",
      alt: "wild chapo",
      name: "Wild Chapo",
    },
    WildChapo2: {
      redirectUrl: "/casino/qt-wild-chapo-2",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/WildChapo2.webp",
      alt: "wild chapo-2",
      name: "Wild Chapo 2",
    },
    Wildchemy: {
      redirectUrl: "/casino/qt-wildchemy",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/Wildchemy.webp",
      alt: "wildchemy",
      name: "Wildchemy",
    },
    WildHike: {
      redirectUrl: "/casino/qt-wild-hike",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/WildHike.webp",
      alt: "wild hike",
      name: "Wild Hike",
    },
    WildYield: {
      redirectUrl: "/casino/qt-wild-yield",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/WildYield.webp",
      alt: "wild yield",
      name: "Wild Yield",
    },
    ZombieCircus: {
      redirectUrl: "/casino/qt-zombie-circus",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/ZombieCircus.webp",
      alt: "zombie circus",
      name: "Zombie Circus",
    },
    BlackjackNeo: {
      redirectUrl: "/casino/qt-blackjack-neo",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/BlackjackNeo.webp",
      alt: "blackjack neo",
      name: "Blackjack Neo",
    },
    RouletteNouveau: {
      redirectUrl: "/casino/qt-roulette-nouveau",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/RouletteNouveau.webp",
      alt: "roulette nouveau",
      name: "Roulette Nouveau",
    },
    MONEYCART4: {
      redirectUrl: "/casino/qt-money-cart-4",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/MONEYCART4.webp",
      alt: "money cart 4",
      name: "MONEY CART 4",
    },
    SWEETOPIAROYALE: {
      redirectUrl: "/casino/qt-sweetopia-royale",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/SWEETOPIAROYALE.webp",
      alt: "sweetopia royale",
      name: "SWEETOPIA ROYALE",
    },
    FIREWINSFACTORY: {
      redirectUrl: "/casino/qt-firewins-factory",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/FIREWINSFACTORY.webp",
      alt: "firewins factory",
      name: "Firewins Factory",
    },
    // HeroesHunt2MegawaysXmasVersion: {
    //   redirectUrl: "/casino/qt-heroes-hunt-2-megaways-xmas-version",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "./images/slots/relax-gaming/HeroesHunt2MegawaysXmasVersion.webp",
    //   alt: "heroes hunt 2 megaways - xmas version",
    //   name: "Heroes Hunt 2 Megaways - Xmas Version",
    // },
    TheGreatPigsbyMegapays: {
      redirectUrl: "/casino/qt-the-great-pigsby-megapays",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/TheGreatPigsbyMegapays.webp",
      alt: "the great pigsby megapays",
      name: "The Great Pigsby Megapays",
    },
    // VolatileVikings2DreamDrop: {
    //   redirectUrl: "/casino/qt-volatile-vikings-2-dream-drop",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/VolatileVikings2DreamDrop.webp",
    //   alt: "volatile vikings 2 dream drop",
    //   name: "Volatile Vikings 2 Dream Drop",
    // },
    // TntTumbleDreamDrop: {
    //   redirectUrl: "/casino/qt-tnt-tumble-dream-drop",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/TntTumbleDreamDrop.webp",
    //   alt: "tnt tumble dream drop",
    //   name: "Tnt Tumble Dream Drop",
    // },
    // NekoNightDreamDrop: {
    //   redirectUrl: "/casino/qt-neko-night-dream-drop",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/NekoNightDreamDrop.webp",
    //   alt: "neko night dream drop",
    //   name: "Neko Night Dream Drop",
    // },
    // WildChapoDreamDrop: {
    //   redirectUrl: "/casino/qt-wild-chapo-dream-drop",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/WildChapoDreamDrop.webp",
    //   alt: "wild chapo dream drop",
    //   name: "Wild Chapo Dream Drop",
    // },
    // TheTumbles: {
    //   redirectUrl: "/casino/qtechrelaxgaming-the-tumbles",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/TheTumbles.webp",
    //   alt: "the tumbles",
    //   name: "The Tumbles",
    // },
    // BoneRaiders: {
    //   redirectUrl: "/casino/qtechrelaxgaming-bone-raiders",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/BoneRaiders.webp",
    //   alt: "bone raiders",
    //   name: "Bone Raiders",
    // },
    AtlantisCrush: {
      redirectUrl: "/casino/qt-atlantis-crush",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/AtlantisCrush.webp",
      alt: "atlantis crush",
      name: "Atlantis Crush",
    },
    AncientTumble: {
      redirectUrl: "/casino/qt-ancient-tumble",
      code: "",
      casino: "Relax Gaming",
      provider: "WorldCasino",
      category: "relaxGaming",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/relax-gaming/AncientTumble.webp",
      alt: "ancient tumble",
      name: "Ancient Tumble",
    },
    // EpicDreams: {
    //   redirectUrl: "/casino/qtechrelaxgaming-epic-dreams",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/EpicDreams.webp",
    //   alt: "epic dreams",
    //   name: "Epic Dreams",
    // },
    // SultanSpins: {
    //   redirectUrl: "/casino/qtechrelaxgaming-sultan-spins",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/SultanSpins.webp",
    //   alt: "sultan spins",
    //   name: "Sultan Spins",
    // },
    // QuackinReels: {
    //   redirectUrl: "/casino/qtechrelaxgaming-quackin-reels",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/QuackinReels.webp",
    //   alt: "quackin reels",
    //   name: "Quackin' Reels",
    // },
    // FeatherFury: {
    //   redirectUrl: "/casino/qtechrelaxgaming-feather-fury",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/FeatherFury.webp",
    //   alt: "feather fury",
    //   name: "Feather Fury",
    // },
    // MoneySleigh: {
    //   redirectUrl: "/casino/qtechrelaxgaming-money-sleigh",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/MoneySleigh.webp",
    //   alt: "money sleigh",
    //   name: "Money Sleigh",
    // },
    // WinterChampions: {
    //   redirectUrl: "/casino/qtechrelaxgaming-winter-champions",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/WinterChampions.webp",
    //   alt: "winter champions",
    //   name: "Winter Champions",
    // },
    // Immortal5: {
    //   redirectUrl: "/casino/qtechrelaxgaming-immortal-5",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/Immortal5.webp",
    //   alt: "immortal 5",
    //   name: "Immortal 5",
    // },
    // KrakensCove: {
    //   redirectUrl: "/casino/qtechrelaxgaming-krakens-cove",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/KrakensCove.webp",
    //   alt: "krakens cove",
    //   name: "Kraken's Cove",
    // },
    // CamelotCash: {
    //   redirectUrl: "/casino/qtechrelaxgaming-camelot-cash",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "WorldCasino",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/CamelotCash.webp",
    //   alt: "camelot cash",
    //   name: "Camelot Cash",
    // },
    // GiantsAndSheep: {
    //   redirectUrl: "/casino/qtechrelaxgaming-giants-and-sheep",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/GiantsAndSheep.webp",
    //   alt: "giants and sheep",
    //   name: "Giants & Sheep",
    // },
    // GlyphOfGods: {
    //   redirectUrl: "/casino/qtechrelaxgaming-glyph-of-gods",
    //   code: "",
    //   casino: "Relax Gaming",
    //   provider: "QTECH",
    //   category: "relaxGaming",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/relax-gaming/GlyphofGods.webp",
    //   alt: "glyph of gods",
    //   name: "Glyph of Gods",
    // },
  },

  habanero: {
    HotHotFruit: {
      redirectUrl: "/casino/qt-hot-hot-fruit",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HotHotFruit.webp",
      alt: "Hot Hot Fruit",
      name: "Hot Hot Fruit",
    },
    Lucky5Lions: {
      redirectUrl: "/casino/qt-5-lucky-lions",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/5LuckyLions.webp",
      alt: "5 Lucky Lions",
      name: "5 Lucky Lions",
    },
    LondonHunter: {
      redirectUrl: "/casino/qt-london-hunter",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LondonHunter.webp",
      alt: "London Hunter",
      name: "London Hunter",
    },
    FruityMayan: {
      redirectUrl: "/casino/qt-fruity-mayan",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FruityMayan.webp",
      alt: "Fruity Mayan",
      name: "Fruity Mayan",
    },
    SantasInn: {
      redirectUrl: "/casino/qt-santas-inn",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SantasInn.webp",
      alt: "Santa's Inn",
      name: "Santa's Inn",
    },
    // ZeusDeluxe: {
    //   redirectUrl: "/casino/qt-zeus-deluxe",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "habanero",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/ZeusDeluxe.webp",
    //   alt: "Zeus Deluxe",
    //   name: "Zeus Deluxe",
    // },
    FruityHalloween: {
      redirectUrl: "/casino/qt-fruity-halloween",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FruityHalloween.webp",
      alt: "Fruity Halloween",
      name: "Fruity Halloween",
    },
    SlimeParty: {
      redirectUrl: "/casino/qt-slime-party",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SlimeParty.webp",
      alt: "Slime Party",
      name: "Slime Party",
    },
    MeowJanken: {
      redirectUrl: "/casino/qt-meow-janken",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MeowJanken.webp",
      alt: "Meow Janken",
      name: "Meow Janken",
    },
    BikiniIslandDeluxe: {
      redirectUrl: "/casino/qt-bikini-island-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BikiniIslandDeluxe.webp",
      alt: "Bikini Island Deluxe",
      name: "Bikini Island Deluxe",
    },
    AtomicKittens: {
      redirectUrl: "/casino/qt-atomic-kittens",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/AtomicKittens.webp",
      alt: "Atomic Kittens",
      name: "Atomic Kittens",
    },
    WitchesTome: {
      redirectUrl: "/casino/qt-witches-tome",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WitchesTome.webp",
      alt: "Witches Tome",
      name: "Witches Tome",
    },
    LegendOfNezha: {
      redirectUrl: "/casino/qt-legend-of-nezha",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LegendOfNezha.webp",
      alt: "Legend Of Nezha",
      name: "Legend Of Nezha",
    },
    TootyFruityFruits: {
      redirectUrl: "/casino/qt-tooty-fruity-fruits",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TootyFruityFruits.webp",
      alt: "Tooty Fruity Fruits",
      name: "Tooty Fruity Fruits",
    },
    SirensSpell: {
      redirectUrl: "/casino/qt-sirenaeurotms-spell",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SirensSpell.webp",
      alt: "Siren’s Spell",
      name: "Siren’s Spell",
    },
    Crystopia: {
      redirectUrl: "/casino/qt-crystopia",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Crystopia.webp",
      alt: "Crystopia",
      name: "Crystopia",
    },
    Mariachis5: {
      redirectUrl: "/casino/qt-5-mariachis",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/5Mariachis.webp",
      alt: "5 Mariachis",
      name: "5 Mariachis",
    },
    Zodiacs12: {
      redirectUrl: "/casino/qt-12-zodiacs",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/12Zodiacs.webp",
      alt: "12 Zodiacs",
      name: "12 Zodiacs",
    },
    ArcaneElements: {
      redirectUrl: "/casino/qt-arcane-elements",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ArcaneElements.webp",
      alt: "Arcane Elements",
      name: "Arcane Elements",
    },
    BeforeTimeRunsOut: {
      redirectUrl: "/casino/qt-before-time-runs-out",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BeforeTimeRunsOut.webp",
      alt: "Before Time Runs Out",
      name: "Before Time Runs Out",
    },
    BirdOfThunder: {
      redirectUrl: "/casino/qt-bird-of-thunder",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BirdofThunder.webp",
      alt: "Bird of Thunder",
      name: "Bird of Thunder",
    },
    BombRunner: {
      redirectUrl: "/casino/qt-bomb-runner",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BombRunner.webp",
      alt: "Bomb Runner",
      name: "Bomb Runner",
    },
    BombsAway: {
      redirectUrl: "/casino/qt-bombs-away",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BombsAway.webp",
      alt: "Bombs Away",
      name: "Bombs Away",
    },
    CalaverasExplosivas: {
      redirectUrl: "/casino/qt-calaveras-explosivas",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CalaverasExplosivas.webp",
      alt: "Calaveras Explosivas",
      name: "Calaveras Explosivas",
    },
    CakeValley: {
      redirectUrl: "/casino/qt-cake-valley",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CakeValley.webp",
      alt: "Cake Valley",
      name: "Cake Valley",
    },
    CandyTower: {
      redirectUrl: "/casino/qt-candy-tower",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CandyTower.webp",
      alt: "Candy Tower",
      name: "Candy Tower",
    },
    ChristmasGiftRush: {
      redirectUrl: "/casino/qt-christmas-gift-rush",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ChristmasGiftRush.webp",
      alt: "Christmas Gift Rush",
      name: "Christmas Gift Rush",
    },
    ColossalGems: {
      redirectUrl: "/casino/qt-colossal-gems",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ColossalGems.webp",
      alt: "Colossal Gems",
      name: "Colossal Gems",
    },
    CoyoteCrash: {
      redirectUrl: "/casino/qt-coyote-crash",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CoyoteCrash.webp",
      alt: "Coyote Crash",
      name: "Coyote Crash",
    },
    DiscoBeats: {
      redirectUrl: "/casino/qt-disco-beats",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DiscoBeats.webp",
      alt: "Disco Beats",
      name: "Disco Beats",
    },
    DragonCastle: {
      redirectUrl: "/casino/qt-dragon-castle",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DragonCastle.webp",
      alt: "Dragon Castle",
      name: "Dragon Castle",
    },
    DragonsRealm: {
      redirectUrl: "/casino/qt-dragons-realm",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DragonsRealm.webp",
      alt: "Dragon's Realm",
      name: "Dragon's Realm",
    },
    DragonsThrone: {
      redirectUrl: "/casino/qt-dragons-throne",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DragonsThrone.webp",
      alt: "Dragon’s Throne",
      name: "Dragon’s Throne",
    },
    DragonTigerGate: {
      redirectUrl: "/casino/qt-dragon-tiger-gate",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DragonTigerGate.webp",
      alt: "Dragon Tiger Gate",
      name: "Dragon Tiger Gate",
    },
    EgyptianDreamsDeluxe: {
      redirectUrl: "/casino/qt-egyptian-dreams-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/EgyptianDreamsDeluxe.webp",
      alt: "Egyptian Dreams Deluxe",
      name: "Egyptian Dreams Deluxe",
    },
    FaCaiShen: {
      redirectUrl: "/casino/qt-fa-cai-shen",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FaCaiShen.webp",
      alt: "Fa Cai Shen",
      name: "Fa Cai Shen",
    },
    FaCaiShenDeluxe: {
      redirectUrl: "/casino/qt-fa-cai-shen-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FaCaiShenDeluxe.webp",
      alt: "Fa Cai Shen Deluxe",
      name: "Fa Cai Shen Deluxe",
    },
    Fenghuang: {
      redirectUrl: "/casino/qt-fenghuang",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Fenghuang.webp",
      alt: "Fenghuang",
      name: "Fenghuang",
    },
    FireRooster: {
      redirectUrl: "/casino/qt-fire-rooster",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FireRooster.webp",
      alt: "Fire Rooster",
      name: "Fire Rooster",
    },
    Fly: {
      redirectUrl: "/casino/qt-fly-jet",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Fly.webp",
      alt: "Fly",
      name: "Fly",
    },
    FortuneDogs: {
      redirectUrl: "/casino/qt-fortune-dogs",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FortuneDogs.webp",
      alt: "Fortune Dogs",
      name: "Fortune Dogs",
    },
    FourDivineBeasts: {
      redirectUrl: "/casino/qt-four-divine-beasts",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/FourDivineBeasts.webp",
      alt: "Four Divine Beasts",
      name: "Four Divine Beasts",
    },
    Gangsters: {
      redirectUrl: "/casino/qt-gangsters",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Gangsters.webp",
      alt: "Gangsters",
      name: "Gangsters",
    },
    GoldenUnicornDeluxe: {
      redirectUrl: "/casino/qt-golden-unicorn-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/GoldenUnicornDeluxe.webp",
      alt: "Golden Unicorn Deluxe",
      name: "Golden Unicorn Deluxe",
    },
    GoldRush: {
      redirectUrl: "/casino/qt-gold-rush",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/GoldRush.webp",
      alt: "Gold Rush",
      name: "Gold Rush",
    },
    HappiestChristmasTree: {
      redirectUrl: "/casino/qt-happiest-christmas-tree",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HappiestChristmasTree.webp",
      alt: "Happiest Christmas Tree",
      name: "Happiest Christmas Tree",
    },
    HappyApe: {
      redirectUrl: "/casino/qt-happy-ape",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HappyApe.webp",
      alt: "Happy Ape",
      name: "Happy Ape",
    },
    HeySushi: {
      redirectUrl: "/casino/qt-hey-sushi",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HeySushi.webp",
      alt: "Hey Sushi",
      name: "Hey Sushi",
    },
    HotHotHalloween: {
      redirectUrl: "/casino/qt-hot-hot-halloween",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HotHotHalloween.webp",
      alt: "Hot Hot Halloween",
      name: "Hot Hot Halloween",
    },
    IndianCashCatcher: {
      redirectUrl: "/casino/qt-indian-cash-catcher",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/IndianCashCatcher.webp",
      alt: "Indian Cash Catcher",
      name: "Indian Cash Catcher",
    },
    JellyfishFlow: {
      redirectUrl: "/casino/qt-jellyfish-flow",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/JellyfishFlow.webp",
      alt: "Jellyfish Flow",
      name: "Jellyfish Flow",
    },
    JellyFishFlowUltra: {
      redirectUrl: "/casino/qt-jellyfish-flow-ultra",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/JellyFishFlowUltra.webp",
      alt: "JellyFish Flow Ultra",
      name: "JellyFish Flow Ultra",
    },
    Jugglenaut: {
      redirectUrl: "/casino/qt-jugglenaut",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Jugglenaut.webp",
      alt: "Jugglenaut",
      name: "Jugglenaut",
    },
    Jump: {
      redirectUrl: "/casino/qt-jump",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Jump.webp",
      alt: "Jump",
      name: "Jump",
    },
    KnockoutFootball: {
      redirectUrl: "/casino/qt-knockout-football",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/KnockoutFootball.webp",
      alt: "Knockout Football",
      name: "Knockout Football",
    },
    KnockoutFootballRush: {
      redirectUrl: "/casino/qt-knockout-football-rush",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/KnockoutFootballRush.webp",
      alt: "Knockout Football Rush",
      name: "Knockout Football Rush",
    },
    KoiGate: {
      redirectUrl: "/casino/qt-koi-gate",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/KoiGate.webp",
      alt: "Koi Gate",
      name: "Koi Gate",
    },
    LanternLuck: {
      redirectUrl: "/casino/qt-lantern-luck",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LanternLuck.webp",
      alt: "Lantern Luck",
      name: "Lantern Luck",
    },
    LaughingBuddha: {
      redirectUrl: "/casino/qt-laughing-buddha",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LaughingBuddha.webp",
      alt: "Laughing Buddha",
      name: "Laughing Buddha",
    },
    LegendaryBeasts: {
      redirectUrl: "/casino/qt-legendary-beasts",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LegendaryBeasts.webp",
      alt: "Legendary Beasts",
      name: "Legendary Beasts",
    },
    LoonyBlox: {
      redirectUrl: "/casino/qt-loony-blox",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LoonyBlox.webp",
      alt: "Loony Blox",
      name: "Loony Blox",
    },
    LuckyDurian: {
      redirectUrl: "/casino/qt-lucky-durian",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LuckyDurian.webp",
      alt: "Lucky Durian",
      name: "Lucky Durian",
    },
    LuckyFortuneCat: {
      redirectUrl: "/casino/qt-lucky-fortune-cat",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LuckyFortuneCat.webp",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
    },
    LuckyLucky: {
      redirectUrl: "/casino/qt-lucky-lucky",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/LuckyLucky.webp",
      alt: "Lucky Lucky",
      name: "Lucky Lucky",
    },
    MagicOak: {
      redirectUrl: "/casino/qt-magic-oak",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MagicOak.webp",
      alt: "Magic Oak",
      name: "Magic Oak",
    },
    MarvelousFurlongs: {
      redirectUrl: "/casino/qt-marvelous-furlongs",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MarvelousFurlongs.webp",
      alt: "Marvelous Furlongs",
      name: "Marvelous Furlongs",
    },
    MightyMedusa: {
      redirectUrl: "/casino/qt-mighty-medusa",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MightyMedusa.webp",
      alt: "Mighty Medusa",
      name: "Mighty Medusa",
    },
    MonsterMashCash: {
      redirectUrl: "/casino/qt-monster-mash-cash",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MonsterMashCash.webp",
      alt: "Monster Mash Cash",
      name: "Monster Mash Cash",
    },
    MountMazuma: {
      redirectUrl: "/casino/qt-mount-mazuma",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MountMazuma.webp",
      alt: "Mount Mazuma",
      name: "Mount Mazuma",
    },
    MysticFortune: {
      redirectUrl: "/casino/qt-mystic-fortune",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MysticFortune.webp",
      alt: "Mystic Fortune",
      name: "Mystic Fortune",
    },
    MysticFortuneDeluxe: {
      redirectUrl: "/casino/qt-mystic-fortune-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MysticFortuneDeluxe.webp",
      alt: "Mystic Fortune Deluxe",
      name: "Mystic Fortune Deluxe",
    },
    NaughtySanta: {
      redirectUrl: "/casino/qt-naughty-santa",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/NaughtySanta.webp",
      alt: "Naughty Santa",
      name: "Naughty Santa",
    },
    NaughtyWukong: {
      redirectUrl: "/casino/qt-naughty-wukong",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/NaughtyWukong.webp",
      alt: "Naughty Wukong",
      name: "Naughty Wukong",
    },
    NewYearsBash: {
      redirectUrl: "/casino/qt-new-years-bash",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/NewYearsBash.webp",
      alt: "New Year's Bash",
      name: "New Year's Bash",
    },
    NineTails: {
      redirectUrl: "/casino/qt-nine-tails",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/NineTails.webp",
      alt: "Nine Tails",
      name: "Nine Tails",
    },
    Nuwa: {
      redirectUrl: "/casino/qt-nuwa",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Nuwa.webp",
      alt: "Nuwa",
      name: "Nuwa",
    },
    OrbsOfAtlantis: {
      redirectUrl: "/casino/qt-orbs-of-atlantis",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/OrbsOfAtlantis.webp",
      alt: "Orbs Of Atlantis",
      name: "Orbs Of Atlantis",
    },
    OceansCall: {
      redirectUrl: "/casino/qt-oceans-call",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/OceansCall.webp",
      alt: "Ocean's Call",
      name: "Ocean's Call",
    },
    PandaPanda: {
      redirectUrl: "/casino/qt-panda-panda",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/PandaPanda.webp",
      alt: "Panda Panda",
      name: "Panda Panda",
    },
    PoolShark: {
      redirectUrl: "/casino/qt-pool-shark",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/PoolShark.webp",
      alt: "Pool Shark",
      name: "Pool Shark",
    },
    Presto: {
      redirectUrl: "/casino/qt-presto",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Presto.webp",
      alt: "Presto",
      name: "Presto",
    },
    Prost: {
      redirectUrl: "/casino/qt-prost",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Prost.webp",
      alt: "Prost",
      name: "Prost",
    },
    PuckerUpPrince: {
      redirectUrl: "/casino/qt-pucker-up-prince",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/PuckerUpPrince.webp",
      alt: "Pucker Up Prince",
      name: "Pucker Up Prince",
    },
    PumpkinPatch: {
      redirectUrl: "/casino/qt-pumpkin-patch",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/PumpkinPatch.webp",
      alt: "Pumpkin Patch",
      name: "Pumpkin Patch",
    },
    RainbowMania: {
      redirectUrl: "/casino/qt-rainbow-mania",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/RainbowMania.webp",
      alt: "Rainbow Mania",
      name: "Rainbow Mania",
    },
    ReturnToTheFeature: {
      redirectUrl: "/casino/qt-return-to-the-feature",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ReturnToTheFeature.webp",
      alt: "Return To The Feature",
      name: "Return To The Feature",
    },
    RollingRoger: {
      redirectUrl: "/casino/qt-rolling-roger",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/RollingRoger.webp",
      alt: "Rolling Roger",
      name: "Rolling Roger",
    },
    RomanEmpire: {
      redirectUrl: "/casino/qt-roman-empire",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/RomanEmpire.webp",
      alt: "Roman Empire",
      name: "Roman Empire",
    },
    RuffledUp: {
      redirectUrl: "/casino/qt-ruffled-up",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/RuffledUp.webp",
      alt: "Ruffled Up",
      name: "Ruffled Up",
    },
    SantasVillage: {
      redirectUrl: "/casino/qt-santas-village",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SantasVillage.webp",
      alt: "Santa’s Village",
      name: "Santa’s Village",
    },
    Scopa: {
      redirectUrl: "/casino/qt-scopa",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Scopa.webp",
      alt: "Scopa",
      name: "Scopa",
    },
    ScruffyScallywags: {
      redirectUrl: "/casino/qt-scruffy-scallywags",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ScruffyScallywags.webp",
      alt: "Scruffy Scallywags",
      name: "Scruffy Scallywags",
    },
    ShaolinFortunes: {
      redirectUrl: "/casino/qt-shaolin-fortunes",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ShaolinFortunes.webp",
      alt: "Shaolin Fortunes",
      name: "Shaolin Fortunes",
    },
    SojuBomb: {
      redirectUrl: "/casino/qt-soju-bomb",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SojuBomb.webp",
      alt: "Soju Bomb",
      name: "Soju Bomb",
    },
    SOS: {
      redirectUrl: "/casino/qt-sos",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SOS.webp",
      alt: "S.O.S!",
      name: "S.O.S!",
    },
    SpaceGoonz: {
      redirectUrl: "/casino/qt-space-goonz",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SpaceGoonz.webp",
      alt: "Space Goonz",
      name: "Space Goonz",
    },
    Sparta: {
      redirectUrl: "/casino/qt-sparta",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Sparta.webp",
      alt: "Sparta",
      name: "Sparta",
    },
    SuperStrike: {
      redirectUrl: "/casino/qt-super-strike",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SuperStrike.webp",
      alt: "Super Strike",
      name: "Super Strike",
    },
    SuperTwister: {
      redirectUrl: "/casino/qt-super-twister",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/SuperTwister.webp",
      alt: "Super Twister",
      name: "Super Twister",
    },
    TabernaDeLosMuertos: {
      redirectUrl: "/casino/qt-taberna-de-los-muertos",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TabernaDeLosMuertos.webp",
      alt: "Taberna De Los Muertos",
      name: "Taberna De Los Muertos",
    },
    TabernaDeLosMuertosUltra: {
      redirectUrl: "/casino/qt-taberna-de-los-muertos-ultra",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TabernaDeLosMuertosUltra.webp",
      alt: "Taberna De Los Muertos Ultra",
      name: "Taberna De Los Muertos Ultra",
    },
    TaikoBeats: {
      redirectUrl: "/casino/qt-taiko-beats",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TaikoBeats.webp",
      alt: "Taiko Beats",
      name: "Taiko Beats",
    },
    TechnoTumble: {
      redirectUrl: "/casino/qt-techno-tumble",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TechnoTumble.webp",
      alt: "Techno Tumble",
      name: "Techno Tumble",
    },
    TheBigDealDeluxe: {
      redirectUrl: "/casino/qt-the-big-deal-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TheBigDealDeluxe.webp",
      alt: "The Big Deal Deluxe",
      name: "The Big Deal Deluxe",
    },
    TheDeadEscape: {
      redirectUrl: "/casino/qt-the-dead-escape",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TheDeadEscape.webp",
      alt: "The Dead Escape",
      name: "The Dead Escape",
    },
    TotemTowers: {
      redirectUrl: "/casino/qt-totem-towers",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TotemTowers.webp",
      alt: "Totem Towers",
      name: "Totem Towers",
    },
    TukTukThailand: {
      redirectUrl: "/casino/qt-tuk-tuk-thailand",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TukTukThailand.webp",
      alt: "Tuk Tuk Thailand",
      name: "Tuk Tuk Thailand",
    },
    WaysOfFortune: {
      redirectUrl: "/casino/qt-ways-of-fortune",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WaysOfFortune.webp",
      alt: "Ways Of Fortune",
      name: "Ways Of Fortune",
    },
    WealthInn: {
      redirectUrl: "/casino/qt-wealth-inn",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WealthInn.webp",
      alt: "Wealth Inn",
      name: "Wealth Inn",
    },
    WickedWitch: {
      redirectUrl: "/casino/qt-wicked-witch",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WickedWitch.webp",
      alt: "Wicked Witch",
      name: "Wicked Witch",
    },
    WildTrucks: {
      redirectUrl: "/casino/qt-wild-trucks",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WildTrucks.webp",
      alt: "Wild Trucks",
      name: "Wild Trucks",
    },
    WizardsWantWar: {
      redirectUrl: "/casino/qt-wizards-want-war",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WizardsWantWar.webp",
      alt: "Wizards Want War",
      name: "Wizards Want War",
    },
    Zeus: {
      redirectUrl: "/casino/qt-zeus",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Zeus.webp",
      alt: "Zeus",
      name: "Zeus",
    },
    Hand3Blackjack: {
      redirectUrl: "/casino/qt-3-hand-blackjack",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/3HandBlackjack.webp",
      alt: "3 Hand Blackjack",
      name: "3 Hand Blackjack",
    },
    Hand3BlackjackDoubleExposure: {
      redirectUrl: "/casino/qt-3-hand-blackjack-double-exposure",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/3HandBlackjackDoubleExposure.webp",
      alt: "3 Hand Blackjack Double Exposure",
      name: "3 Hand Blackjack Double Exposure",
    },
    AmericanBlackjack: {
      redirectUrl: "/casino/qt-american-blackjack",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/AmericanBlackjack.webp",
      alt: "American Blackjack",
      name: "American Blackjack",
    },
    Baccarat: {
      redirectUrl: "/casino/qt-baccarat",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
    },
    BaccaratZeroCommission: {
      redirectUrl: "/casino/qt-baccarat-zero-commission",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/BaccaratZeroCommission.webp",
      alt: "Baccarat Zero Commission",
      name: "Baccarat Zero Commission",
    },
    CaribbeanHoldem: {
      redirectUrl: "/casino/qt-caribbean-holdem",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CaribbeanHoldem.webp",
      alt: "Caribbean Holdem",
      name: "Caribbean Holdem",
    },
    CaribbeanStud: {
      redirectUrl: "/casino/qt-caribbean-stud",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/CaribbeanStud.webp",
      alt: "Caribbean Stud",
      name: "Caribbean Stud",
    },
    DragonTiger: {
      redirectUrl: "/casino/qt-dragon-tiger",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    EuropeanRoulette: {
      redirectUrl: "/casino/qt-european-roulette",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/EuropeanRoulette.webp",
      alt: "European Roulette",
      name: "European Roulette",
    },
    SicBo: {
      redirectUrl: "/casino/qt-sic-bo",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Sicbo.webp",
      alt: "Sic Bo",
      name: "Sic Bo",
    },
    ThreeCardPoker: {
      redirectUrl: "/casino/qt-three-card-poker",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ThreeCardPoker.webp",
      alt: "Three Card Poker",
      name: "Three Card Poker",
    },
    ThreeCardPokerDeluxe: {
      redirectUrl: "/casino/qt-three-card-poker-deluxe",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ThreeCardPokerDeluxe.webp",
      alt: "Three Card Poker Deluxe",
      name: "Three Card Poker Deluxe",
    },
    War: {
      redirectUrl: "/casino/qt-war",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/War.webp",
      alt: "War",
      name: "War",
    },
    ValentineMonchy: {
      redirectUrl: "/casino/qt-valentine-monchy",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ValentineMonchy.webp",
      alt: "Valentine Monchy",
      name: "Valentine Monchy",
    },
    HotHotSummer: {
      redirectUrl: "/casino/qt-hot-hot-summer",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/HotHotSummer.webp",
      alt: "Hot Hot Summer",
      name: "Hot Hot Summer",
    },
    // HauntedHarbor: {
    //   redirectUrl: "/casino/aggaphabanero-haunted-harbor",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "habanero",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/HauntedHarbor.webp",
    //   alt: "Haunted Harbor",
    //   name: "Haunted Harbor",
    // },
    // GloryOfRome: {
    //   redirectUrl: "/casino/aggaphabanero-glory-of-rome",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "habanero",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/GloryofRome.webp",
    //   alt: "Glory of Rome",
    //   name: "Glory of Rome",
    // },
    KoiKoiTreasure: {
      redirectUrl: "/casino/qt-koi-koi-treasure",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/KoiKoiTreasure.webp",
      alt: "Koi-Koi Treasure",
      name: "Koi-Koi Treasure",
    },
    WaltzBeauty: {
      redirectUrl: "/casino/qt-waltz-beauty",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WaltzBeauty.webp",
      alt: "Waltz Beauty",
      name: "Waltz Beauty",
    },
    TotemWarrior: {
      redirectUrl: "/casino/qt-totem-warrior",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/TotemWarrior.webp",
      alt: "Totem Warrior",
      name: "Totem Warrior",
    },
    ArcticHunt: {
      redirectUrl: "/casino/qt-arctic-hunt",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/ArcticHunt.webp",
      alt: "Arctic Hunt",
      name: "Arctic Hunt",
    },
    MooMooCow: {
      redirectUrl: "/casino/qt-moo-moo-cow",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/MooMooCow.webp",
      alt: "Moo Moo Cow",
      name: "Moo Moo Cow",
    },
    GoldenTajMahal: {
      redirectUrl: "/casino/qt-golden-taj-mahal",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/GoldenTajMahal.webp",
      alt: "Golden Taj Mahal",
      name: "Golden Taj Mahal",
    },
    WildFlow: {
      redirectUrl: "/casino/qt-wild-flow",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/WildFlow.webp",
      alt: "Wild Flow",
      name: "Wild Flow",
    },
    VampiresFate: {
      redirectUrl: "/casino/qt-vampires-fate",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/VampiresFate.webp",
      alt: "Vampire's Fate",
      name: "Vampire's Fate",
    },
    Jump2: {
      redirectUrl: "/casino/qt-jump-high-2",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Jump2.webp",
      alt: "Jump! 2",
      name: "Jump! 2",
    },
    Poseidon: {
      redirectUrl: "/casino/qt-poseidon",
      code: "",
      casino: "Habanero",
      provider: "WorldCasino",
      category: "habanero",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/habanero/Poseidon.webp",
      alt: "Poseidon",
      name: "Poseidon",
    },
    // BabaYaga: {
    //   redirectUrl: "/casino/aggaphabanero-baba-yaga",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/BabaYaga.webp",
    //   alt: "Baba Yaga",
    //   name: "Baba Yaga",
    // },
    // CarnivalCove: {
    //   redirectUrl: "/casino/aggaphabanero-carnival-cove",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/CarnivalCove.webp",
    //   alt: "Carnival Cove",
    //   name: "Carnival Cove",
    // },
    // HyperHues: {
    //   redirectUrl: "/casino/aggaphabanero-hyper-hues",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/HyperHues.webp",
    //   alt: "Hyper Hues",
    //   name: "Hyper Hues",
    // },
    // JapaneseMask: {
    //   redirectUrl: "/casino/aggaphabanero-japanese-mask",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/JapaneseMask.webp",
    //   alt: "Japanese Mask",
    //   name: "Japanese Mask",
    // },
    // ShamrockQuest: {
    //   redirectUrl: "/casino/aggaphabanero-shamrock-quest",
    //   code: "",
    //   casino: "Habanero",
    //   provider: "WorldCasino",
    //   category: "ALT_GAMING_GAP",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/habanero/ShamrockQuest.webp",
    //   alt: "Shamrock Quest",
    //   name: "Shamrock Quest",
    // },
  },

  dragoonSoft: {
    Phoenix: {
      redirectUrl: "/casino/aggapdrgs-phoenix",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Phoenix1.webp",
      alt: "Phoenix",
      name: "Phoenix",
    },
    GetMoney: {
      redirectUrl: "/casino/aggapdrgs-get-money",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GetMoney.webp",
      alt: "Get Money",
      name: "Get Money",
    },
    CoinCat: {
      redirectUrl: "/casino/aggapdrgs-coin-cat",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CoinCat.webp",
      alt: "Coin Cat",
      name: "Coin Cat",
    },
    AceyDeucey: {
      redirectUrl: "/casino/aggapdrgs-acey-deucey",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/AceyDeucey.webp",
      alt: "Acey Deucey",
      name: "Acey Deucey",
    },
    DragonOrCrash: {
      redirectUrl: "/casino/aggapdrgs-dragon-or-crash",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DragonOrCrash.webp",
      alt: "Dragon or Crash",
      name: "Dragon or Crash",
    },
    FlyingPhoenix: {
      redirectUrl: "/casino/aggapdrgs-flying-phoenix",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/FlyingPhoenix.webp",
      alt: "Flying Phoenix",
      name: "Flying Phoenix",
    },
    JumpAndJump: {
      redirectUrl: "/casino/aggapdrgs-jump-and-jump",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/JumpAndJump.webp",
      alt: "Jump & Jump",
      name: "Jump & Jump",
    },
    LadderGame: {
      redirectUrl: "/casino/aggapdrgs-ladder-game",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/LadderGame.webp",
      alt: "Ladder Game",
      name: "Ladder Game",
    },
    LetsEnhance: {
      redirectUrl: "/casino/aggapdrgs-lets-enhance",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/LetsEnhance.webp",
      alt: "Let's Enhance",
      name: "Let's Enhance",
    },
    // LionsOrb: {
    //   redirectUrl: "/casino/qtechdragoonsoft-lions-orb",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/LionsOrb.webp",
    //   alt: "Lion's Orb",
    //   name: "Lion's Orb",
    // },
    // NinjaFishing: {
    //   redirectUrl: "/casino/qtechdragoonsoft-ninja-fishing",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/NinjaFishing.webp",
    //   alt: "Ninja Fishing",
    //   name: "Ninja Fishing",
    // },
    // WonderfulChristmas: {
    //   redirectUrl: "/casino/qtechdragoonsoft-wonderful-christmas",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/WonderfulChristmas.webp",
    //   alt: "Wonderful Christmas",
    //   name: "Wonderful Christmas",
    // },
    // Golf2: {
    //   redirectUrl: "/casino/qtechdragoonsoft-golf-2",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/Golf2.webp",
    //   alt: "Golf 2",
    //   name: "Golf 2",
    // },
    // DessertParty: {
    //   redirectUrl: "/casino/qtechdragoonsoft-dessert-party",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/Dessertparty.webp",
    //   alt: "Dessert Party",
    //   name: "Dessert Party",
    // },
    // PartyNight: {
    //   redirectUrl: "/casino/qtechdragoonsoft-party-night",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/PartyNight.webp",
    //   alt: "Party Night",
    //   name: "Party Night",
    // },
    // KingsSword: {
    //   redirectUrl: "/casino/qtechdragoonsoft-kings-sword",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/KingsSword.webp",
    //   alt: "King's Sword",
    //   name: "King's Sword",
    // },
    CatFishing: {
      redirectUrl: "/casino/aggapdrgs-cat-fishing",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CatFishing.webp",
      alt: "Cat Fishing",
      name: "Cat Fishing",
    },
    OverlordAndConcubine: {
      redirectUrl: "/casino/aggapdrgs-overlord-and-concubine",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/OverlordAndConcubine.webp",
      alt: "Overlord & Concubine",
      name: "Overlord & Concubine",
    },
    Gods3Fishing: {
      redirectUrl: "/casino/aggapdrgs-3-gods-fishing",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/3GodsFishing.webp",
      alt: "3 Gods Fishing",
      name: "3 Gods Fishing",
    },
    BigHammer: {
      redirectUrl: "/casino/aggapdrgs-big-hammer",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BigHammer.webp",
      alt: "Big Hammer",
      name: "Big Hammer",
    },
    BingoFishing: {
      redirectUrl: "/casino/aggapdrgs-bingo-fishing",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BingoFishing.webp",
      alt: "Bingo Fishing",
      name: "Bingo Fishing",
    },
    CrazyOrb: {
      redirectUrl: "/casino/aggapdrgs-crazy-orb",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CrazyOrb.webp",
      alt: "Crazy Orb",
      name: "Crazy Orb",
    },
    DemonConquered: {
      redirectUrl: "/casino/aggapdrgs-demon-conquered",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DemonConquered.webp",
      alt: "Demon Conquered",
      name: "Demon Conquered",
    },
    DinoHunter: {
      redirectUrl: "/casino/aggapdrgs-dino-hunter",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DinoHunter.webp",
      alt: "Dino Hunter",
      name: "Dino Hunter",
    },
    GodsSlashFish: {
      redirectUrl: "/casino/aggapdrgs-gods-slash-fish",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GodsSlashFish.webp",
      alt: "Gods Slash Fish",
      name: "Gods Slash Fish",
    },
    GoldenZuma: {
      redirectUrl: "/casino/aggapdrgs-golden-zuma",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GoldenZuma.webp",
      alt: "Golden Zuma",
      name: "Golden Zuma",
    },
    LetsShoot: {
      redirectUrl: "/casino/aggapdrgs-lets-shoot",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/LetsShoot.webp",
      alt: "Let's Shoot",
      name: "Let's Shoot",
    },
    OceanLord: {
      redirectUrl: "/casino/aggapdrgs-ocean-lord",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/OceanLord.webp",
      alt: "Ocean Lord",
      name: "Ocean Lord",
    },
    PlantsVsDinos: {
      redirectUrl: "/casino/aggapdrgs-plants-vs-dinos",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/PlantsVsDinos.webp",
      alt: "Plants vs. Dinos",
      name: "Plants vs. Dinos",
    },
    God5Beast: {
      redirectUrl: "/casino/aggapdrgs-5-god-beast",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/5GodBeast.webp",
      alt: "5 God Beast",
      name: "5 God Beast",
    },
    777: {
      redirectUrl: "/casino/aggapdrgs-777",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/777.webp",
      alt: "777",
      name: "777",
    },
    Alice: {
      redirectUrl: "/casino/aggapdrgs-alice",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Alice.webp",
      alt: "Alice",
      name: "Alice",
    },
    Arab: {
      redirectUrl: "/casino/aggapdrgs-arab",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Arab.webp",
      alt: "Arab",
      name: "Arab",
    },
    BakufuShogun: {
      redirectUrl: "/casino/aggapdrgs-bakufu-shogun",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BakufuShogun.webp",
      alt: "Bakufu Shogun",
      name: "Bakufu Shogun",
    },
    BengalTiger: {
      redirectUrl: "/casino/aggapdrgs-bengal-tiger",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BengalTiger.webp",
      alt: "Bengal Tiger",
      name: "Bengal Tiger",
    },
    BigDiamond: {
      redirectUrl: "/casino/aggapdrgs-big-diamond",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BigDiamond.webp",
      alt: "Big Diamond",
      name: "Big Diamond",
    },
    BonusCat: {
      redirectUrl: "/casino/aggapdrgs-bonus-cat",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BonusCat.webp",
      alt: "Bonus Cat",
      name: "Bonus Cat",
    },
    BoomingGems: {
      redirectUrl: "/casino/aggapdrgs-booming-gems",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BoomingGems.webp",
      alt: "Booming Gems",
      name: "Booming Gems",
    },
    BuffaloBurst: {
      redirectUrl: "/casino/aggapdrgs-buffalo-burst",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BuffaloBurst.webp",
      alt: "Buffalo Burst",
      name: "Buffalo Burst",
    },
    BustTreasury: {
      redirectUrl: "/casino/aggapdrgs-bust-treasury",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/BustTreasury.webp",
      alt: "Bust Treasury",
      name: "Bust Treasury",
    },
    CaishenComing: {
      redirectUrl: "/casino/aggapdrgs-caishen-coming",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CaishenComing.webp",
      alt: "Caishen Coming",
      name: "Caishen Coming",
    },
    CandyDynasty: {
      redirectUrl: "/casino/aggapdrgs-candy-dynasty",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CandyDynasty.webp",
      alt: "Candy Dynasty",
      name: "Candy Dynasty",
    },
    ChefLady: {
      redirectUrl: "/casino/aggapdrgs-chef-lady",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/ChefLady.webp",
      alt: "Chef Lady",
      name: "Chef Lady",
    },
    CoinRat: {
      redirectUrl: "/casino/aggapdrgs-coin-rat",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CoinRat.webp",
      alt: "Coin Rat",
      name: "Coin Rat",
    },
    CrystalFruits: {
      redirectUrl: "/casino/aggapdrgs-crystal-fruits",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/CrystalFruits.webp",
      alt: "Crystal Fruits",
      name: "Crystal Fruits",
    },
    Diamond7: {
      redirectUrl: "/casino/aggapdrgs-diamond-7",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Diamond7.webp",
      alt: "Diamond 7",
      name: "Diamond 7",
    },
    DiamondMogul: {
      redirectUrl: "/casino/aggapdrgs-diamond-mogul",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DiamondMogul.webp",
      alt: "Diamond Mogul",
      name: "Diamond Mogul",
    },
    DoggyWealth: {
      redirectUrl: "/casino/aggapdrgs-doggy-wealth",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DoggyWealth.webp",
      alt: "Doggy Wealth",
      name: "Doggy Wealth",
    },
    Dracula: {
      redirectUrl: "/casino/aggapdrgs-dracula",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Dracula.webp",
      alt: "Dracula",
      name: "Dracula",
    },
    Dragonburst: {
      redirectUrl: "/casino/aggapdrgs-dragonburst",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Dragonburst.webp",
      alt: "Dragonburst",
      name: "Dragonburst",
    },
    DragonsTreasure: {
      redirectUrl: "/casino/aggapdrgs-dragons-treasure",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/DragonsTreasure.webp",
      alt: "Dragon's Treasure",
      name: "Dragon's Treasure",
    },
    EgyptDynasty: {
      redirectUrl: "/casino/aggapdrgs-egypt-dynasty",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/EgyptDynasty.webp",
      alt: "Egypt Dynasty",
      name: "Egypt Dynasty",
    },
    EgyptOracle: {
      redirectUrl: "/casino/aggapdrgs-egypt-oracle",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/EgyptOracle.webp",
      alt: "Egypt Oracle",
      name: "Egypt Oracle",
    },
    FruitsBar: {
      redirectUrl: "/casino/aggapdrgs-fruits-bar",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/FruitsBar.webp",
      alt: "Fruits Bar",
      name: "Fruits Bar",
    },
    FushenComing: {
      redirectUrl: "/casino/aggapdrgs-fushen-coming",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/FushenComing.webp",
      alt: "Fushen Coming",
      name: "Fushen Coming",
    },
    GetHigh: {
      redirectUrl: "/casino/aggapdrgs-get-high",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GetHigh.webp",
      alt: "Get High",
      name: "Get High",
    },
    GiveYouMoney: {
      redirectUrl: "/casino/aggapdrgs-give-you-money",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GiveYouMoney.webp",
      alt: "Give You Money",
      name: "Give You Money",
    },
    Golf: {
      redirectUrl: "/casino/aggapdrgs-golf",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Golf.webp",
      alt: "Golf",
      name: "Golf",
    },
    GrandSheriff: {
      redirectUrl: "/casino/aggapdrgs-grand-sheriff",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GrandSheriff.webp",
      alt: "Grand Sheriff",
      name: "Grand Sheriff",
    },
    GreatLion: {
      redirectUrl: "/casino/aggapdrgs-great-lion",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GreatLion.webp",
      alt: "Great Lion",
      name: "Great Lion",
    },
    GreatestCircus: {
      redirectUrl: "/casino/aggapdrgs-greatest-circus",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GreatestCircus.webp",
      alt: "Greatest Circus",
      name: "Greatest Circus",
    },
    IcyBar: {
      redirectUrl: "/casino/aggapdrgs-icy-bar",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/IcyBar.webp",
      alt: "Icy Bar",
      name: "Icy Bar",
    },
    ImmortalHeroes: {
      redirectUrl: "/casino/aggapdrgs-immortal-heroes",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/ImmortalHeroes.webp",
      alt: "Immortal Heroes",
      name: "Immortal Heroes",
    },
    JinHouYe: {
      redirectUrl: "/casino/aggapdrgs-jin-hou-ye",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/JinHouYe.webp",
      alt: "Jin Hou Ye",
      name: "Jin Hou Ye",
    },
    LuLingQi: {
      redirectUrl: "/casino/aggapdrgs-lu-ling-qi",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/LuLingQi.webp",
      alt: "Lu Ling Qi",
      name: "Lu Ling Qi",
    },
    ManyBeauties: {
      redirectUrl: "/casino/aggapdrgs-many-beauties",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/ManyBeauties.webp",
      alt: "Many Beauties",
      name: "Many Beauties",
    },
    MayaKing: {
      redirectUrl: "/casino/aggapdrgs-maya-king",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/MayaKing.webp",
      alt: "Maya King",
      name: "Maya King",
    },
    MidasTouch: {
      redirectUrl: "/casino/aggapdrgs-midas-touch",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/MidasTouch.webp",
      alt: "Midas Touch",
      name: "Midas Touch",
    },
    MonkeyKing: {
      redirectUrl: "/casino/aggapdrgs-monkey-king",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/MonkeyKing.webp",
      alt: "Monkey King",
      name: "Monkey King",
    },
    OrePower: {
      redirectUrl: "/casino/aggapdrgs-ore-power",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/OrePower.webp",
      alt: "Ore Power",
      name: "Ore Power",
    },
    OverDragonsGate: {
      redirectUrl: "/casino/aggapdrgs-over-dragons-gate",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/OverDragonsGate.webp",
      alt: "Over Dragon's Gate",
      name: "Over Dragon's Gate",
    },
    Pandaria: {
      redirectUrl: "/casino/aggapdrgs-pandaria",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Pandaria.webp",
      alt: "Pandaria",
      name: "Pandaria",
    },
    PirateKing: {
      redirectUrl: "/casino/aggapdrgs-pirate-king",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/PirateKing.webp",
      alt: "Pirate King",
      name: "Pirate King",
    },
    RichDragon: {
      redirectUrl: "/casino/aggapdrgs-rich-dragon",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/RichDragon.webp",
      alt: "Rich Dragon",
      name: "Rich Dragon",
    },
    RichLion: {
      redirectUrl: "/casino/aggapdrgs-rich-lion",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/RichLion.webp",
      alt: "Rich Lion",
      name: "Rich Lion",
    },
    RichNow: {
      redirectUrl: "/casino/aggapdrgs-rich-now",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/RichNow.webp",
      alt: "Rich Now",
      name: "Rich Now",
    },
    RollInMoney: {
      redirectUrl: "/casino/aggapdrgs-roll-in-money",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/RollInMoney.webp",
      alt: "Roll in Money",
      name: "Roll in Money",
    },
    Roman: {
      redirectUrl: "/casino/aggapdrgs-roman",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Roman.webp",
      alt: "Roman",
      name: "Roman",
    },
    StoneHominid: {
      redirectUrl: "/casino/aggapdrgs-stone-hominid",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/StoneHominid.webp",
      alt: "Stone Hominid",
      name: "Stone Hominid",
    },
    TigerLord: {
      redirectUrl: "/casino/aggapdrgs-tiger-lord",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/TigerLord.webp",
      alt: "Tiger Lord",
      name: "Tiger Lord",
    },
    TripleMonkey: {
      redirectUrl: "/casino/aggapdrgs-triple-monkey",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/TripleMonkey.webp",
      alt: "Triple Monkey",
      name: "Triple Monkey",
    },
    TRex: {
      redirectUrl: "/casino/aggapdrgs-t-rex",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/TRex.webp",
      alt: "T-Rex",
      name: "T-Rex",
    },
    UltraTreasure: {
      redirectUrl: "/casino/aggapdrgs-ultra-treasure",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/UltraTreasure.webp",
      alt: "Ultra Treasure",
      name: "Ultra Treasure",
    },
    WolfLegend: {
      redirectUrl: "/casino/aggapdrgs-wolf-legend",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/WolfLegend.webp",
      alt: "Wolf Legend",
      name: "Wolf Legend",
    },
    Worldie: {
      redirectUrl: "/casino/aggapdrgs-worldie",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Worldie.webp",
      alt: "Worldie",
      name: "Worldie",
    },
    YouWillWin: {
      redirectUrl: "/casino/aggapdrgs-you-will-win",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/YouWillWin.webp",
      alt: "You Will Win",
      name: "You Will Win",
    },
    Zeus: {
      redirectUrl: "/casino/aggapdrgs-zeus",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/Zeus.webp",
      alt: "Zeus",
      name: "Zeus",
    },
    ZhaoYun: {
      redirectUrl: "/casino/aggapdrgs-zhao-yun",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/ZhaoYun.webp",
      alt: "Zhao Yun",
      name: "Zhao Yun",
    },
    GoldenEgg: {
      redirectUrl: "/casino/aggapdrgs-golden-egg",
      code: "",
      casino: "Slots",
      provider: "ALT_GAMING_GAP",
      category: "dragoonSoft",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/dragoon-soft/GoldenEgg.webp",
      alt: "Golden Egg",
      name: "Golden Egg",
    },
    // MahjongWin: {
    //   redirectUrl: "/casino/qtechdragoonsoft-mahjong-win",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/MahjongWin.webp",
    //   alt: "Mahjong Win",
    //   name: "Mahjong Win",
    // },
    // SuperHooHeyHow: {
    //   redirectUrl: "/casino/qtechdragoonsoft-super-hoo-hey-how",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/SuperHooHeyHow.webp",
    //   alt: "Super Hoo Hey How",
    //   name: "Super Hoo Hey How",
    // },
    // MuchRicher: {
    //   redirectUrl: "/casino/qtechdragoonsoft-much-richer",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/MuchRicher.webp",
    //   alt: "Much Richer",
    //   name: "Much Richer",
    // },
    // GoddessOrCrash: {
    //   redirectUrl: "/casino/qtechdragoonsoft-goddess-or-crash",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/GoddessOrCrash.webp",
    //   alt: "Goddess or Crash",
    //   name: "Goddess or Crash",
    // },
    // FireBallBlazePhoenix: {
    //   redirectUrl: "/casino/qtechdragoonsoft-fire-ball-blaze-phoenix",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/FireBallBlazePhoenix.webp",
    //   alt: "Fire Ball Blaze Phoenix",
    //   name: "Fire Ball Blaze Phoenix",
    // },
    // MidasHand: {
    //   redirectUrl: "/casino/qtechdragoonsoft-midas-hand",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/MidasHand.webp",
    //   alt: "Midas Hand",
    //   name: "Midas Hand",
    // },
    // HappyFish: {
    //   redirectUrl: "/casino/qtechdragoonsoft-happy-fish",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/HappyFish.webp",
    //   alt: "Happy Fish",
    //   name: "Happy Fish",
    // },
    // DancingSamba: {
    //   redirectUrl: "/casino/qtechdragoonsoft-dancing-samba",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/DancingSamba.webp",
    //   alt: "Dancing Samba",
    //   name: "Dancing Samba",
    // },
    // FortuneTwins: {
    //   redirectUrl: "/casino/qtechdragoonsoft-fortune-twins",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/FortuneTwins.webp",
    //   alt: "Fortune Twins",
    //   name: "Fortune Twins",
    // },
    // AztecTreasure: {
    //   redirectUrl: "/casino/qtechdragoonsoft-aztec-treasure",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/AztecTreasure.webp",
    //   alt: "Aztec Treasure",
    //   name: "Aztec Treasure",
    // },
    // OdinTerritory: {
    //   redirectUrl: "/casino/qtechdragoonsoft-odin-territory",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/OdinTerritory.webp",
    //   alt: "Odin Territory",
    //   name: "Odin Territory",
    // },
    // CrazyBartender: {
    //   redirectUrl: "/casino/qtechdragoonsoft-crazy-bartender",
    //   code: "",
    //   casino: "Slots",
    //   provider: "QTECH",
    //   category: "dragoonSoft",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/dragoon-soft/CrazyBartender.webp",
    //   alt: "Crazy Bartender",
    //   name: "Crazy Bartender",
    // },
  },

  mac88: {
    Lucky7: {
      redirectUrl: "/casino/aggapmac88gaming-lucky7",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lucky7",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/lucky7.webp",
      alt: "Lucky 7",
      name: "Lucky 7",
    },
    Lucky5: {
      redirectUrl: "/casino/aggapmac88gaming-lucky-5",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lucky7",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/lucky-5.webp",
      alt: "Lucky 5",
      name: "Lucky 5",
    },
    DragonTiger: {
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "dragontiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/dragon-tiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
    },
    DragonTiger2: {
      redirectUrl: "/casino/aggapmac88gaming-dragon-tiger-2",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "dragontiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/dragon-tiger-2.webp",
      alt: "Dragon Tiger 2",
      name: "Dragon Tiger 2",
    },
    DragonTigerLion: {
      redirectUrl: "/casino/aggapmac88gaming-dtl",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "dragontiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/dtl.webp",
      alt: "Dragon Tiger Lion",
      name: "Dragon Tiger Lion",
    },
    Day1DragonTiger: {
      redirectUrl: "/casino/aggapmac88gaming-1-day-dragon-tiger",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "dragontiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/1-day-dragon-tiger.webp",
      alt: "1 Day Dragon Tiger",
      name: "1 Day Dragon Tiger",
    },
    Baccarat29: {
      redirectUrl: "/casino/aggapmac88gaming-29-baccarat",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "baccarat",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/29-baccarat.webp",
      alt: "29 Baccarat",
      name: "29 Baccarat",
    },
    BaccaratOneDay: {
      redirectUrl: "/casino/aggapmac88gaming-baccarat-one-day",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "baccarat",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/baccarat-one-day.webp",
      alt: "Baccarat One Day",
      name: "Baccarat One Day",
    },
    SicBo: {
      redirectUrl: "/casino/aggapmac88gaming-sic-bo",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "baccarat",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/sic-bo.webp",
      alt: "Sic Bo",
      name: "Sic Bo",
    },
    Roulette: {
      redirectUrl: "/casino/aggapmac88gaming-roulette",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/roulette.webp",
      alt: "Roulette",
      name: "Roulette",
    },
    Poker1Day: {
      redirectUrl: "/casino/aggapmac88gaming-poker-1-day",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "poker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/poker-1-day.webp",
      alt: "Poker 1-Day",
      name: "Poker 1-Day",
    },
    Poker2020: {
      redirectUrl: "/casino/aggapmac88gaming-poker-20-20",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "poker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/poker-20-20.webp",
      alt: "Poker 20-20",
      name: "Poker 20-20",
    },
    Player6Poker: {
      redirectUrl: "/casino/aggapmac88gaming-6-player-poker",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "poker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/6-player-poker.webp",
      alt: "6 Player Poker",
      name: "6 Player Poker",
    },
    MuflisTeenpatti: {
      redirectUrl: "/casino/aggapmac88gaming-muflis-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/muflis-teenpatti.webp",
      alt: "Muflis Teenpatti",
      name: "Muflis Teenpatti",
    },
    TwoCardTeenpatti: {
      redirectUrl: "/casino/aggapmac88gaming-two-card-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/2-card-teenpatti.webp",
      alt: "Two Card Teenpatti",
      name: "Two Card Teenpatti",
    },
    OpenTeenpatti: {
      redirectUrl: "/casino/aggapmac88gaming-open-teen-patti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/open-teen-patti.webp",
      alt: "Open Teen patti",
      name: "Open Teen patti",
    },
    TeenpattiOneDay: {
      redirectUrl: "/casino/aggapmac88gaming-teenpatti-one-day",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/teenpatti-one-day.webp",
      alt: "Teenpatti One Day",
      name: "Teenpatti One Day",
    },
    TestTeenpatti: {
      redirectUrl: "/casino/aggapmac88gaming-test-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/test-teenpatti.webp",
      alt: "Test Teenpatti",
      name: "Test Teenpatti",
    },
    Teenpatti2020: {
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/20-20-teenpatti.webp",
      alt: "20-20 Teenpatti",
      name: "20-20 Teenpatti",
    },
    Teenpatti20202: {
      redirectUrl: "/casino/aggapmac88gaming-20-20-teenpatti-2",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/20-20-teenpatti-2.webp",
      alt: "20 20 Teenpatti 2",
      name: "20 20 Teenpatti 2",
    },
    AK47Teenpatti: {
      redirectUrl: "/casino/aggapmac88gaming-ak47-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/ak47-teenpatti.webp",
      alt: "AK47 Teenpatti",
      name: "AK47 Teenpatti",
    },
    InstantTeenPatti: {
      redirectUrl: "/casino/aggapmac88gaming-instant-teen-patti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/instant-teen-patti.webp",
      alt: "Instant Teen Patti",
      name: "Instant Teen Patti",
    },
    Highlow: {
      redirectUrl: "/casino/aggapmac88gaming-high-low",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "hiLo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/high-low.webp",
      alt: "High low",
      name: "High low",
    },
    HiLo: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "hiLo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/hi-lo.webp",
      alt: "Hi Lo",
      name: "Hi Lo",
    },

    // LotteryMac88: {
    //   redirectUrl: "/casino/aggapmac88gaming-lottery",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "lottery",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "/images/casino/lottery/Lottery-Mac88.webp",
    //   alt: "Lottery",
    //   name: "Lottery",
    //   providerName: "lottery",
    // },
    BollywoodCasinoB: {
      redirectUrl: "/casino/aggapmac88gaming-bollywood-casino-b",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/bollywood-casino-b.webp",
      alt: "Bollywood Casino B",
      name: "Bollywood Casino B",
    },
    CasinoWar: {
      redirectUrl: "/casino/aggapmac88gaming-casino-war",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/casino-war.webp",
      alt: "Casino War",
      name: "Casino War",
    },
    CenterCard: {
      redirectUrl: "/casino/aggapmac88gaming-center-card",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/center-card.webp",
      alt: "Center card",
      name: "Center card",
    },
    Instantworli: {
      redirectUrl: "/casino/aggapmac88gaming-instant-worli",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/instant-worli.webp",
      alt: "Instant worli",
      name: "Instant worli",
    },
    NoteNumber: {
      redirectUrl: "/casino/aggapmac88gaming-note-number",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/note-number.webp",
      alt: "Note Number",
      name: "Note Number",
    },
    OneCard2020: {
      redirectUrl: "/casino/aggapmac88gaming-one-card-20-20",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/one-card-20-20.webp",
      alt: "One Card 20 20",
      name: "One Card 20 20",
    },
    OneCardOneDay: {
      redirectUrl: "/casino/aggapmac88gaming-one-card-one-day",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/one-card-one-day.webp",
      alt: "One Card One Day",
      name: "One Card One Day",
    },
    QueenRace: {
      redirectUrl: "/casino/aggapmac88gaming-queen-race",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/queen-race.webp",
      alt: "Queen Race",
      name: "Queen Race",
    },
    Race20: {
      redirectUrl: "/casino/aggapmac88gaming-race-20",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/race-20.webp",
      alt: "Race 20",
      name: "Race 20",
    },
    Raceto17: {
      redirectUrl: "/casino/aggapmac88gaming-race-to-17",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/race-to-17.webp",
      alt: "Race to 17",
      name: "Race to 17",
    },
    Raceto2nd: {
      redirectUrl: "/casino/aggapmac88gaming-race-to-2nd",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/race-to-2nd.webp",
      alt: "Race to 2nd",
      name: "Race to 2nd",
    },
    // SideBetcity: {
    //   redirectUrl: "/casino/aggapmac88gaming-side-bet-city",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "others",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/mac88/side-bet-city.webp",
    //   alt: "Side Bet city",
    //   name: "Side Bet city",
    // },
    CenterCardOneDay: {
      redirectUrl: "/casino/aggapmac88gaming-center-card-one-day",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/center-card-one-day.webp",
      alt: "Center Card One Day",
      name: "Center Card One Day",
    },
    Trio: {
      redirectUrl: "/casino/aggapmac88gaming-trio",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/trio.webp",
      alt: "Trio",
      name: "Trio",
    },
    WorliMatka: {
      redirectUrl: "/casino/aggapmac88gaming-worli-matka",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/worli-matka.webp",
      alt: "Worli Matka",
      name: "Worli Matka",
    },
    Cards3Judgement: {
      redirectUrl: "/casino/aggapmac88gaming-3-cards-judgement",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/3-cards-judgement.webp",
      alt: "3 Cards Judgement",
      name: "3 Cards Judgement",
    },
    AmarAkbarAnthony: {
      redirectUrl: "/casino/aggapmac88gaming-amar-akbar-anthony",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/amar-akbar-anthony.webp",
      alt: "Amar Akbar Anthony",
      name: "Amar Akbar Anthony",
    },
    AndarBahar: {
      redirectUrl: "/casino/aggapmac88gaming-andar-bahar",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "andarbahar",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/andar-bahar.webp",
      alt: "Andar Bahar",
      name: "Andar Bahar",
    },
    AndarBahar50: {
      redirectUrl: "/casino/aggapmac88gaming-andar-bahar-50",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "andarbahar",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/andar-bahar-50.webp",
      alt: "Andar Bahar 50",
      name: "Andar Bahar 50",
    },
    Cards32: {
      redirectUrl: "/casino/aggapmac88gaming-32-cards",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/32-cards.webp",
      alt: "32 Cards",
      name: "32 Cards",
    },
    DreamWheel: {
      redirectUrl: "/casino/aggapmac88gaming-dream-wheel",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "liveGameShows",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/dream-wheel.webp",
      alt: "Dream Wheel",
      name: "Dream Wheel",
    },
    FootballStudIo: {
      redirectUrl: "/casino/aggapmac88gaming-football-studio",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "liveGameShows",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88/football-studio.webp",
      alt: "Football StudIo",
      name: "Football StudIo",
    },
  },

  mac88VR: {
    VRLucky7: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-lucky-7",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lucky7",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-lucky-7.webp",
      alt: "VR Lucky 7",
      name: "VR Lucky 7",
    },
    Lucky5: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-5",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lucky7",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/lucky-5.webp",
      alt: "Lucky 5",
      name: "Lucky 5",
    },
    Lucky15: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-lucky-15",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "lucky7",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/lucky-15.webp",
      alt: "Lucky 15",
      name: "Lucky 15",
    },
    CenterCardVR: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-center-card-vr",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/center-card-vr.webp",
      alt: "Center Card VR",
      name: "Center Card VR",
    },
    // KaunBanegaCrorepatiVR: {
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-kaun-banega-crorepati-vr",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "teenpatti",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/mac88-vr/kaun-banega-crorepati-vr.webp",
    //   alt: "Kaun Banega Crorepati VR",
    //   name: "Kaun Banega Crorepati VR",
    // },
    VRAmarAkbarAnthony: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-amar-akbar-anthony",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-amar-akbar-anthony.webp",
      alt: "VR Amar Akbar Anthony",
      name: "VR Amar Akbar Anthony",
    },
    VRBollywoodCasino: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-bollywood-casino",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-bollywood-casino.webp",
      alt: "VR Bollywood Casino",
      name: "VR Bollywood Casino",
    },
    VRCasinoMeter: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-casino-meter",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-casino-meter.webp",
      alt: "VR Casino Meter",
      name: "VR Casino Meter",
    },
    VRQueenRace: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-queen-race",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-queen-race.webp",
      alt: "VR Queen Race",
      name: "VR Queen Race",
    },
    VRRaceT20: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-race-t20",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-race-20.webp",
      alt: "VR Race T20",
      name: "VR Race T20",
    },
    VRTrio: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-trio",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-trio.webp",
      alt: "VR Trio",
      name: "VR Trio",
    },
    VRWorliMatka: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-worli-matka",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-worli-matka.webp",
      alt: "VR Worli Matka",
      name: "VR Worli Matka",
    },
    BallbyBallVR: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-ball-by-ball-vr",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/ball-by-ball-vr.webp",
      alt: "Ball by Ball VR",
      name: "Ball by Ball VR",
    },

    RockPaperScissors: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-rock-paper-scissors",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/rock-paper-scissors.webp",
      alt: "Rock Paper Scissors",
      name: "Rock Paper Scissors",
    },
    Boys5: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-5-boys",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/5-boys.webp",
      alt: "5 Boys",
      name: "5 Boys",
    },
    Vortex: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vortex",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vortex.webp",
      alt: "Vortex",
      name: "Vortex",
    },
    BollyKiss: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-bolly-kiss",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/bollywood-kiss.webp",
      alt: "Bolly Kiss",
      name: "Bolly Kiss",
    },
    Plinko: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-plinko",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/plinko.webp",
      alt: "Plinko",
      name: "Plinko",
    },
    diamonds: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-diamonds",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/diamonds.webp",
      alt: "Diamond",
      name: "Diamond",
    },
    Limbo: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-limbo",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/limbo.webp",
      alt: "Limbo",
      name: "Limbo",
    },
    Dice: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-dice",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/dice.webp",
      alt: "Dice",
      name: "Dice",
    },

    // K3Lottery10: {
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-k3-lottery-10",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "others",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/mac88-vr/centrecard-vr.webp",
    //   alt: "K3 Lottery 10",
    //   name: "K3 Lottery 10",
    // },
    VRDragonTiger: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-dragon-tiger",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "dragontiger",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-dragon-tiger.webp",
      alt: "VR Dragon Tiger",
      name: "VR Dragon Tiger",
    },
    VR2020DTL: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-dtl",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-20-20-dtl.webp",
      alt: "VR 20-20 DTL",
      name: "VR 20-20 DTL",
    },
    AK47VR: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-ak47-vr",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/ak47-vr.webp",
      alt: "AK47 VR",
      name: "AK47 VR",
    },
    VR2020Teenpatti: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-20-20-teenpatti",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-20-20-teenpatti.webp",
      alt: "VR 20-20 Teenpatti",
      name: "VR 20-20 Teenpatti",
    },
    VR2CardTP: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-2-card-tp",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "teenpatti",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-2-card-tp.webp",
      alt: "VR 2 Card TP",
      name: "VR 2 Card TP",
    },
    VR32Cards: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-32-cards",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "cards32",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-32-cards.webp",
      alt: "VR 32 Cards",
      name: "VR 32 Cards",
    },
    VRAndarBahar: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-andar-bahar",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "andarbahar",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-andar-bahar.webp",
      alt: "VR Andar Bahar",
      name: "VR Andar Bahar",
    },
    VRHighlow: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-high-low",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "hiLo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/high-low-vr.webp",
      alt: "VR High low",
      name: "VR High low",
    },
    HiloVR: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-hi-lo-vr",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "hiLo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/hi-lo.webp",
      alt: "Hi Lo VR",
      name: "Hi Lo VR",
    },
    VR29cardbacarrat: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-29-card-bacarrat",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "baccarat",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/29-baccarat-vr.webp",
      alt: "VR 29 card bacarrat",
      name: "VR 29 card bacarrat",
    },
    VRPoker: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-poker",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "poker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-poker.webp",
      alt: "VR Poker",
      name: "VR Poker",
    },
    // XRoulette: {
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-x-roulette",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "roulette",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/mac88-vr/x-roulette.webp",
    //   alt: "X Roulette",
    //   name: "X Roulette",
    // },
    VRAutoRoulette: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-vr-auto-roulette",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "roulette",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/vr-auto-roulette.webp",
      alt: "VR Auto Roulette",
      name: "VR Auto Roulette",
    },
    minesMac: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-mines",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "mines",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/mines.webp",
      alt: "Mines",
      name: "Mines",
    },
    JetXT: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-jet-xt",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/jet-xt.webp",
      alt: "Jet XT",
      name: "Jet XT",
    },
    Kitex: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-kitex",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/kitex.webp",
      alt: "Kitex",
      name: "Kitex",
    },
    CrashX: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-crash-x",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/crash-x.webp",
      alt: "Crash X",
      name: "Crash X",
    },
    // AviatorX2: {
    //   redirectUrl: "/casino/aggapmac88gamingvirtual-aviatorx2",
    //   code: "",
    //   casino: "Mac88",
    //   provider: "ALT_GAMING_GAP",
    //   category: "crashX",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/mac88-vr/aviatorX2.webp",
    //   alt: "AviatorX2",
    //   name: "AviatorX2",
    // },
    PushpaRani: {
      redirectUrl: "/casino/aggapmac88gamingvirtual-pushpa-rani",
      code: "",
      casino: "Mac88",
      provider: "ALT_GAMING_GAP",
      category: "crash",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/mac88-vr/pushpa-rani.webp",
      alt: "Pushpa Rani",
      name: "Pushpa Rani",
    },
  },

  smartSoft: {
    JetX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/JetX.webp",
      alt: "JetX",
      name: "JetX",
      providerName: "SmartSoft",
    },
    Cappadocia: {
      redirectUrl: "/casino/aggapsmartsoftgaming-cappadocia",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Cappadocia.webp",
      alt: "Cappadocia",
      name: "Cappadocia",
      providerName: "SmartSoft",
    },
    JetX3: {
      redirectUrl: "/casino/aggapsmartsoftgaming-jetx3",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/JetX3.webp",
      alt: "JetX3",
      name: "JetX3",
      providerName: "SmartSoft",
    },
    CricketX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-cricketx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/CricketX.webp",
      alt: "CricketX",
      name: "CricketX",
      providerName: "SmartSoft",
    },
    FootballX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-footballx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/FootballX.webp",
      alt: "FootballX",
      name: "FootballX",
      providerName: "SmartSoft",
    },
    TowerX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-towerx",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crashX",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/TowerX.webp",
      alt: "TowerX",
      name: "TowerX",
      providerName: "SmartSoft",
    },
    // SpinX: {
    //   redirectUrl: "/casino/aggapsmartsoftgaming-spinx",
    //   code: "",
    //   casino: "SmartSoft",
    //   provider: "ALT_GAMING_GAP",
    //   category: "others",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/slots/smartsoft/SpinX.webp",
    //   alt: "SpinX",
    //   name: "SpinX",
    //   providerName: "SmartSoft",
    // },
    PlinkoX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-plinkox",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/PlinkoX.webp",
      alt: "PlinkoX",
      name: "PlinkoX",
      providerName: "SmartSoft",
    },
    HunterX: {
      redirectUrl: "/casino/aggapsmartsoftgaming-hunter-x",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/CrazyHuntX.webp",
      alt: "Hunter X",
      name: "Hunter X",
      providerName: "SmartSoft",
    },
    Jokers4Bonuses: {
      redirectUrl: "/casino/aggapsmartsoftgaming-4-bonuses-bonanza",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Jokers4Bonuses.webp",
      alt: "Joker's 4 Bonuses",
      name: "Joker's 4 Bonuses",
      providerName: "SmartSoft",
    },
    Samurai: {
      redirectUrl: "/casino/aggapsmartsoftgaming-samurai",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Samurai.webp",
      alt: "Samurai",
      name: "Samurai",
      providerName: "SmartSoft",
    },
    BurningIce: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce.webp",
      alt: "Burning Ice",
      name: "Burning Ice",
      providerName: "SmartSoft",
    },
    BurningIce10: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-10",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce10.webp",
      alt: "Burning Ice 10",
      name: "Burning Ice 10",
      providerName: "SmartSoft",
    },
    BurningIce40: {
      redirectUrl: "/casino/aggapsmartsoftgaming-burning-ice-40",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/BurningIce40.webp",
      alt: "Burning Ice 40",
      name: "Burning Ice 40",
      providerName: "SmartSoft",
    },
    Vampires: {
      redirectUrl: "/casino/aggapsmartsoftgaming-vampires",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Vampires.webp",
      alt: "Vampires",
      name: "Vampires",
      providerName: "SmartSoft",
    },
    MultiHot5: {
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-5",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/MultiHot5.webp",
      alt: "Multi Hot 5",
      name: "Multi Hot 5",
      providerName: "SmartSoft",
    },
    WildJungle: {
      redirectUrl: "/casino/aggapsmartsoftgaming-wild-jungle",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/WildJungle.webp",
      alt: "Wild Jungle",
      name: "Wild Jungle",
      providerName: "SmartSoft",
    },
    GeniesBonanza: {
      redirectUrl: "/casino/aggapsmartsoftgaming-genies-bonanza",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/GeniesBonanza.webp",
      alt: "Genie's Bonanza",
      name: "Genie's Bonanza",
      providerName: "SmartSoft",
    },
    MultiHotWays: {
      redirectUrl: "/casino/aggapsmartsoftgaming-multi-hot-ways",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "others",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/MultiHotWays.webp",
      alt: "Multi Hot Ways",
      name: "Multi Hot Ways",
      providerName: "SmartSoft",
    },
    Balloon: {
      redirectUrl: "/casino/aggapsmartsoftgaming-baloon",
      code: "",
      casino: "SmartSoft",
      provider: "ALT_GAMING_GAP",
      category: "crash",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/slots/smartsoft/Balloon.webp",
      alt: "Balloon",
      name: "Balloon",
      providerName: "SmartSoft",
    },
  },

 pragmaticplay:{
     gatesofolympus: {
       href: "/casino/pragmaticplay-gates-of-olympus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympus.webp",
       alt: "Gates of Olympus",
       name: "Gates of Olympus",
     },
     sweetbonanza: {
       href: "/casino/pragmaticplay-sweet-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanza.webp",
       alt: "Sweet Bonanza",
       name: "Sweet Bonanza",
     },
     sugarrush: {
       href: "/casino/pragmaticplay-sugar-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarRush.webp",
       alt: "Sugar Rush",
       name: "Sugar Rush",
     },
     bigbassbonanza: {
       href: "/casino/pragmaticplay-big-bass-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBonanza.webp",
       alt: "Big Bass Bonanza",
       name: "Big Bass Bonanza",
     },
     bigbasshalloween: {
       href: "/casino/pragmaticplay-big-bass-halloween",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassHalloween.webp",
       alt: "Big Bass Halloween",
       name: "Big Bass Halloween",
     },
     bigbasssplash: {
       href: "/casino/pragmaticplay-big-bass-splash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassSplash.webp",
       alt: "Big Bass Splash",
       name: "Big Bass Splash",
     },
     thedoghouse: {
       href: "/casino/pragmaticplay-the-dog-house",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouse.webp",
       alt: "The Dog House",
       name: "The Dog House",
     },
     gatesofhades: {
       href: "/casino/pragmaticplay-gates-of-hades",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofHades.webp",
       alt: "Gates of Hades",
       name: "Gates of Hades",
     },
     zombieschoolmegaways: {
       href: "/casino/pragmaticplay-zombie-school-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ZombieSchoolMegaways.webp",
       alt: "Zombie School Megaways",
       name: "Zombie School Megaways",
     },
     zombiecarnival: {
       href: "/casino/pragmaticplay-zombie-carnival",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ZombieCarnival.webp",
       alt: "Zombie Carnival",
       name: "Zombie Carnival",
     },
     zeusvshadesgodsofwar: {
       href: "/casino/pragmaticplay-zeus-vs-hades-gods-of-war",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ZeusvsHades-GodsofWar.webp",
       alt: "Zeus vs Hades  Gods of War",
       name: "Zeus vs Hades  Gods of War",
     },
     youcanpiggybankonit: {
       href: "/casino/pragmaticplay-you-can-piggy-bank-on-it",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YouCanPiggyBankonIt.webp",
       alt: "You Can Piggy Bank On It",
       name: "You Can Piggy Bank On It",
     },
     yollarinkrali: {
       href: "/casino/pragmaticplay-yollarin-krali",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YollarinKrali.webp",
       alt: "Yollarin Krali",
       name: "Yollarin Krali",
     },
     yisunshin: {
       href: "/casino/pragmaticplay-yi-sun-shin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YiSunShin.webp",
       alt: "Yi Sun Shin",
       name: "Yi Sun Shin",
     },
     yetiquest: {
       href: "/casino/pragmaticplay-yeti-quest",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YetiQuest.webp",
       alt: "Yeti Quest",
       name: "Yeti Quest",
     },
     yearofthedragonking: {
       href: "/casino/pragmaticplay-year-of-the-dragon-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YearofTheDragonKing.webp",
       alt: "Year Of The Dragon King",
       name: "Year Of The Dragon King",
     },
     yabotreeofriches: {
       href: "/casino/pragmaticplay-yabo-tree-of-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/YaboTreeofRiches.webp",
       alt: "Yabo Tree of Riches",
       name: "Yabo Tree of Riches",
     },
     xmasspark: {
       href: "/casino/pragmaticplay-xmas-spark",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/XmasSpark.webp",
       alt: "Xmas Spark",
       name: "Xmas Spark",
     },
     wukongrush: {
       href: "/casino/pragmaticplay-wukong-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WukongRush.webp",
       alt: "Wukong Rush",
       name: "Wukong Rush",
     },
     wolfgoldultimate: {
       href: "/casino/pragmaticplay-wolf-gold-ultimate",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WolfGoldUltimate.webp",
       alt: "Wolf Gold Ultimate",
       name: "Wolf Gold Ultimate",
     },
     wolfgolddice: {
       href: "/casino/pragmaticplay-wolf-gold-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WolfGoldDice.webp",
       alt: "Wolf Gold Dice",
       name: "Wolf Gold Dice",
     },
     wolfgold4pack: {
       href: "/casino/pragmaticplay-wolf-gold-4-pack",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WolfGold4Pack.webp",
       alt: "Wolf Gold 4 Pack",
       name: "Wolf Gold 4 Pack",
     },
     wolfgold: {
       href: "/casino/pragmaticplay-wolf-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WolfGold.webp",
       alt: "Wolf Gold",
       name: "Wolf Gold",
     },
     witchheartmegaways: {
       href: "/casino/pragmaticplay-witch-heart-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WitchHeartMegaways.webp",
       alt: "Witch Heart Megaways",
       name: "Witch Heart Megaways",
     },
     wisdomofathena1000: {
       href: "/casino/pragmaticplay-wisdom-of-athena-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WisdomofAthena1000.webp",
       alt: "Wisdom Of Athena 1000",
       name: "Wisdom Of Athena 1000",
     },
     wisdomofathena: {
       href: "/casino/pragmaticplay-wisdom-of-athena",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WisdomofAthena.webp",
       alt: "Wisdom of Athena",
       name: "Wisdom of Athena",
     },
     wildmansuperbonanza: {
       href: "/casino/pragmaticplay-wildman-super-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildmanSuperBonanza.webp",
       alt: "Wildman Super Bonanza",
       name: "Wildman Super Bonanza",
     },
     wildies: {
       href: "/casino/pragmaticplay-wildies",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Wildies.webp",
       alt: "Wildies",
       name: "Wildies",
     },
     wildwildebeestwins: {
       href: "/casino/pragmaticplay-wild-wildebeest-wins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildebeestWins.webp",
       alt: "Wild Wildebeest Wins",
       name: "Wild Wildebeest Wins",
     },
     wildwildwolf: {
       href: "/casino/pragmaticplay-wild-wild-wolf",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildWolf.webp",
       alt: "Wild Wild Wolf",
       name: "Wild Wild Wolf",
     },
     wildwildriches: {
       href: "/casino/pragmaticplay-wild-wild-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildRiches.webp",
       alt: "Wild Wild Riches",
       name: "Wild Wild Riches",
     },
     wildwildpearls: {
       href: "/casino/pragmaticplay-wild-wild-pearls",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildPearls.webp",
       alt: "Wild Wild Pearls",
       name: "Wild Wild Pearls",
     },
     wildwildjoker: {
       href: "/casino/pragmaticplay-wild-wild-joker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildJoker.webp",
       alt: "Wild Wild Joker",
       name: "Wild Wild Joker",
     },
     wildwildbananas: {
       href: "/casino/pragmaticplay-wild-wild-bananas",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWildBananas.webp",
       alt: "Wild Wild Bananas",
       name: "Wild Wild Bananas",
     },
     wildwestgoldmegaways: {
       href: "/casino/pragmaticplay-wild-west-gold-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWestGoldMegaways.webp",
       alt: "Wild West Gold Megaways",
       name: "Wild West Gold Megaways",
     },
     wildwestgoldblazingbounty: {
       href: "/casino/pragmaticplay-wild-west-gold-blazing-bounty",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWestGoldBlazingBounty.webp",
       alt: "Wild West Gold Blazing Bounty",
       name: "Wild West Gold Blazing Bounty",
     },
     wildwestgold: {
       href: "/casino/pragmaticplay-wild-west-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWestGold.webp",
       alt: "Wild West Gold",
       name: "Wild West Gold",
     },
     wildwestbounty: {
       href: "/casino/pragmaticplay-wild-west-bounty",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWestBounty.webp",
       alt: "Wild West Bounty",
       name: "Wild West Bounty",
     },
     wildwalker: {
       href: "/casino/pragmaticplay-wild-walker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildWalker.webp",
       alt: "Wild Walker",
       name: "Wild Walker",
     },
     wildspells: {
       href: "/casino/pragmaticplay-wild-spells",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildSpells.webp",
       alt: "Wild Spells",
       name: "Wild Spells",
     },
     wildpixies: {
       href: "/casino/pragmaticplay-wild-pixies",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildPixies.webp",
       alt: "Wild Pixies",
       name: "Wild Pixies",
     },
     wildhopdrop: {
       href: "/casino/pragmaticplay-wild-hopanddrop",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildHop&Drop.webp",
       alt: "Wild Hop&Drop",
       name: "Wild Hop&Drop",
     },
     wildgladiators: {
       href: "/casino/pragmaticplay-wild-gladiators",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildGladiators.webp",
       alt: "Wild Gladiators",
       name: "Wild Gladiators",
     },
     wilddepths: {
       href: "/casino/pragmaticplay-wild-depths",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildDepths.webp",
       alt: "Wild Depths",
       name: "Wild Depths",
     },
     wildcelebritybusmegaways: {
       href: "/casino/pragmaticplay-wild-celebrity-bus-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildCelebrityBusMegaways.webp",
       alt: "Wild Celebrity Bus Megaways",
       name: "Wild Celebrity Bus Megaways",
     },
     wildbooster: {
       href: "/casino/pragmaticplay-wild-booster",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildBooster.webp",
       alt: "Wild Booster",
       name: "Wild Booster",
     },
     wildbisoncharge: {
       href: "/casino/pragmaticplay-wild-bison-charge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildBisonCharge.webp",
       alt: "Wild Bison Charge",
       name: "Wild Bison Charge",
     },
     wildbeachxmasparty: {
       href: "/casino/pragmaticplay-wild-beach-xmas-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildBeachXmasParty.webp",
       alt: "Wild Beach Xmas Party",
       name: "Wild Beach Xmas Party",
     },
     wildbeachparty: {
       href: "/casino/pragmaticplay-wild-beach-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WildBeachParty.webp",
       alt: "Wild Beach Party",
       name: "Wild Beach Party",
     },
     wheelogold: {
       href: "/casino/pragmaticplay-wheel-ogold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WheelOGold.webp",
       alt: "Wheel O'Gold",
       name: "Wheel O'Gold",
     },
     wavesofposeidon: {
       href: "/casino/pragmaticplay-waves-of-poseidon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WavesofPoseidon.webp",
       alt: "Waves of Poseidon",
       name: "Waves of Poseidon",
     },
 
     LuckysWildPub: {
       href: "/casino/pragmaticplay-luckys-wild-pub",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckysWildPub.webp",
       alt: "Lucky’s Wild Pub",
       name: "Lucky’s Wild Pub",
     },
     LuckyNewYear: {
       href: "/casino/pragmaticplay-lucky-new-year",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyNewYear.webp",
       alt: "Lucky New Year",
       name: "Lucky New Year",
     },
     LuckyLightning: {
       href: "/casino/pragmaticplay-lucky-lightning",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyLightning.webp",
       alt: "Lucky Lightning",
       name: "Lucky Lightning",
     },
     LuckyGraceAndCharm: {
       href: "/casino/pragmaticplay-lucky-grace-and-charm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyGraceAndCharm.webp",
       alt: "Lucky Grace And Charm",
       name: "Lucky Grace And Charm",
     },
     LuckyFishingMegaways: {
       href: "/casino/pragmaticplay-lucky-fishing-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyFishingMegaways.webp",
       alt: "Lucky Fishing Megaways",
       name: "Lucky Fishing Megaways",
     },
     LuckyDragons: {
       href: "/casino/pragmaticplay-lucky-dragons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyDragons.webp",
       alt: "Lucky Dragons",
       name: "Lucky Dragons",
     },
     LuckyDragonBall: {
       href: "/casino/pragmaticplay-lucky-dragon-ball",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LuckyDragonBall.webp",
       alt: "Lucky Dragon Ball",
       name: "Lucky Dragon Ball",
     },
     LokisRiches: {
       href: "/casino/pragmaticplay-lokis-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LokisRiches.webp",
       alt: "Loki's Riches",
       name: "Loki's Riches",
     },
     LobsterBobSeaFoodandWinIt: {
       href: "/casino/pragmaticplay-lobster-bobs-sea-food-and-win-it",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LobsterBobsSeaFoodandWinIt.webp",
       alt: "Lobster Bob's Sea Food and Win It",
       name: "Lobster Bob's Sea Food and Win It",
     },
     LobsterBobsCrazyCrabShack: {
       href: "/casino/pragmaticplay-lobster-bobs-crazy-crab-shack",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LobsterBobsCrazyCrabShack.webp",
       alt: "Lobster Bobs Crazy Crab Shack",
       name: "Lobster Bobs Crazy Crab Shack",
     },
     LittleGemHoldandSpin: {
       href: "/casino/pragmaticplay-waves-of-poseidon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LittleGemHoldandSpin.webp",
       alt: "Little Gem Hold and Spin",
       name: "Little Gem Hold and Spin",
     },
     LeprechaunSong: {
       href: "/casino/pragmaticplay-leprechaun-song",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LeprechaunSong.webp",
       alt: "Leprechaun Song",
       name: "Leprechaun Song",
     },
     LeprechaunCarol: {
       href: "/casino/pragmaticplay-leprechaun-carol",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LeprechaunCarol.webp",
       alt: "Leprechaun Carol",
       name: "Leprechaun Carol",
     },
     LeprechaunCarol: {
       href: "/casino/pragmaticplay-legend-of-heroes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LegendofHeroes.webp",
       alt: "Legend of Heroes",
       name: "Legend of Heroes",
     },
     LegendofGaruda: {
       href: "/casino/pragmaticplay-legend-of-garuda",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LegendofGaruda.webp",
       alt: "Legend of Garuda",
       name: "Legend of Garuda",
     },
     LaughingFortune: {
       href: "/casino/pragmaticplay-laughing-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LaughingFortune.webp",
       alt: "Laughing Fortune",
       name: "Laughing Fortune",
     },
     LampOfInfinity: {
       href: "/casino/pragmaticplay-laughing-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LampOfInfinity.webp",
       alt: "Lamp Of Infinity",
       name: "Lamp Of Infinity",
     },
     LadyBugLuck: {
       href: "/casino/pragmaticplay-ladybug-luck",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LadyBugLuck.webp",
       alt: "LadyBug Luck",
       name: "LadyBug Luck",
     },
     LadyGodiva: {
       href: "/casino/pragmaticplay-lady-godiva",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LadyGodiva.webp",
       alt: "Lady Godiva",
       name: "Lady Godiva",
     },
     ladydmegaways: {
       href: "/casino/pragmaticplay-lady-d-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LadyDMegaways.webp",
       alt: "Lady D Megaways",
       name: "Lady D Megaways",
     },
 
     ladbrokesheat: {
       href: "/casino/pragmaticplay-ladbrokes-heat",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LadbrokesHeat.webp",
       alt: "Ladbrokes Heat",
       name: "Ladbrokes Heat",
     },
     lamokawildpowernudge: {
       href: "/casino/pragmaticplay-la-moka-wild-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/LaMokaWildPowernudge.webp",
       alt: "La Moka Wild Powernudge",
       name: "La Moka Wild Powernudge",
     },
     koipond: {
       href: "/casino/pragmaticplay-koi-pond",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KoiPond.webp",
       alt: "Koi Pond",
       name: "Koi Pond",
     },
     koibonanzajackpotplay: {
       href: "/casino/pragmaticplay-koi-bonanza-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KoiBonanzaJackpotPlay.webp",
       alt: "Koi Bonanza Jackpot Play",
       name: "Koi Bonanza Jackpot Play",
     },
     knighthotspotz: {
       href: "/casino/pragmaticplay-knight-hot-spotz",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KnightHotSpotz.webp",
       alt: "Knight Hot Spotz",
       name: "Knight Hot Spotz",
     },
     kingdomofthedead: {
       href: "/casino/pragmaticplay-kingdom-of-the-dead",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KingdomofTheDead.webp",
       alt: "Kingdom of The Dead",
       name: "Kingdom of The Dead",
     },
     kingdomofatlantisjackpotplay: {
       href: "/casino/pragmaticplay-kingdom-of-atlantis-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KingdomofAtlantisJackpotPlay.webp",
       alt: "Kingdom of Atlantis Jackpot Play",
       name: "Kingdom of Atlantis Jackpot Play",
     },
     kingdomofasgard: {
       href: "/casino/pragmaticplay-kingdom-of-asgard",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KingdomofAsgard.webp",
       alt: "Kingdom of Asgard",
       name: "Kingdom of Asgard",
     },
     killordie: {
       href: "/casino/pragmaticplay-kill-or-die",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KillorDie.webp",
       alt: "Kill or Die",
       name: "Kill or Die",
     },
     jurassicgiants: {
       href: "/casino/pragmaticplay-jurassic-giants",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JurassicGiants.webp",
       alt: "Jurassic Giants",
       name: "Jurassic Giants",
     },
     junglegorilla: {
       href: "/casino/pragmaticplay-jungle-gorilla",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JungleGorilla.webp",
       alt: "Jungle Gorilla",
       name: "Jungle Gorilla",
     },
     juicyfruitsmultihold: {
       href: "/casino/pragmaticplay-juicy-fruits-multihold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JuicyFruitsMultihold.webp",
       alt: "Juicy Fruits Multihold",
       name: "Juicy Fruits Multihold",
     },
     juicyfruits: {
       href: "/casino/pragmaticplay-juicy-fruits",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JuicyFruits.webp",
       alt: "Juicy Fruits",
       name: "Juicy Fruits",
     },
     journeytothewest: {
       href: "/casino/pragmaticplay-journey-to-the-west",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JourneytotheWest.webp",
       alt: "Journey to the West",
       name: "Journey to the West",
     },
     jokersjewelstm: {
       href: "/casino/pragmaticplay-jokers-jewelstm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewels.webp",
       alt: "Joker's Jewels™",
       name: "Joker's Jewels™",
     },
     jokersjewelswild: {
       href: "/casino/pragmaticplay-jokers-jewels-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewelsWild.webp",
       alt: "Jokers Jewels Wild",
       name: "Jokers Jewels Wild",
     },
     jokersjewelshot: {
       href: "/casino/pragmaticplay-jokers-jewels-hot-u7047",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewelsHot.webp",
       alt: "Joker's Jewels Hot",
       name: "Joker's Jewels Hot",
     },
     jokersjewels: {
       href: "/casino/pragmaticplay-jokers-jewels",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewels.webp",
       alt: "Joker's Jewels",
       name: "Joker's Jewels",
     },
     jokersjewelsdice: {
       href: "/casino/pragmaticplay-jokers-jewels-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewelsDice.webp",
       alt: "Joker’s Jewels Dice",
       name: "Joker’s Jewels Dice",
     },
     jokersjewelscash: {
       href: "/casino/pragmaticplay-jokers-jewels-cash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokersJewelsCash.webp",
       alt: "Joker’s Jewels Cash",
       name: "Joker’s Jewels Cash",
     },
     jokerrace: {
       href: "/casino/pragmaticplay-joker-race",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokerRace.webp",
       alt: "Joker Race",
       name: "Joker Race",
     },
     jokerking: {
       href: "/casino/pragmaticplay-joker-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokerKing.webp",
       alt: "Joker King",
       name: "Joker King",
     },
     jokerblastbonanza: {
       href: "/casino/pragmaticplay-joker-blast-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JokerBlastBonanza.webp",
       alt: "Joker Blast Bonanza",
       name: "Joker Blast Bonanza",
     },
     joiasdaestrela: {
       href: "/casino/pragmaticplay-joias-da-estrela",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JoiasdaEstrela.webp",
       alt: "Joias da Estrela",
       name: "Joias da Estrela",
     },
     johnhunternellanticaroma: {
       href: "/casino/pragmaticplay-john-hunter-nellantica-roma",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JohnHunterNellAnticaRoma.webp",
       alt: "John Hunter Nell’Antica Roma",
       name: "John Hunter Nell’Antica Roma",
     },
     johnhunterandthetombofthescarabqueen: {
       href: "/casino/pragmaticplay-john-hunter-and-the-tomb-of-the-scarab-queen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/johnhunterandthetombofthescarabqueen.jpg",
       alt: "John Hunter and the Tomb of the Scarab Queen",
       name: "John Hunter and the Tomb of the Scarab Queen",
     },
     johnhunterandthequestforbermudariches: {
       href: "/casino/pragmaticplay-john-hunter-and-the-quest-for-bermuda-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl:
         "./images/pragmaticplay/JohnHunterandtheQuestforBermudaRiches.webp",
       alt: "John Hunter and the Quest for Bermuda Riches",
       name: "John Hunter and the Quest for Bermuda Riches",
     },
     johnhunterandthemayangods: {
       href: "/casino/pragmaticplay-john-hunter-and-the-mayan-gods",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JohnHunterandtheMayanGods.webp",
       alt: "John Hunter and the Mayan Gods",
       name: "John Hunter and the Mayan Gods",
     },
     johnhunterandthebookoftutmegaways: {
       href: "/casino/pragmaticplay-john-hunter-and-the-book-of-tut-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JohnHunterandtheBookofTutMegaways.webp",
       alt: "John Hunter and the Book of Tut Megaways",
       name: "John Hunter and the Book of Tut Megaways",
     },
     johnhunterandthebookoftut: {
       href: "/casino/pragmaticplay-john-hunter-and-the-book-of-tut",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JohnHunterandtheBookofTut.webp",
       alt: "John Hunter and the Book of Tut",
       name: "John Hunter and the Book of Tut",
     },
     jewelrush: {
       href: "/casino/pragmaticplay-jewel-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JewelRush.webp",
       alt: "Jewel Rush",
       name: "Jewel Rush",
     },
     jewelbonanza: {
       href: "/casino/pragmaticplay-jewel-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JewelBonanza.webp",
       alt: "Jewel Bonanza",
       name: "Jewel Bonanza",
     },
     jasminedreams: {
       href: "/casino/pragmaticplay-jasmine-dreams",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JasmineDreams.webp",
       alt: "Jasmine Dreams",
       name: "Jasmine Dreams",
     },
     jajananpasar: {
       href: "/casino/pragmaticplay-jajanan-pasar",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JajananPasar.webp",
       alt: "Jajanan Pasar",
       name: "Jajanan Pasar",
     },
     jadebutterfly: {
       href: "/casino/pragmaticplay-jade-butterfly",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JadeButterfly.webp",
       alt: "Jade Butterfly",
       name: "Jade Butterfly",
     },
     jackpothunter: {
       href: "/casino/pragmaticplay-jackpot-hunter",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/JackpotHunter.webp",
       alt: "Jackpot Hunter",
       name: "Jackpot Hunter",
     },
     irishcrown: {
       href: "/casino/pragmaticplay-irish-crown",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/IrishCrown.webp",
       alt: "Irish Crown",
       name: "Irish Crown",
     },
     infectivewild: {
       href: "/casino/pragmaticplay-infective-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/InfectiveWild.webp",
       alt: "Infective Wild",
       name: "Infective Wild",
     },
     icelobster: {
       href: "/casino/pragmaticplay-ice-lobster",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/IceLobster.webp",
       alt: "Ice Lobster",
       name: "Ice Lobster",
     },
     hotfiesta: {
       href: "/casino/pragmaticplay-hotfiesta",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Hotfiesta.webp",
       alt: "Hotfiesta",
       name: "Hotfiesta",
     },
     hottoburnmultiplier: {
       href: "/casino/pragmaticplay-hot-to-burn-multiplier",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurnMultiplier.webp",
       alt: "Hot to Burn Multiplier",
       name: "Hot to Burn Multiplier",
     },
     hottoburnjackpotplay: {
       href: "/casino/pragmaticplay-hot-to-burn-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurnJackpotPlay.webp",
       alt: "Hot to Burn Jackpot Play",
       name: "Hot to Burn Jackpot Play",
     },
     hottoburnholdandspin: {
       href: "/casino/pragmaticplay-hot-to-burn-hold-and-spin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurnHoldandSpin.webp",
       alt: "Hot to Burn Hold and Spin",
       name: "Hot to Burn Hold and Spin",
     },
     hottoburnextreme: {
       href: "/casino/pragmaticplay-hot-to-burn-extreme",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurnExtreme.webp",
       alt: "Hot to Burn Extreme",
       name: "Hot to Burn Extreme",
     },
     hottoburn7deadlyfreespins: {
       href: "/casino/pragmaticplay-hot-to-burn-7-deadly-free-spins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurn7DeadlyFreeSpins.webp",
       alt: "Hot to Burn 7 Deadly Free Spins",
       name: "Hot to Burn 7 Deadly Free Spins",
     },
     hottoburn: {
       href: "/casino/pragmaticplay-hot-to-burn",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HottoBurn.webp",
       alt: "Hot to Burn",
       name: "Hot to Burn",
     },
     hotsafari: {
       href: "/casino/pragmaticplay-hot-safari",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HotSafari.webp",
       alt: "Hot Safari",
       name: "Hot Safari",
     },
     hotpepper: {
       href: "/casino/pragmaticplay-hot-pepper",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HotPepper.webp",
       alt: "Hot Pepper",
       name: "Hot Pepper",
     },
     hotchilli: {
       href: "/casino/pragmaticplay-hot-chilli",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HotChilli.webp",
       alt: "Hot Chilli",
       name: "Hot Chilli",
     },
     honeyhoneyhoney: {
       href: "/casino/pragmaticplay-honey-honey-honey",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HoneyHoneyHoney.webp",
       alt: "Honey Honey Honey",
       name: "Honey Honey Honey",
     },
     holidayride: {
       href: "/casino/pragmaticplay-holiday-ride",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HolidayRide.webp",
       alt: "Holiday Ride",
       name: "Holiday Ride",
     },
     hokkaidowolf: {
       href: "/casino/pragmaticplay-hokkaido-wolf",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HokkaidoWolf.webp",
       alt: "Hokkaido Wolf",
       name: "Hokkaido Wolf",
     },
     hockeyleaguewildmatch: {
       href: "/casino/pragmaticplay-hockey-league-wild-match",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HockeyLeagueWildMatch.webp",
       alt: "Hockey League Wild Match",
       name: "Hockey League Wild Match",
     },
     wavemaster: {
       href: "/casino/pragmaticplay-wave-master",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/WaveMaster.webp",
       alt: "Wave Master",
       name: "Wave Master",
     },
     vulkanofolympus: {
       href: "/casino/pragmaticplay-vulkan-of-olympus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/vulkanofolympus.webp",
       alt: "Vulkan of Olympus",
       name: "Vulkan of Olympus",
     },
     voodoomagic: {
       href: "/casino/pragmaticplay-voodoo-magic",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VoodooMagic.webp",
       alt: "Voodoo Magic",
       name: "Voodoo Magic",
     },
     vikingsvstrolls: {
       href: "/casino/pragmaticplay-vikings-vs-trolls",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VikingsvsTrolls.webp",
       alt: "Vikings vs Trolls",
       name: "Vikings vs Trolls",
     },
     vikingforge: {
       href: "/casino/pragmaticplay-viking-forge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VikingForge.webp",
       alt: "Viking Forge",
       name: "Viking Forge",
     },
     viadelcorso: {
       href: "/casino/pragmaticplay-via-del-corso",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ViadelCorso.webp",
       alt: "Via del Corso",
       name: "Via del Corso",
     },
     vegasnights: {
       href: "/casino/pragmaticplay-vegas-nights",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VegasNights.webp",
       alt: "Vegas Nights",
       name: "Vegas Nights",
     },
     vegasmagic: {
       href: "/casino/pragmaticplay-vegas-magic",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VegasMagic.webp",
       alt: "Vegas Magic",
       name: "Vegas Magic",
     },
     vegasadventures: {
       href: "/casino/pragmaticplay-vegas-adventures",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VegasAdventures.webp",
       alt: "Vegas Adventures",
       name: "Vegas Adventures",
     },
     vampiresvswolves: {
       href: "/casino/pragmaticplay-vampires-vs-wolves",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/VampiresvsWolves.webp",
       alt: "Vampires vs Wolves",
       name: "Vampires vs Wolves",
     },
     ultraholdandspin: {
       href: "/casino/pragmaticplay-ultra-hold-and-spin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/UltraHoldandSpin.webp",
       alt: "Ultra Hold and Spin",
       name: "Ultra Hold and Spin",
     },
     ultraburn: {
       href: "/casino/pragmaticplay-ultra-burn",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/UltraBurn.webp",
       alt: "Ultra Burn",
       name: "Ultra Burn",
     },
     twilightprincess: {
       href: "/casino/pragmaticplay-twilight-princess",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TwilightPrincess.webp",
       alt: "Twilight Princess",
       name: "Twilight Princess",
     },
     tundrasfortune: {
       href: "/casino/pragmaticplay-tundras-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TundrasFortune.webp",
       alt: "Tundras Fortune",
       name: "Tundras Fortune",
     },
     tucanito: {
       href: "/casino/pragmaticplay-tucanito",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Tucanito.webp",
       alt: "Tucanito",
       name: "Tucanito",
     },
     tsilidoghouse: {
       href: "/casino/pragmaticplay-tsili-dog-house",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TSILIDogHouse.webp",
       alt: "TSILI Dog House",
       name: "TSILI Dog House",
     },
     tropicaltiki: {
       href: "/casino/pragmaticplay-tropical-tiki",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TropicalTiki.webp",
       alt: "Tropical Tiki",
       name: "Tropical Tiki",
     },
     tropicalpopjackpotplay: {
       href: "/casino/pragmaticplay-tropical-pop-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TropicalPopJackpotPlay.webp",
       alt: "Tropical Pop Jackpot Play",
       name: "Tropical Pop Jackpot Play",
     },
     trolling1000: {
       href: "/casino/pragmaticplay-trolling-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Trolling1000.webp",
       alt: "Trolling 1000",
       name: "Trolling 1000",
     },
     tripletigers: {
       href: "/casino/pragmaticplay-triple-tigers",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TripleTigers.webp",
       alt: "Triple Tigers",
       name: "Triple Tigers",
     },
     triplepotgold: {
       href: "/casino/pragmaticplay-triple-pot-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TriplePotGold.webp",
       alt: "Triple Pot Gold",
       name: "Triple Pot Gold",
     },
     triplejokers: {
       href: "/casino/pragmaticplay-triple-jokers",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TripleJokers.webp",
       alt: "Triple Jokers",
       name: "Triple Jokers",
     },
     tripledragons: {
       href: "/casino/pragmaticplay-triple-dragons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TripleDragons.webp",
       alt: "Triple Dragons",
       name: "Triple Dragons",
     },
     treesoftreasure: {
       href: "/casino/pragmaticplay-trees-of-treasure",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TreesofTreasure.webp",
       alt: "Trees of Treasure",
       name: "Trees of Treasure",
     },
     treeofriches: {
       href: "/casino/pragmaticplay-tree-of-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TreeofRiches.webp",
       alt: "Tree of Riches",
       name: "Tree of Riches",
     },
     treasurewild: {
       href: "/casino/pragmaticplay-treasure-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TreasureWild.webp",
       alt: "Treasure Wild",
       name: "Treasure Wild",
     },
     treasuretrawler: {
       href: "/casino/pragmaticplay-treasure-trawler",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TreasureTrawler.webp",
       alt: "Treasure Trawler",
       name: "Treasure Trawler",
     },
     treasurehorse: {
       href: "/casino/pragmaticplay-treasure-horse",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TreasureHors.webp",
       alt: "Treasure Horse",
       name: "Treasure Horse",
     },
     traintoseoul: {
       href: "/casino/pragmaticplay-train-to-seoul",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TraintoSeoul.webp",
       alt: "Train to Seoul",
       name: "Train to Seoul",
     },
     toweringfortunes: {
       href: "/casino/pragmaticplay-towering-fortunes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ToweringFortunes.webp",
       alt: "Towering Fortunes",
       name: "Towering Fortunes",
     },
     tinytoads: {
       href: "/casino/pragmaticplay-tiny-toads",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TinyToads.webp",
       alt: "Tiny Toads",
       name: "Tiny Toads",
     },
     timberstacks: {
       href: "/casino/pragmaticplay-timber-stacks",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TimberStacks.webp",
       alt: "Timber Stacks",
       name: "Timber Stacks",
     },
     tigresortudo: {
       href: "/casino/pragmaticplay-tigre-sortudo",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TigreSortudo.webp",
       alt: "Tigre Sortudo",
       name: "Tigre Sortudo",
     },
     tictactake: {
       href: "/casino/pragmaticplay-tic-tac-take",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TicTacTake.webp",
       alt: "Tic Tac Take",
       name: "Tic Tac Take",
     },
     thundervsunderworld: {
       href: "/casino/pragmaticplay-thunder-vs-underworld",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ThundervsUnderworld.webp",
       alt: "Thunder vs Underworld",
       name: "Thunder vs Underworld",
     },
     threestarfortune: {
       href: "/casino/pragmaticplay-three-star-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ThreeStarFortune.webp",
       alt: "Three Star Fortune",
       name: "Three Star Fortune",
     },
     thewildgang: {
       href: "/casino/pragmaticplay-the-wild-gang",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheWildGang.webp",
       alt: "The Wild Gang",
       name: "The Wild Gang",
     },
     theultimate5: {
       href: "/casino/pragmaticplay-the-ultimate-5",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheUltimate5.webp",
       alt: "The Ultimate 5",
       name: "The Ultimate 5",
     },
     thetweetyhouse: {
       href: "/casino/pragmaticplay-the-tweety-house",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheTweetyHouse.webp",
       alt: "The Tweety House",
       name: "The Tweety House",
     },
     thetigerwarrior: {
       href: "/casino/pragmaticplay-the-tiger-warrior",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheTigerWarrior.webp",
       alt: "The Tiger Warrior",
       name: "The Tiger Warrior",
     },
     theroohouse: {
       href: "/casino/pragmaticplay-the-roo-house",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheRooHouse.webp",
       alt: "The Roo House",
       name: "The Roo House",
     },
     theredqueen: {
       href: "/casino/pragmaticplay-the-red-queen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheRedQueen.webp",
       alt: "The Red Queen",
       name: "The Red Queen",
     },
     themoneymenmegaways: {
       href: "/casino/pragmaticplay-the-money-men-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheMoneyMenMegaways.webp",
       alt: "The Money Men Megaways",
       name: "The Money Men Megaways",
     },
     themagiccauldronenchantedbrew: {
       href: "/casino/pragmaticplay-the-magic-cauldron-enchanted-brew",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheMagicCauldronEnchantedBrew.webp",
       alt: "The Magic Cauldron  Enchanted Brew",
       name: "The Magic Cauldron  Enchanted Brew",
     },
     theknightking: {
       href: "/casino/pragmaticplay-the-knight-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/KnightKing.webp",
       alt: "The Knight King",
       name: "The Knight King",
     },
     thehandofmidas: {
       href: "/casino/pragmaticplay-the-hand-of-midas",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheHandofMidas.webp",
       alt: "The Hand of Midas",
       name: "The Hand of Midas",
     },
     thegreensun: {
       href: "/casino/pragmaticplay-the-green-sun",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheGreenSun.webp",
       alt: "The Green Sun",
       name: "The Green Sun",
     },
     thegreatstickup: {
       href: "/casino/pragmaticplay-the-great-stick-up",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheGreatStickUp.webp",
       alt: "The Great Stick-Up",
       name: "The Great Stick-Up",
     },
     thegreatchickenescape: {
       href: "/casino/pragmaticplay-the-great-chicken-escape",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheGreatChickenEscape.webp",
       alt: "The Great Chicken Escape",
       name: "The Great Chicken Escape",
     },
     thedragontiger: {
       href: "/casino/pragmaticplay-the-dragon-tiger",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDragonTiger.webp",
       alt: "The Dragon Tiger",
       name: "The Dragon Tiger",
     },
     thedoghousemultihold: {
       href: "/casino/pragmaticplay-the-dog-house-multihold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseMultihold.webp",
       alt: "The Dog House Multihold",
       name: "The Dog House Multihold",
     },
     thedoghousemegaways: {
       href: "/casino/pragmaticplay-the-dog-house-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseMegaways.webp",
       alt: "The Dog House Megaways",
       name: "The Dog House Megaways",
     },
     thedoghousediceshow: {
       href: "/casino/pragmaticplay-the-dog-house-dice-show",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseDiceShow.webp",
       alt: "The Dog House Dice Show",
       name: "The Dog House Dice Show",
     },
     thedoghouseroyalhunt: {
       href: "/casino/pragmaticplay-the-dog-house-royal-hunt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseRoyalHunt.webp",
       alt: "The Dog House – Royal Hunt",
       name: "The Dog House – Royal Hunt",
     },
     thedoghousemuttleycrew: {
       href: "/casino/pragmaticplay-the-dog-house-muttley-crew",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseMuttleyCrew.webp",
       alt: "The Dog House - Muttley Crew",
       name: "The Dog House - Muttley Crew",
     },
     thedoghousedogoralive: {
       href: "/casino/pragmaticplay-the-dog-house-dog-or-alive",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheDogHouseDogorAlive.webp",
       alt: "The Dog House - Dog or Alive",
       name: "The Dog House - Dog or Alive",
     },
 
     thecatfatherpartii: {
       href: "/casino/pragmaticplay-the-catfather-part-ii",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheCatfatherPartII.webp",
       alt: "The Catfather Part II",
       name: "The Catfather Part II",
     },
     thecatfather: {
       href: "/casino/pragmaticplay-the-catfather",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheCatfather.webp",
       alt: "The Catfather",
       name: "The Catfather",
     },
     thebirdhouse: {
       href: "/casino/pragmaticplay-the-bird-house",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheBirdHouse.webp",
       alt: "The Bird House",
       name: "The Bird House",
     },
     thebigdawgs: {
       href: "/casino/pragmaticplay-the-big-dawgs",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheBigDawgs.webp",
       alt: "The Big Dawgs",
       name: "The Big Dawgs",
     },
     theamazingmoneymachine: {
       href: "/casino/pragmaticplay-the-amazing-money-machine",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheAmazingMoneyMachine.webp",
       alt: "The Amazing Money Machine",
       name: "The Amazing Money Machine",
     },
     thealterego: {
       href: "/casino/pragmaticplay-the-alter-ego",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TheAlterEgo.webp",
       alt: "The Alter Ego",
       name: "The Alter Ego",
     },
     temujintreasures: {
       href: "/casino/pragmaticplay-temujin-treasures",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TemujinTreasures.webp",
       alt: "Temujin Treasures",
       name: "Temujin Treasures",
     },
     templeguardians: {
       href: "/casino/pragmaticplay-temple-guardians",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TempleGuardians.webp",
       alt: "Temple Guardians",
       name: "Temple Guardians",
     },
     talesofegypt: {
       href: "/casino/pragmaticplay-tales-of-egypt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/TalesofEgypt.webp",
       alt: "Tales of Egypt",
       name: "Tales of Egypt",
     },
     swordofares: {
       href: "/casino/pragmaticplay-sword-of-ares",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SwordofAres.webp",
       alt: "Sword of Ares",
       name: "Sword of Ares",
     },
     sweetpowernudge: {
       href: "/casino/pragmaticplay-sweet-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetPowerNudge.webp",
       alt: "Sweet PowerNudge",
       name: "Sweet PowerNudge",
     },
     firebirdspirit: {
       href: "/casino/pragmaticplay-firebird-spirit",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FirebirdSpirit.webp",
       alt: "Firebird Spirit",
       name: "Firebird Spirit",
     },
     sweetkingdom: {
       href: "/casino/pragmaticplay-sweet-kingdom",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetKingdom.webp",
       alt: "Sweet Kingdom",
       name: "Sweet Kingdom",
     },
     sweetfiesta: {
       href: "/casino/pragmaticplay-sweet-fiesta",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetFiesta.webp",
       alt: "Sweet Fiesta",
       name: "Sweet Fiesta",
     },
     sweetbonanzaxmas: {
       href: "/casino/pragmaticplay-sweet-bonanza-xmas",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanzaXmas.webp",
       alt: "Sweet Bonanza Xmas",
       name: "Sweet Bonanza Xmas",
     },
     sweetbonanzasuperscatter: {
       href: "/casino/pragmaticplay-sweet-bonanza-super-scatter",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanzaSuperScatter.webp",
       alt: "Sweet Bonanza Super Scatter",
       name: "Sweet Bonanza Super Scatter",
     },
     sweetbonanzadice: {
       href: "/casino/pragmaticplay-sweet-bonanza-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanza.webp",
       alt: "Sweet Bonanza Dice",
       name: "Sweet Bonanza Dice",
     },
     sweetbonanzadice: {
       href: "/casino/pragmaticplay-sweet-bonanza-1000-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanza1000Dice.webp",
       alt: "Sweet Bonanza 1000 Dice",
       name: "Sweet Bonanza 1000 Dice",
     },
     sweetbonanza1000: {
       href: "/casino/pragmaticplay-sweet-bonanza-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBonanza1000.webp",
       alt: "Sweet Bonanza 1000",
       name: "Sweet Bonanza 1000",
     },
 
     sweetbombdrop: {
       href: "/casino/pragmaticplay-sweet-bomb-drop",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBombDrop.webp",
       alt: "Sweet Bomb Drop",
       name: "Sweet Bomb Drop",
     },
     sweetbaklava: {
       href: "/casino/pragmaticplay-sweet-baklava",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SweetBaklava.webp",
       alt: "Sweet Baklava",
       name: "Sweet Baklava",
     },
     supermania: {
       href: "/casino/pragmaticplay-supermania",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Supermania.webp",
       alt: "Supermania",
       name: "Supermania",
     },
     superligaheroes: {
       href: "/casino/pragmaticplay-superliga-heroes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SuperligaHeroes.webp",
       alt: "Superliga Heroes",
       name: "Superliga Heroes",
     },
     superx: {
       href: "/casino/pragmaticplay-super-x",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SuperX.webp",
       alt: "Super X",
       name: "Super X",
     },
     superjoker: {
       href: "/casino/pragmaticplay-super-joker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SuperJoker.webp",
       alt: "Super Joker",
       name: "Super Joker",
     },
     super7s: {
       href: "/casino/pragmaticplay-super-7s",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Super7s.webp",
       alt: "Super 7s",
       name: "Super 7s",
     },
     sunstonejewels: {
       href: "/casino/pragmaticplay-sunstone-jewels",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SunstoneJewels.webp",
       alt: "Sunstone Jewels",
       name: "Sunstone Jewels",
     },
     sumosuprememegaways: {
       href: "/casino/pragmaticplay-sumo-supreme-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SumoSupremeMegaways.webp",
       alt: "Sumo Supreme Megaways",
       name: "Sumo Supreme Megaways",
     },
     sugartwist: {
       href: "/casino/pragmaticplay-sugar-twist",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarTwist.webp",
       alt: "Sugar Twist",
       name: "Sugar Twist",
     },
     sugarsupremepowernudge: {
       href: "/casino/pragmaticplay-sugar-supreme-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarSupremePowernudge.webp",
       alt: "Sugar Supreme Powernudge",
       name: "Sugar Supreme Powernudge",
     },
     sugarrushxmas: {
       href: "/casino/pragmaticplay-sugar-rush-xmas",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarRushXmas.webp",
       alt: "Sugar Rush Xmas",
       name: "Sugar Rush Xmas",
     },
     sugarrushdice: {
       href: "/casino/pragmaticplay-sugar-rush-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarRushDice.webp",
       alt: "Sugar Rush Dice",
       name: "Sugar Rush Dice",
     },
     sugarrush1000: {
       href: "/casino/pragmaticplay-sugar-rush-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SugarRush1000.webp",
       alt: "Sugar Rush 1000",
       name: "Sugar Rush 1000",
     },
 
     strikinghot5jackpotplay: {
       href: "/casino/pragmaticplay-striking-hot-5-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StrikingHot5JackpotPlay.webp",
       alt: "Striking Hot 5 Jackpot Play",
       name: "Striking Hot 5 Jackpot Play",
     },
     strikinghot5: {
       href: "/casino/pragmaticplay-striking-hot-5",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StrikingHot5.webp",
       alt: "Striking Hot 5",
       name: "Striking Hot 5",
     },
     strikefrenzy: {
       href: "/casino/pragmaticplay-strike-frenzy",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StrikeFrenzy.webp",
       alt: "Strike Frenzy",
       name: "Strike Frenzy",
     },
     streetracer: {
       href: "/casino/pragmaticplay-street-racer",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StreetRacer.webp",
       alt: "Street Racer",
       name: "Street Racer",
     },
     strawberrycocktail: {
       href: "/casino/pragmaticplay-strawberry-cocktail",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StrawberryCocktail.webp",
       alt: "Strawberry Cocktail",
       name: "Strawberry Cocktail",
     },
     stickybees: {
       href: "/casino/pragmaticplay-sticky-bees",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StickyBees.webp",
       alt: "Sticky Bees",
       name: "Sticky Bees",
     },
     starzmegaways: {
       href: "/casino/pragmaticplay-starz-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarzMegaways.webp",
       alt: "Starz Megaways",
       name: "Starz Megaways",
     },
     starlightprincesspachi: {
       href: "/casino/pragmaticplay-starlight-princess-pachi",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarlightPrincessPachi.webp",
       alt: "Starlight Princess Pachi",
       name: "Starlight Princess Pachi",
     },
     starlightprincess1000: {
       href: "/casino/pragmaticplay-starlight-princess-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarlightPrincess1000.webp",
       alt: "Starlight Princess 1000",
       name: "Starlight Princess 1000",
     },
     starlightprincess: {
       href: "/casino/pragmaticplay-starlight-princess",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarlightPrincess.webp",
       alt: "Starlight Princess",
       name: "Starlight Princess",
     },
     starlightchristmas: {
       href: "/casino/pragmaticplay-starlight-christmas",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarlightChristmas.webp",
       alt: "Starlight Christmas",
       name: "Starlight Christmas",
     },
     starpiratescode: {
       href: "/casino/pragmaticplay-star-pirates-code",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarPiratesCode.webp",
       alt: "Star Pirates Code",
       name: "Star Pirates Code",
     },
     starbounty: {
       href: "/casino/pragmaticplay-star-bounty",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/StarBounty.webp",
       alt: "Star Bounty",
       name: "Star Bounty",
     },
     spinscoremegaways: {
       href: "/casino/pragmaticplay-spin-and-score-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Spin&ScoreMegaways.webp",
       alt: "Spin & Score Megaways",
       name: "Spin & Score Megaways",
     },
     spellbindingmystery: {
       href: "/casino/pragmaticplay-spellbinding-mystery",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SpellbindingMystery.webp",
       alt: "Spellbinding Mystery",
       name: "Spellbinding Mystery",
     },
     spartanking: {
       href: "/casino/pragmaticplay-spartan-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SpartanKing.webp",
       alt: "Spartan King",
       name: "Spartan King",
     },
     snakesandladdersmegadice: {
       href: "/casino/pragmaticplay-snakes-and-ladders-megadice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SnakesandLaddersMegadice.webp",
       alt: "Snakes and Ladders Megadice",
       name: "Snakes and Ladders Megadice",
     },
     snakesladderssnakeeyes: {
       href: "/casino/pragmaticplay-snakes-and-ladders-snake-eyes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Snakes&LaddersSnakeEyes.webp",
       alt: "Snakes & Ladders - Snake Eyes",
       name: "Snakes & Ladders - Snake Eyes",
     },
     smugglerscove: {
       href: "/casino/pragmaticplay-smugglers-cove",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SmugglersCove.webp",
       alt: "Smugglers Cove",
       name: "Smugglers Cove",
     },
     slushieparty: {
       href: "/casino/pragmaticplay-slushie-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SlushieParty.webp",
       alt: "Slushie Party",
       name: "Slushie Party",
     },
     slotmaniarabbit: {
       href: "/casino/pragmaticplay-slot-mania-rabbit",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SlotManiaRabbit.webp",
       alt: "Slot Mania Rabbit",
       name: "Slot Mania Rabbit",
     },
     sleepingdragon: {
       href: "/casino/pragmaticplay-sleeping-dragon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SleepingDragon.webp",
       alt: "Sleeping Dragon",
       name: "Sleeping Dragon",
     },
     skybounty: {
       href: "/casino/pragmaticplay-sky-bounty",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SkyBounty.webp",
       alt: "Sky Bounty",
       name: "Sky Bounty",
     },
     shotsforslots: {
       href: "/casino/pragmaticplay-shots-for-slots",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/shotsforslots.webp",
       alt: "Shots for Slots",
       name: "Shots for Slots",
     },
     shininghot5jackpotplay: {
       href: "/casino/pragmaticplay-shining-hot-5-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot5JackpotPlay.webp",
       alt: "Shining Hot 5 Jackpot Play",
       name: "Shining Hot 5 Jackpot Play",
     },
     shininghot5: {
       href: "/casino/pragmaticplay-shining-hot-5",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot5.webp",
       alt: "Shining Hot 5",
       name: "Shining Hot 5",
     },
     shininghot40jackpotplay: {
       href: "/casino/pragmaticplay-shining-hot-40-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot40JackpotPlay.webp",
       alt: "Shining Hot 40 Jackpot Play",
       name: "Shining Hot 40 Jackpot Play",
     },
     shininghot40: {
       href: "/casino/pragmaticplay-shining-hot-40",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot40.webp",
       alt: "Shining Hot 40",
       name: "Shining Hot 40",
     },
     shininghot20jackpotplay: {
       href: "/casino/pragmaticplay-shining-hot-20-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot20Jackpotplay.webp",
       alt: "Shining Hot 20 Jackpot play",
       name: "Shining Hot 20 Jackpot play",
     },
     shininghot20: {
       href: "/casino/pragmaticplay-shining-hot-20",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot20.webp",
       alt: "Shining Hot 20",
       name: "Shining Hot 20",
     },
     shininghot100jackpotplay: {
       href: "/casino/pragmaticplay-shining-hot-100-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot100JackpotPlay.webp",
       alt: "Shining Hot 100 Jackpot Play",
       name: "Shining Hot 100 Jackpot Play",
     },
     shininghot100: {
       href: "/casino/pragmaticplay-shining-hot-100",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShiningHot100.webp",
       alt: "Shining Hot 100",
       name: "Shining Hot 100",
     },
     shieldofsparta: {
       href: "/casino/pragmaticplay-shield-of-sparta",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ShieldofSparta.webp",
       alt: "Shield of Sparta",
       name: "Shield of Sparta",
     },
     secretcitygold: {
       href: "/casino/pragmaticplay-secret-city-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SecretCityGold.webp",
       alt: "Secret City Gold",
       name: "Secret City Gold",
     },
     savannahlegend: {
       href: "/casino/pragmaticplay-savannah-legend",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SavannahLegend.webp",
       alt: "Savannah Legend",
       name: "Savannah Legend",
     },
     sasuntsidavit: {
       href: "/casino/pragmaticplay-sasuntsi-davit",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SasuntsiDavit.webp",
       alt: "Sasuntsi Davit",
       name: "Sasuntsi Davit",
     },
     sarayruyasi: {
       href: "/casino/pragmaticplay-saray-ruyasi",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SarayRuyasi.webp",
       alt: "Saray Ruyasi",
       name: "Saray Ruyasi",
     },
     santasxmasrush: {
       href: "/casino/pragmaticplay-santas-xmas-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SantasXmasRush.webp",
       alt: "Santas Xmas Rush",
       name: "Santas Xmas Rush",
     },
     SeaFantasy: {
       href: "/casino/pragmaticplay-sea-fantasy",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SeaFantasy.webp",
       alt: "Sea Fantasy",
       name: "Sea Fantasy",
     },
     santaswonderland: {
       href: "/casino/pragmaticplay-santas-wonderland",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SantasWonderland.webp",
       alt: "Santas Wonderland",
       name: "Santas Wonderland",
     },
     santasgreatgifts: {
       href: "/casino/pragmaticplay-santas-great-gifts",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SantasGreatGifts.webp",
       alt: "Santa’s Great Gifts",
       name: "Santa’s Great Gifts",
     },
     santa: {
       href: "/casino/pragmaticplay-santa",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Santa.webp",
       alt: "Santa",
       name: "Santa",
     },
     samuraicode: {
       href: "/casino/pragmaticplay-samurai-code",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SamuraiCode.webp",
       alt: "Samurai Code",
       name: "Samurai Code",
     },
     saiyanmania: {
       href: "/casino/pragmaticplay-saiyan-mania",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SaiyanMania.webp",
       alt: "Saiyan Mania",
       name: "Saiyan Mania",
     },
     safariking: {
       href: "/casino/pragmaticplay-safari-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SafariKing.webp",
       alt: "Safari King",
       name: "Safari King",
     },
     sabafufufu: {
       href: "/casino/pragmaticplay-saba-fu-fu-fu",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/SabaFuFuFu.webp",
       alt: "Saba Fu Fu Fu",
       name: "Saba Fu Fu Fu",
     },
     runningsushi: {
       href: "/casino/pragmaticplay-running-sushi",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RunningSushi.webp",
       alt: "Running Sushi",
       name: "Running Sushi",
     },
     runaway7s: {
       href: "/casino/pragmaticplay-runaway-7s",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Runaway7s.webp",
       alt: "Runaway 7s",
       name: "Runaway 7s",
     },
     rujakbonanza: {
       href: "/casino/pragmaticplay-rujak-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RujakBonanza.webp",
       alt: "Rujak Bonanza",
       name: "Rujak Bonanza",
     },
     romeoandjuliet: {
       href: "/casino/pragmaticplay-romeo-and-juliet",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RomeoandJuliet.webp",
       alt: "Romeo and Juliet",
       name: "Romeo and Juliet",
     },
     rockvegasmegaholdspin: {
       href: "/casino/pragmaticplay-rock-vegas-mega-hold-and-spin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RockVegasMegaHold&Spin.webp",
       alt: "Rock Vegas Mega Hold & Spin",
       name: "Rock Vegas Mega Hold & Spin",
     },
     robberstrike: {
       href: "/casino/pragmaticplay-robber-strike",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RobberStrike.webp",
       alt: "Robber Strike",
       name: "Robber Strike",
     },
     riverofstyx: {
       href: "/casino/pragmaticplay-river-of-styx",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiverofStyx.webp",
       alt: "River of Styx",
       name: "River of Styx",
     },
     riseofsamuraimegaways: {
       href: "/casino/pragmaticplay-rise-of-samurai-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofSamuraiMegaways.webp",
       alt: "Rise of Samurai Megaways",
       name: "Rise of Samurai Megaways",
     },
     riseofsamurai4: {
       href: "/casino/pragmaticplay-rise-of-samurai-4",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofSamurai4.webp",
       alt: "Rise of Samurai 4",
       name: "Rise of Samurai 4",
     },
     riseofsamurai3: {
       href: "/casino/pragmaticplay-rise-of-samurai-3",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofSamurai3.webp",
       alt: "Rise of Samurai 3",
       name: "Rise of Samurai 3",
     },
     riseofsamurai: {
       href: "/casino/pragmaticplay-rise-of-samurai",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofSamurai.webp",
       alt: "Rise of Samurai",
       name: "Rise of Samurai",
     },
     riseofpyramids: {
       href: "/casino/pragmaticplay-rise-of-pyramids",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofPyramids.webp",
       alt: "Rise of Pyramids",
       name: "Rise of Pyramids",
     },
     riseofgizapowernudge: {
       href: "/casino/pragmaticplay-rise-of-giza-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RiseofGizaPowerNudge.webp",
       alt: "Rise of Giza PowerNudge",
       name: "Rise of Giza PowerNudge",
     },
     riperewards: {
       href: "/casino/pragmaticplay-ripe-rewards",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RipeRewards.webp",
       alt: "Ripe Rewards",
       name: "Ripe Rewards",
     },
     ridethelightning: {
       href: "/casino/pragmaticplay-ride-the-lightning",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RideTheLightning.webp",
       alt: "Ride The Lightning",
       name: "Ride The Lightning",
     },
     revengeoflokimegaways: {
       href: "/casino/pragmaticplay-revenge-of-loki-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RevengeofLokiMegaways.webp",
       alt: "Revenge of Loki Megaways",
       name: "Revenge of Loki Megaways",
     },
     returnofthedead: {
       href: "/casino/pragmaticplay-return-of-the-dead",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ReturnoftheDead.webp",
       alt: "Return of the Dead",
       name: "Return of the Dead",
     },
     resurrectingriches: {
       href: "/casino/pragmaticplay-resurrecting-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ResurrectingRiches.webp",
       alt: "Resurrecting Riches",
       name: "Resurrecting Riches",
     },
     releasethekraken: {
       href: "/casino/pragmaticplay-release-the-kraken",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ReleasetheKraken.webp",
       alt: "Release the Kraken",
       name: "Release the Kraken",
     },
     releasethebison: {
       href: "/casino/pragmaticplay-release-the-bison",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ReleasetheBison.webp",
       alt: "Release the Bison",
       name: "Release the Bison",
     },
     reelbanks: {
       href: "/casino/pragmaticplay-reel-banks",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ReelBanks.webp",
       alt: "Reel Banks",
       name: "Reel Banks",
     },
     redhotluck: {
       href: "/casino/pragmaticplay-red-hot-luck",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RedHotLuck.webp",
       alt: "Red Hot Luck",
       name: "Red Hot Luck",
     },
     rainbowreels: {
       href: "/casino/pragmaticplay-rainbow-reels",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RainbowReels.webp",
       alt: "Rainbow Reels",
       name: "Rainbow Reels",
     },
     rainbowgold: {
       href: "/casino/pragmaticplay-rainbow-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RainbowGold.webp",
       alt: "Rainbow Gold",
       name: "Rainbow Gold",
     },
     ragingwaterfallmegaways: {
       href: "/casino/pragmaticplay-raging-waterfall-megawaystm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RagingWaterfallMegaways.webp",
       alt: "Raging Waterfall Megaways™",
       name: "Raging Waterfall Megaways™",
     },
     ragingbull: {
       href: "/casino/pragmaticplay-raging-bull",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RagingBull.webp",
       alt: "Raging Bull",
       name: "Raging Bull",
     },
     racingjoker: {
       href: "/casino/pragmaticplay-racing-joker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RacingJoker.webp",
       alt: "Racing Joker",
       name: "Racing Joker",
     },
     rabbitgarden: {
       href: "/casino/pragmaticplay-rabbit-garden",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/RabbitGarden.webp",
       alt: "Rabbit Garden",
       name: "Rabbit Garden",
     },
     queenie: {
       href: "/casino/pragmaticplay-queenie",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Queenie.webp",
       alt: "Queenie",
       name: "Queenie",
     },
     queenofgold: {
       href: "/casino/pragmaticplay-queen-of-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/QueenofGold.webp",
       alt: "Queen of Gold",
       name: "Queen of Gold",
     },
     queenofgods: {
       href: "/casino/pragmaticplay-queen-of-gods",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/QueenofGods.webp",
       alt: "Queen of Gods",
       name: "Queen of Gods",
     },
     pyramidking: {
       href: "/casino/pragmaticplay-pyramid-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PyramidKing.webp",
       alt: "Pyramid King",
       name: "Pyramid King",
     },
     pyramidbonanza: {
       href: "/casino/pragmaticplay-pyramid-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PyramidBonanza.webp",
       alt: "Pyramid Bonanza",
       name: "Pyramid Bonanza",
     },
     puresweet: {
       href: "/casino/pragmaticplay-pure-sweet",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/puresweet.webp",
       alt: "Pure Sweet",
       name: "Pure Sweet",
     },
     purefruit: {
       href: "/casino/pragmaticplay-pure-fruit",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PureFruit.webp",
       alt: "Pure Fruit",
       name: "Pure Fruit",
     },
     puffersvssharks: {
       href: "/casino/pragmaticplay-puffers-vs-sharks",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PuffersvsSharks.webp",
       alt: "Puffers vs Sharks",
       name: "Puffers vs Sharks",
     },
     pubkings: {
       href: "/casino/pragmaticplay-pub-kings",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PubKings.webp",
       alt: "Pub Kings",
       name: "Pub Kings",
     },
     powerofthormegaways: {
       href: "/casino/pragmaticplay-power-of-thor-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PowerofThorMegaways.webp",
       alt: "Power of Thor Megaways",
       name: "Power of Thor Megaways",
     },
     powerofninja: {
       href: "/casino/pragmaticplay-power-of-ninja",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PowerofNinja.webp",
       alt: "Power of Ninja",
       name: "Power of Ninja",
     },
     potoffortune: {
       href: "/casino/pragmaticplay-pot-of-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PotofFortune.webp",
       alt: "Pot of Fortune",
       name: "Pot of Fortune",
     },
     pompeiimegareelsmegaways: {
       href: "/casino/pragmaticplay-pompeii-megareels-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PompeiiMegareelsMegaways.webp",
       alt: "Pompeii Megareels Megaways",
       name: "Pompeii Megareels Megaways",
     },
     pizzapizzapizza: {
       href: "/casino/pragmaticplay-pizza-pizza-pizza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PIZZAPIZZAPIZZA.webp",
       alt: "PIZZA PIZZA PIZZA",
       name: "PIZZA PIZZA PIZZA",
     },
     pixiewings: {
       href: "/casino/pragmaticplay-pixie-wings",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PixieWings.webp",
       alt: "Pixie Wings",
       name: "Pixie Wings",
     },
     piratespub: {
       href: "/casino/pragmaticplay-pirates-pub",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PiratesPub.webp",
       alt: "Pirates Pub",
       name: "Pirates Pub",
     },
     piratequest1000: {
       href: "/casino/pragmaticplay-pirate-quest-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PirateQuest1000.webp",
       alt: "Pirate Quest 1000",
       name: "Pirate Quest 1000",
     },
     pirategoldenage: {
       href: "/casino/pragmaticplay-pirate-golden-age",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PirateGoldenAge.webp",
       alt: "Pirate Golden Age",
       name: "Pirate Golden Age",
     },
     pirategolddeluxe: {
       href: "/casino/pragmaticplay-pirate-gold-deluxe",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PirateGoldDeluxe.webp",
       alt: "Pirate Gold Deluxe",
       name: "Pirate Gold Deluxe",
     },
     pirategold: {
       href: "/casino/pragmaticplay-pirate-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PirateGold.webp",
       alt: "Pirate Gold",
       name: "Pirate Gold",
     },
     pinupgirls: {
       href: "/casino/pragmaticplay-pinup-girls",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PinupGirls.webp",
       alt: "Pinup Girls",
       name: "Pinup Girls",
     },
     piggyrockparty: {
       href: "/casino/pragmaticplay-piggy-rock-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PiggyRockParty.webp",
       alt: "Piggy Rock Party",
       name: "Piggy Rock Party",
     },
     piggybankers: {
       href: "/casino/pragmaticplay-piggy-bankers",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PiggyBankers.webp",
       alt: "Piggy Bankers",
       name: "Piggy Bankers",
     },
     piggybankbills: {
       href: "/casino/pragmaticplay-piggy-bank-bills",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PiggyBankBills.webp",
       alt: "Piggy Bank Bills",
       name: "Piggy Bank Bills",
     },
     phoenixforge: {
       href: "/casino/pragmaticplay-phoenix-forge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PhoenixForge.webp",
       alt: "Phoenix Forge",
       name: "Phoenix Forge",
     },
     peppespepperonipizzaplaza: {
       href: "/casino/pragmaticplay-peppes-pepperoni-pizza-plaza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PeppesPepperoniPizzaPlaza.webp",
       alt: "Peppes Pepperoni Pizza Plaza",
       name: "Peppes Pepperoni Pizza Plaza",
     },
     penguinschristmaspartytime: {
       href: "/casino/pragmaticplay-penguins-christmas-party-time",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PenguinsChristmasPartyTime.webp",
       alt: "Penguins Christmas Party Time",
       name: "Penguins Christmas Party Time",
     },
     pekingluck: {
       href: "/casino/pragmaticplay-peking-luck",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PekingLuck.webp",
       alt: "Peking Luck",
       name: "Peking Luck",
     },
     peakpower: {
       href: "/casino/pragmaticplay-peak-power",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PeakPower.webp",
       alt: "Peak Power",
       name: "Peak Power",
     },
     pantherqueen: {
       href: "/casino/pragmaticplay-panther-queen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PantherQueen.webp",
       alt: "Panther Queen",
       name: "Panther Queen",
     },
     pandafortune2: {
       href: "/casino/pragmaticplay-panda-fortune-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PandaFortune2.webp",
       alt: "Panda Fortune 2",
       name: "Panda Fortune 2",
     },
     pandafortune: {
       href: "/casino/pragmaticplay-panda-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/PandaFortune.webp",
       alt: "Panda Fortune",
       name: "Panda Fortune",
     },
     oodlesofnoodles: {
       href: "/casino/pragmaticplay-oodles-of-noodles",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/OodlesofNoodles.webp",
       alt: "Oodles of Noodles",
       name: "Oodles of Noodles",
     },
     oly: {
       href: "/casino/pragmaticplay-oly",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/oly.webp",
       alt: "Oly",
       name: "Oly",
     },
     oldgoldminermegaways: {
       href: "/casino/pragmaticplay-old-gold-miner-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/OldGoldMinerMegaways.webp",
       alt: "Old Gold Miner Megaways",
       name: "Old Gold Miner Megaways",
     },
     oishiibonanza: {
       href: "/casino/pragmaticplay-oishii-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/OishiiBonanza.webp",
       alt: "Oishii Bonanza",
       name: "Oishii Bonanza",
     },
     octobeerfortunes: {
       href: "/casino/pragmaticplay-octobeer-fortunes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/OctobeerFortunes.webp",
       alt: "Octobeer Fortunes",
       name: "Octobeer Fortunes",
     },
     northguardians: {
       href: "/casino/pragmaticplay-north-guardians",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/NorthGuardians.webp",
       alt: "North Guardians",
       name: "North Guardians",
     },
     nilefortunes: {
       href: "/casino/pragmaticplay-nile-fortunes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/NileFortunes.webp",
       alt: "Nile Fortunes",
       name: "Nile Fortunes",
     },
     nexusgatesofolympus: {
       href: "/casino/pragmaticplay-nexus-gates-of-olympus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/nexusgatesofolympus.webp",
       alt: "Nexus Gates of Olympus",
       name: "Nexus Gates of Olympus",
     },
     newyeartigertreasures: {
       href: "/casino/pragmaticplay-new-year-tiger-treasures",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/NewYearTigerTreasures.webp",
       alt: "New Year Tiger Treasures",
       name: "New Year Tiger Treasures",
     },
     newtalesofegypt: {
       href: "/casino/pragmaticplay-new-tales-of-egypt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/NewTalesofEgypt.webp",
       alt: "New Tales of Egypt",
       name: "New Tales of Egypt",
     },
     mysticchief: {
       href: "/casino/pragmaticplay-mystic-chief",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MysticChief.webp",
       alt: "Mystic Chief",
       name: "Mystic Chief",
     },
     mysteryoftheorient: {
       href: "/casino/pragmaticplay-mystery-of-the-orient",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/mysteryoftheorient.jpg",
       alt: "Mystery of the Orient",
       name: "Mystery of the Orient",
     },
     mysterymice: {
       href: "/casino/pragmaticplay-mystery-mice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MysteryMice.webp",
       alt: "Mystery Mice",
       name: "Mystery Mice",
     },
     mysteriousegypt: {
       href: "/casino/pragmaticplay-mysterious-egypt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MysteriousEgypt.webp",
       alt: "Mysterious Egypt",
       name: "Mysterious Egypt",
     },
     mustangtrail: {
       href: "/casino/pragmaticplay-mustang-trail",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MustangTrail.webp",
       alt: "Mustang Trail",
       name: "Mustang Trail",
     },
     mustanggold: {
       href: "/casino/pragmaticplay-mustang-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MustangGold.webp",
       alt: "Mustang Gold",
       name: "Mustang Gold",
     },
     mummysjewels: {
       href: "/casino/pragmaticplay-mummys-jewels",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MummysJewel.webp",
       alt: "Mummy's Jewels",
       name: "Mummy's Jewels",
     },
     muertosmultipliermegaways: {
       href: "/casino/pragmaticplay-muertos-multiplier-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MuertosMultiplierMegaways.webp",
       alt: "Muertos Multiplier Megaways",
       name: "Muertos Multiplier Megaways",
     },
     mrtainsfurywildwildgladiator: {
       href: "/casino/pragmaticplay-mr-tains-fury-wild-wild-gladiator",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MrTainsFuryWildWildGladiator.webp",
       alt: "Mr Tain's Fury: Wild Wild Gladiator",
       name: "Mr Tain's Fury: Wild Wild Gladiator",
     },
     mrtainsfishingadventures: {
       href: "/casino/pragmaticplay-mr-tains-fishing-adventures",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MrTainsFishingAdventures.webp",
       alt: "Mr Tains Fishing Adventures",
       name: "Mr Tains Fishing Adventures",
     },
     mpoplayaztecgems: {
       href: "/casino/pragmaticplay-mpoplay-aztec-gems",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MPOPLAYAztecGems.webp",
       alt: "MPOPLAY Aztec Gems",
       name: "MPOPLAY Aztec Gems",
     },
     moonshot: {
       href: "/casino/pragmaticplay-moonshot",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Moonshot.webp",
       alt: "Moonshot",
       name: "Moonshot",
     },
     monstersuperlanche: {
       href: "/casino/pragmaticplay-monster-superlanche",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MonsterSuperlanche.webp",
       alt: "Monster Superlanche",
       name: "Monster Superlanche",
     },
     monkeywarrior: {
       href: "/casino/pragmaticplay-monkey-warrior",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MonkeyWarrior.webp",
       alt: "Monkey Warrior",
       name: "Monkey Warrior",
     },
     monkeymadness: {
       href: "/casino/pragmaticplay-monkey-madness",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MonkeyMadness.webp",
       alt: "Monkey Madness",
       name: "Monkey Madness",
     },
     moneystacks: {
       href: "/casino/pragmaticplay-money-stacks",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MoneyStacks.webp",
       alt: "Money Stacks",
       name: "Money Stacks",
     },
     moneymouse: {
       href: "/casino/pragmaticplay-money-mouse",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MoneyMouse.webp",
       alt: "Money Mouse",
       name: "Money Mouse",
     },
     moneymoneymoney: {
       href: "/casino/pragmaticplay-money-money-money",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MoneyMoneyMoney.webp",
       alt: "Money Money Money",
       name: "Money Money Money",
     },
     moleionaire: {
       href: "/casino/pragmaticplay-moleionaire",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Moleionaire.webp",
       alt: "Moleionaire",
       name: "Moleionaire",
     },
     mochimon: {
       href: "/casino/pragmaticplay-mochimon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Mochimon.webp",
       alt: "Mochimon",
       name: "Mochimon",
     },
     miningrush: {
       href: "/casino/pragmaticplay-mining-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MiningRush.webp",
       alt: "Mining Rush",
       name: "Mining Rush",
     },
     mightymunchingmelons: {
       href: "/casino/pragmaticplay-mighty-munching-melons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MightyMunchingMelons.webp",
       alt: "Mighty Munching Melons",
       name: "Mighty Munching Melons",
     },
     mightykong: {
       href: "/casino/pragmaticplay-mighty-kong",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MightyKong.webp",
       alt: "Mighty Kong",
       name: "Mighty Kong",
     },
     mightyhercules: {
       href: "/casino/pragmaticplay-mighty-hercules",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MightyHercules.webp",
       alt: "Mighty Hercules",
       name: "Mighty Hercules",
     },
     mightofra: {
       href: "/casino/pragmaticplay-might-of-ra",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MightofRa.webp",
       alt: "Might of Ra",
       name: "Might of Ra",
     },
     medusasstone: {
       href: "/casino/pragmaticplay-medusas-stone",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MedusasStone.webp",
       alt: "Medusa's Stone",
       name: "Medusa's Stone",
     },
     masterjoker: {
       href: "/casino/pragmaticplay-master-joker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MasterJoker.webp",
       alt: "Master Joker",
       name: "Master Joker",
     },
     mastergems: {
       href: "/casino/pragmaticplay-master-gems",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MasterGems.webp",
       alt: "Master Gems",
       name: "Master Gems",
     },
     masterchensfortune: {
       href: "/casino/pragmaticplay-master-chens-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MasterChensFortune.webp",
       alt: "Master Chens Fortune",
       name: "Master Chens Fortune",
     },
     mammothgoldmegaways: {
       href: "/casino/pragmaticplay-mammoth-gold-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MammothGoldMegaways.webp",
       alt: "Mammoth Gold Megaways",
       name: "Mammoth Gold Megaways",
     },
     majesticexpressgoldrun: {
       href: "/casino/pragmaticplay-majestic-express-gold-run",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MajesticExpressGoldRun.webp",
       alt: "Majestic Express Gold Run",
       name: "Majestic Express Gold Run",
     },
     mahjongx: {
       href: "/casino/pragmaticplay-mahjong-x",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongX.webp",
       alt: "Mahjong X",
       name: "Mahjong X",
     },
     mahjongwinssuperscatter: {
       href: "/casino/pragmaticplay-mahjong-wins-super-scatter",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWinsSuperScatter.webp",
       alt: "Mahjong Wins Super Scatter",
       name: "Mahjong Wins Super Scatter",
     },
     mahjongwinsbonus: {
       href: "/casino/pragmaticplay-mahjong-wins-bonus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWinsBonus.webp",
       alt: "Mahjong Wins Bonus",
       name: "Mahjong Wins Bonus",
     },
     mahjongwins3blackscatter: {
       href: "/casino/pragmaticplay-mahjong-wins-3-black-scatter",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWins3BlackScatter.webp",
       alt: "Mahjong Wins 3 - Black Scatter",
       name: "Mahjong Wins 3 - Black Scatter",
     },
     mahjongwins2: {
       href: "/casino/pragmaticplay-mahjong-wins-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWins2.webp",
       alt: "Mahjong Wins 2",
       name: "Mahjong Wins 2",
     },
     mahjongwinsgongxifacai: {
       href: "/casino/pragmaticplay-mahjong-wins-gong-xi-fa-cai",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWinsGongXiFaCai.webp",
       alt: "Mahjong Wins - Gong Xi Fa Cai",
       name: "Mahjong Wins - Gong Xi Fa Cai",
     },
     mahjongwins: {
       href: "/casino/pragmaticplay-mahjong-wins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongWins.webp",
       alt: "Mahjong Wins",
       name: "Mahjong Wins",
     },
     mahjongpanda: {
       href: "/casino/pragmaticplay-mahjong-panda",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongPanda.webp",
       alt: "Mahjong Panda",
       name: "Mahjong Panda",
     },
     mahjongbonanza: {
       href: "/casino/pragmaticplay-mahjong-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MahjongBonanza.webp",
       alt: "Mahjong Bonanza",
       name: "Mahjong Bonanza",
     },
     magicianssecrets: {
       href: "/casino/pragmaticplay-magicians-secrets",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MagiciansSecrets.webp",
       alt: "Magicians Secrets",
       name: "Magicians Secrets",
     },
     magicmoneymaze: {
       href: "/casino/pragmaticplay-magic-money-maze",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MagicMoneyMaze.webp",
       alt: "Magic Money Maze",
       name: "Magic Money Maze",
     },
     magicjourney: {
       href: "/casino/pragmaticplay-magic-journey",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MagicJourne.webp",
       alt: "Magic Journey",
       name: "Magic Journey",
     },
     magiccrystals: {
       href: "/casino/pragmaticplay-magic-crystals",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MagicCrysta.webp",
       alt: "Magic Crystals",
       name: "Magic Crystals",
     },
     madamemystiquemegaways: {
       href: "/casino/pragmaticplay-madame-mystique-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MadameMystiqueMegaways.webp",
       alt: "Madame Mystique Megaways",
       name: "Madame Mystique Megaways",
     },
     madamedestinymegaways: {
       href: "/casino/pragmaticplay-madame-destiny-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MadameDestinyMegaways.webp",
       alt: "Madame Destiny Megaways",
       name: "Madame Destiny Megaways",
     },
     madamedestiny: {
       href: "/casino/pragmaticplay-madame-destiny",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/MadameDestiny.webp",
       alt: "Madame Destiny",
       name: "Madame Destiny",
     },
     hockeyleague: {
       href: "/casino/pragmaticplay-hockey-league",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HockeyLeague.webp",
       alt: "Hockey League",
       name: "Hockey League",
     },
     hockeybonanza: {
       href: "/casino/pragmaticplay-hockey-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HockeyBonanza.webp",
       alt: "Hockey Bonanza",
       name: "Hockey Bonanza",
     },
     hockeyattack: {
       href: "/casino/pragmaticplay-hockey-attack",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HockeyAttack.webp",
       alt: "Hockey Attack",
       name: "Hockey Attack",
     },
     himalayanwild: {
       href: "/casino/pragmaticplay-himalayan-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HimalayanWild.webp",
       alt: "Himalayan Wild",
       name: "Himalayan Wild",
     },
     heroicspins: {
       href: "/casino/pragmaticplay-heroic-spins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HeroicSpins.webp",
       alt: "Heroic Spins",
       name: "Heroic Spins",
     },
 
     herculessonofzeus: {
       href: "/casino/pragmaticplay-hercules-son-of-zeus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HerculesSonofZeus.webp",
       alt: "Hercules Son of Zeus",
       name: "Hercules Son of Zeus",
     },
     herculesandpegasus: {
       href: "/casino/pragmaticplay-hercules-and-pegasus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HerculesandPegasus.webp",
       alt: "Hercules and Pegasus",
       name: "Hercules and Pegasus",
     },
     hellviswild: {
       href: "/casino/pragmaticplay-hellvis-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HellvisWild.webp",
       alt: "Hellvis Wild",
       name: "Hellvis Wild",
     },
     heistforthegoldennuggets: {
       href: "/casino/pragmaticplay-heist-for-the-golden-nuggets",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HeistfortheGoldenNuggets.webp",
       alt: "Heist for the Golden Nuggets",
       name: "Heist for the Golden Nuggets",
     },
     heartofrio: {
       href: "/casino/pragmaticplay-heart-of-rio",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HeartofRio.webp",
       alt: "Heart of Rio",
       name: "Heart of Rio",
     },
     heartofcleopatra: {
       href: "/casino/pragmaticplay-heart-of-cleopatra",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HeartofCleopatra.webp",
       alt: "Heart of Cleopatra",
       name: "Heart of Cleopatra",
     },
     havefesten: {
       href: "/casino/pragmaticplay-havefesten",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Havefesten.webp",
       alt: "Havefesten",
       name: "Havefesten",
     },
     happyhooves: {
       href: "/casino/pragmaticplay-happy-hooves",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HappyHooves.webp",
       alt: "Happy Hooves",
       name: "Happy Hooves",
     },
     happyfortune: {
       href: "/casino/pragmaticplay-happy-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HappyFortune.webp",
       alt: "Happy Fortune",
       name: "Happy Fortune",
     },
     handofmidas2: {
       href: "/casino/pragmaticplay-hand-of-midas-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/HandofMidas2.webp",
       alt: "Hand of Midas 2",
       name: "Hand of Midas 2",
     },
     guaranaeyesoftheamazon: {
       href: "/casino/pragmaticplay-guarana-eyes-of-the-amazon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GuaranaEyesoftheAmazon.webp",
       alt: "Guarana Eyes of the Amazon",
       name: "Guarana Eyes of the Amazon",
     },
     gretzkypowerpucks: {
       href: "/casino/pragmaticplay-gretzky-power-pucks",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GretzkyPowerPucks.webp",
       alt: "Gretzky Power Pucks",
       name: "Gretzky Power Pucks",
     },
     greekgods: {
       href: "/casino/pragmaticplay-greek-gods",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreekGods.webp",
       alt: "Greek Gods",
       name: "Greek Gods",
     },
     greedywolf: {
       href: "/casino/pragmaticplay-greedy-wolf",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreedyWolf.webp",
       alt: "Greedy Wolf",
       name: "Greedy Wolf",
     },
     greedyfortunepig: {
       href: "/casino/pragmaticplay-greedy-fortune-pig",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreedyFortunePig.webp",
       alt: "Greedy Fortune Pig",
       name: "Greedy Fortune Pig",
     },
     greatrhinomegaways: {
       href: "/casino/pragmaticplay-great-rhino-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreatRhinoMegaways.webp",
       alt: "Great Rhino Megaways",
       name: "Great Rhino Megaways",
     },
     greatrhinodeluxe: {
       href: "/casino/pragmaticplay-great-rhino-deluxe",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreatRhinoDeluxe.webp",
       alt: "Great Rhino Deluxe",
       name: "Great Rhino Deluxe",
     },
     greatrhino: {
       href: "/casino/pragmaticplay-great-rhino",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreatRhino.webp",
       alt: "Great Rhino",
       name: "Great Rhino",
     },
     greatreef: {
       href: "/casino/pragmaticplay-great-reef",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GreatReef.webp",
       alt: "Great Reef",
       name: "Great Reef",
     },
     gravitybonanza: {
       href: "/casino/pragmaticplay-gravity-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GravityBonanza.webp",
       alt: "Gravity Bonanza",
       name: "Gravity Bonanza",
     },
     graceofebisu: {
       href: "/casino/pragmaticplay-grace-of-ebisu",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GraceofEbisu.webp",
       alt: "Grace of Ebisu",
       name: "Grace of Ebisu",
     },
     gorillamayhem: {
       href: "/casino/pragmaticplay-gorilla-mayhem",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GorillaMayhem.webp",
       alt: "Gorilla Mayhem",
       name: "Gorilla Mayhem",
     },
     goodluckgoodfortune: {
       href: "/casino/pragmaticplay-good-luck-and-good-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoodLuck&GoodFortune.webp",
       alt: "Good Luck & Good Fortune",
       name: "Good Luck & Good Fortune",
     },
     goldenpig: {
       href: "/casino/pragmaticplay-golden-pig",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldenPig.webp",
       alt: "Golden Pig",
       name: "Golden Pig",
     },
     goldenox: {
       href: "/casino/pragmaticplay-golden-ox",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldenOx.webp",
       alt: "Golden Ox",
       name: "Golden Ox",
     },
     goldtraingpk: {
       href: "/casino/pragmaticplay-gold-train-gpk",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldTrainGPK.webp",
       alt: "Gold Train GPK",
       name: "Gold Train GPK",
     },
     goldtrain: {
       href: "/casino/pragmaticplay-gold-train",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldTrain.webp",
       alt: "Gold Train",
       name: "Gold Train",
     },
     goldrush: {
       href: "/casino/pragmaticplay-gold-rush",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldRush.webp",
       alt: "Gold Rush",
       name: "Gold Rush",
     },
     goldparty2afterhours: {
       href: "/casino/pragmaticplay-gold-party-2-after-hours",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldParty2AfterHours.webp",
       alt: "Gold Party 2 - After Hours",
       name: "Gold Party 2 - After Hours",
     },
     goldparty: {
       href: "/casino/pragmaticplay-gold-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldParty.webp",
       alt: "Gold Party",
       name: "Gold Party",
     },
     goldoasis: {
       href: "/casino/pragmaticplay-gold-oasis",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldOasis.webp",
       alt: "Gold Oasis",
       name: "Gold Oasis",
     },
     goldcarpbonanza: {
       href: "/casino/pragmaticplay-gold-carp-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoldCarpBonanza.webp",
       alt: "Gold Carp Bonanza",
       name: "Gold Carp Bonanza",
     },
     godsofgiza: {
       href: "/casino/pragmaticplay-gods-of-giza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GodsofGiza.webp",
       alt: "Gods of Giza",
       name: "Gods of Giza",
     },
     goblinheistpowernudge: {
       href: "/casino/pragmaticplay-goblin-heist-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GoblinHeistPowerNudg.webp",
       alt: "Goblin Heist PowerNudge",
       name: "Goblin Heist PowerNudge",
     },
     gloriousrome: {
       href: "/casino/pragmaticplay-glorious-rome",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GloriousRome.webp",
       alt: "Glorious Rome",
       name: "Glorious Rome",
     },
     gemstone: {
       href: "/casino/pragmaticplay-gemstone",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Gemstone.webp",
       alt: "Gemstone",
       name: "Gemstone",
     },
     gemsofserengeti: {
       href: "/casino/pragmaticplay-gems-of-serengeti",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GemsofSerengeti.webp",
       alt: "Gems of Serengeti",
       name: "Gems of Serengeti",
     },
     gemsbonanza: {
       href: "/casino/pragmaticplay-gems-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GemsBonanza.webp",
       alt: "Gems Bonanza",
       name: "Gems Bonanza",
     },
     gemine: {
       href: "/casino/pragmaticplay-gemine",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Gemine.webp",
       alt: "Gemine",
       name: "Gemine",
     },
     gemtrio: {
       href: "/casino/pragmaticplay-gem-trio",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GemTrio.webp",
       alt: "Gem Trio",
       name: "Gem Trio",
     },
     gemfirefortune: {
       href: "/casino/pragmaticplay-gem-fire-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GemFireFortune.webp",
       alt: "Gem Fire Fortune",
       name: "Gem Fire Fortune",
     },
     gemelevator: {
       href: "/casino/pragmaticplay-gem-elevator",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GemElevator.webp",
       alt: "Gem Elevator",
       name: "Gem Elevator",
     },
     gearsofhorus: {
       href: "/casino/pragmaticplay-gears-of-horus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GearsofHorus.webp",
       alt: "Gears of Horus",
       name: "Gears of Horus",
     },
     gatotkacasfury: {
       href: "/casino/pragmaticplay-gatot-kacas-fury",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatotKacasFury.webp",
       alt: "Gatot Kacas Fury",
       name: "Gatot Kacas Fury",
     },
     gatestoeldorado: {
       href: "/casino/pragmaticplay-gates-to-el-dorado",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/gatestoeldorado.webp",
       alt: "Gates to El Dorado",
       name: "Gates to El Dorado",
     },
     gatesofxibalba: {
       href: "/casino/pragmaticplay-gates-of-xibalba",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofXibalba.webp",
       alt: "Gates of Xibalba",
       name: "Gates of Xibalba",
     },
     gatesofvalhalla: {
       href: "/casino/pragmaticplay-gates-of-valhalla",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofValhalla.webp",
       alt: "Gates of Valhalla",
       name: "Gates of Valhalla",
     },
     gatesofolympusxmas1000: {
       href: "/casino/pragmaticplay-gates-of-olympus-xmas-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympusXmas1000.webp",
       alt: "Gates of Olympus Xmas 1000",
       name: "Gates of Olympus Xmas 1000",
     },
     gatesofolympussuper: {
       href: "/casino/pragmaticplay-gates-of-olympus-super-scatter",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympusSUPERSCATTER.webp",
       alt: "Gates of Olympus SUPER SCATTER",
       name: "Gates of Olympus SUPER SCATTER",
     },
     gatesofolympusdice: {
       href: "/casino/pragmaticplay-gates-of-olympus-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympusDice.webp",
       alt: "Gates of Olympus Dice",
       name: "Gates of Olympus Dice",
     },
     gatesofolympus1000dice: {
       href: "/casino/pragmaticplay-gates-of-olympus-1000-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympus1000Dice.webp",
       alt: "Gates of Olympus 1000 Dice",
       name: "Gates of Olympus 1000 Dice",
     },
     gatesofolympus1000: {
       href: "/casino/pragmaticplay-gates-of-olympus-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofOlympus1000.webp",
       alt: "Gates of Olympus 1000",
       name: "Gates of Olympus 1000",
     },
 
     gatesofmars: {
       href: "/casino/pragmaticplay-gates-of-mars",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/gatesofmars.webp",
       alt: "Gates of Mars",
       name: "Gates of Mars",
     },
     gatesofleovegas1000: {
       href: "/casino/pragmaticplay-gates-of-leovegas-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofLeoVegas1000.webp",
       alt: "Gates of LeoVegas 1000",
       name: "Gates of LeoVegas 1000",
     },
     gatesofhunny: {
       href: "/casino/pragmaticplay-gates-of-hunny",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/gatesofhunny.webp",
       alt: "Gates of LeoVegas 1000",
       name: "Gates of LeoVegas 1000",
     },
     gatesofheaven: {
       href: "/casino/pragmaticplay-gates-of-heaven",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofHeaven.webp",
       alt: "Gates of Heaven",
       name: "Gates of Heaven",
     },
 
     gatesofgatotkaca: {
       href: "/casino/pragmaticplay-gates-of-gatotkaca",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofGatotkaca.webp",
       alt: "Gates of Gatotkaca",
       name: "Gates of Gatotkaca",
     },
     gatesofgatotkaca1000: {
       href: "/casino/pragmaticplay-gates-of-gatot-kaca-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofGatotKaca1000.webp",
       alt: "Gates of Gatot Kaca 1000",
       name: "Gates of Gatot Kaca 1000",
     },
     gatesofdragonjackpotplay: {
       href: "/casino/pragmaticplay-gates-of-dragon-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofDragonJackpotPlay.webp",
       alt: "Gates of Dragon Jackpot Play",
       name: "Gates of Dragon Jackpot Play",
     },
     gatesofcresus: {
       href: "/casino/pragmaticplay-gates-of-cresus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofCresus.webp",
       alt: "Gates of Cresus",
       name: "Gates of Cresus",
     },
     gatesofaztec: {
       href: "/casino/pragmaticplay-gates-of-aztec",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GatesofAztec.webp",
       alt: "Gates of Aztec",
       name: "Gates of Aztec",
     },
     gameshowpartyjackpotplay: {
       href: "/casino/pragmaticplay-gameshow-party-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GameshowPartyJackpotPlay.webp",
       alt: "Gameshow Party Jackpot Play",
       name: "Gameshow Party Jackpot Play",
     },
     gamesinolympus: {
       href: "/casino/pragmaticplay-games-in-olympus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/GamesinOlympus.webp",
       alt: "Games in Olympus",
       name: "Games in Olympus",
     },
     furyofodinmegaways: {
       href: "/casino/pragmaticplay-fury-of-odin-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FuryofOdinMegaways.webp",
       alt: "Fury of Odin Megaways",
       name: "Fury of Odin Megaways",
     },
     fun88dragons: {
       href: "/casino/pragmaticplay-fun88-dragons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Fun88Dragons.webp",
       alt: "Fun88 Dragons",
       name: "Fun88 Dragons",
     },
     fufufu: {
       href: "/casino/pragmaticplay-fu-fu-fu",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FuFuFu.webp",
       alt: "Fu Fu Fu",
       name: "Fu Fu Fu",
     },
     fruitytreats: {
       href: "/casino/pragmaticplay-fruity-treats",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruityTreats.webp",
       alt: "Fruity Treats",
       name: "Fruity Treats",
     },
     fruityblast: {
       href: "/casino/pragmaticplay-fruity-blast",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruityBlast.webp",
       alt: "Fruity Blast",
       name: "Fruity Blast",
     },
     fruitsoftheamazon: {
       href: "/casino/pragmaticplay-fruits-of-the-amazon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruitsoftheAmazon.webp",
       alt: "Fruits of the Amazon",
       name: "Fruits of the Amazon",
     },
     fruitrainbow: {
       href: "/casino/pragmaticplay-fruit-rainbow",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruitRainbow.webp",
       alt: "Fruit Rainbow",
       name: "Fruit Rainbow",
     },
     fruitparty2: {
       href: "/casino/pragmaticplay-fruit-party-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruitParty2.webp",
       alt: "Fruit Party 2",
       name: "Fruit Party 2",
     },
     fruitparty: {
       href: "/casino/pragmaticplay-fruit-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FruitParty.webp",
       alt: "Fruit Party",
       name: "Fruit Party",
     },
     frozentropics: {
       href: "/casino/pragmaticplay-frozen-tropics",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FrozenTropics.webp",
       alt: "Frozen Tropics",
       name: "Frozen Tropics",
     },
     frontrunneroddson: {
       href: "/casino/pragmaticplay-front-runner-odds-on",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FrontRunnerOddsOn.webp",
       alt: "Front Runner Odds On",
       name: "Front Runner Odds On",
     },
     frogsandfruits: {
       href: "/casino/pragmaticplay-frogs-and-fruits",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FrogsandFruits.webp",
       alt: "Frogs and Fruits",
       name: "Frogs and Fruits",
     },
     frogsbugs: {
       href: "/casino/pragmaticplay-frogs-and-bugs",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Frogs&Bugs.webp",
       alt: "Frogs & Bugs",
       name: "Frogs & Bugs",
     },
     fortunesofaztec: {
       href: "/casino/pragmaticplay-fortunes-of-aztec",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FortunesofAztec.webp",
       alt: "Fortunes of Aztec",
       name: "Fortunes of Aztec",
     },
     fortuneofgiza: {
       href: "/casino/pragmaticplay-fortune-of-giza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FortuneofGiza.webp",
       alt: "Fortune of Giza",
       name: "Fortune of Giza",
     },
     fortunehitnroll: {
       href: "/casino/pragmaticplay-fortune-hitn-roll",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FortuneHitnRoll.webp",
       alt: "Fortune Hit'n Roll",
       name: "Fortune Hit'n Roll",
     },
     fortuneace: {
       href: "/casino/pragmaticplay-fortune-ace",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FortuneAce.webp",
       alt: "Fortune Ace",
       name: "Fortune Ace",
     },
     forgingwilds: {
       href: "/casino/pragmaticplay-forging-wilds",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ForgingWilds.webp",
       alt: "Forging Wilds",
       name: "Forging Wilds",
     },
     forgeofolympus: {
       href: "/casino/pragmaticplay-forge-of-olympus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ForgeofOlympus.webp",
       alt: "Forge of Olympus",
       name: "Forge of Olympus",
     },
     fonzosfelinefortunes: {
       href: "/casino/pragmaticplay-fonzos-feline-fortunes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FonzosFelineFortunes.webp",
       alt: "Fonzos Feline Fortunes",
       name: "Fonzos Feline Fortunes",
     },
     flyinghippo: {
       href: "/casino/pragmaticplay-flying-hippo",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FlyingHippo.webp",
       alt: "Flying Hippo",
       name: "Flying Hippo",
     },
     floatingdragonyearofthesnake: {
       href: "/casino/pragmaticplay-floating-dragon-year-of-the-snake",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FloatingDragonYearoftheSnake.webp",
       alt: "Floating Dragon Year of the Snake",
       name: "Floating Dragon Year of the Snake",
     },
     floatingdragonnewyearfestivalultramegawaysholdspin: {
       href: "/casino/pragmaticplay-floating-dragon-new-year-festival-ultra-megaways-hold-and-spin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl:
         "./images/pragmaticplay/FloatingDragonNewYearFestivalUltraMegawaysHold&Spin.webp",
       alt: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
       name: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
     },
     floatingdragonholdspinmegaways: {
       href: "/casino/pragmaticplay-floating-dragon-hold-and-spin-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FloatingDragonHold&SpinMegaways.webp",
       alt: "Floating Dragon Hold & Spin Megaways",
       name: "Floating Dragon Hold & Spin Megaways",
     },
     floatingdragondragonboatfestival: {
       href: "/casino/pragmaticplay-floating-dragon-dragon-boat-festival",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FloatingDragon-DragonBoatFestiva.webp",
       alt: "Floating Dragon  Dragon Boat Festival",
       name: "Floating Dragon  Dragon Boat Festival",
     },
     floatingdragon: {
       href: "/casino/pragmaticplay-floating-dragon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FloatingDragon.webp",
       alt: "Floating Dragon",
       name: "Floating Dragon",
     },
     fishinreels: {
       href: "/casino/pragmaticplay-fishin-reels",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FishinReels.webp",
       alt: "Fishin Reels",
       name: "Fishin Reels",
     },
     fisheye: {
       href: "/casino/pragmaticplay-fish-eye",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FishEye.webp",
       alt: "Fish Eye",
       name: "Fish Eye",
     },
     firestrike2: {
       href: "/casino/pragmaticplay-fire-strike-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireStrike2.webp",
       alt: "Fire Strike 2",
       name: "Fire Strike 2",
     },
     firestrike: {
       href: "/casino/pragmaticplay-fire-strike",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireStrike.webp",
       alt: "Fire Strike",
       name: "Fire Strike",
     },
     firestampede: {
       href: "/casino/pragmaticplay-fire-stampede",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireStamped.webp",
       alt: "Fire Stampede",
       name: "Fire Stampede",
     },
     fireportals: {
       href: "/casino/pragmaticplay-fire-portals",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FirePortals.webp",
       alt: "Fire Portals",
       name: "Fire Portals",
     },
     firehot5jackpotplay: {
       href: "/casino/pragmaticplay-fire-hot-5-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot5JackpotPlay.webp",
       alt: "Fire Hot 5 Jackpot Play",
       name: "Fire Hot 5 Jackpot Play",
     },
     firehot5: {
       href: "/casino/pragmaticplay-fire-hot-5",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot5.webp",
       alt: "Fire Hot 5",
       name: "Fire Hot 5",
     },
     firehot40jackpotplay: {
       href: "/casino/pragmaticplay-fire-hot-40-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot40JackpotPlay.webp",
       alt: "Fire Hot 40 Jackpot Play",
       name: "Fire Hot 40 Jackpot Play",
     },
     firehot40: {
       href: "/casino/pragmaticplay-fire-hot-40",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot40.webp",
       alt: "Fire Hot 40",
       name: "Fire Hot 40",
     },
     firehot20jackpotplay: {
       href: "/casino/pragmaticplay-fire-hot-20-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot20JackpotPlay.webp",
       alt: "Fire Hot 20 Jackpot Play",
       name: "Fire Hot 20 Jackpot Play",
     },
     firehot20: {
       href: "/casino/pragmaticplay-fire-hot-20",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot20.webp",
       alt: "Fire Hot 20",
       name: "Fire Hot 20",
     },
     firehot100jackpotplay: {
       href: "/casino/pragmaticplay-fire-hot-100-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot100JackpotPla.webp",
       alt: "Fire Hot 100 Jackpot Play",
       name: "Fire Hot 100 Jackpot Play",
     },
     firehot100: {
       href: "/casino/pragmaticplay-fire-hot-100",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireHot100.webp",
       alt: "Fire Hot 100",
       name: "Fire Hot 100",
     },
     firearcher: {
       href: "/casino/pragmaticplay-fire-archer",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FireArcher.webp",
       alt: "Fire Archer",
       name: "Fire Archer",
     },
     fire88: {
       href: "/casino/pragmaticplay-fire-88",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Fire88.webp",
       alt: "Fire 88",
       name: "Fire 88",
     },
     fingerlicknfreespins: {
       href: "/casino/pragmaticplay-finger-lickn-free-spins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FingerLicknFreeSpins.webp",
       alt: "Finger Lick'n Free Spins",
       name: "Finger Lick'n Free Spins",
     },
     fiestafortune: {
       href: "/casino/pragmaticplay-fiesta-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FiestaFortune.webp",
       alt: "Fiesta Fortune",
       name: "Fiesta Fortune",
     },
     fiestadesanfermin: {
       href: "/casino/pragmaticplay-fiesta-de-san-fermin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FiestadeSanFermin.webp",
       alt: "Fiesta de San Fermin",
       name: "Fiesta de San Fermin",
     },
     fatpanda: {
       href: "/casino/pragmaticplay-fat-panda",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FatPanda.webp",
       alt: "Fat Panda",
       name: "Fat Panda",
     },
     fangtasticfreespins: {
       href: "/casino/pragmaticplay-fangtastic-freespins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FangtasticFreespins.webp",
       alt: "Fangtastic Freespins",
       name: "Fangtastic Freespins",
     },
     fairytalefortune: {
       href: "/casino/pragmaticplay-fairytale-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/FairytaleFortune.webp",
       alt: "Fairytale Fortune",
       name: "Fairytale Fortune",
     },
     eyeofthestorm: {
       href: "/casino/pragmaticplay-eye-of-the-storm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EyeoftheStorm.webp",
       alt: "Eye of the Storm",
       name: "Eye of the Storm",
     },
     eyeofspartacus: {
       href: "/casino/pragmaticplay-eye-of-spartacus",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EyeofSpartacus.webp",
       alt: "Eye of Spartacus",
       name: "Eye of Spartacus",
     },
     eyeofcleopatra: {
       href: "/casino/pragmaticplay-eye-of-cleopatra",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EyeofCleopatra.webp",
       alt: "Eye of Cleopatra",
       name: "Eye of Cleopatra",
     },
     extrajuicymegaways: {
       href: "/casino/pragmaticplay-extra-juicy-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ExtraJuicyMegaways.webp",
       alt: "Extra Juicy Megaways",
       name: "Extra Juicy Megaways",
     },
     extrajuicy: {
       href: "/casino/pragmaticplay-extra-juicy",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ExtraJuicy.webp",
       alt: "Extra Juicy",
       name: "Extra Juicy",
     },
     excaliburunleashed: {
       href: "/casino/pragmaticplay-excalibur-unleashed",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ExcaliburUnleashed.webp",
       alt: "Excalibur Unleashed",
       name: "Excalibur Unleashed",
     },
     eternalempressfreezetime: {
       href: "/casino/pragmaticplay-eternal-empress-freeze-time",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EternalEmpressFreezeTime.webp",
       alt: "Eternal Empress - Freeze Time",
       name: "Eternal Empress - Freeze Time",
     },
     escapethepyramidfireice: {
       href: "/casino/pragmaticplay-escape-the-pyramid-fire-and-ice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EscapethePyramidFire&Ice.webp",
       alt: "Escape the Pyramid Fire & Ice",
       name: "Escape the Pyramid Fire & Ice",
     },
     emptythebank: {
       href: "/casino/pragmaticplay-empty-the-bank",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EmptytheBank.webp",
       alt: "Empty the Bank",
       name: "Empty the Bank",
     },
     emperorcaishen: {
       href: "/casino/pragmaticplay-emperor-caishen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EmperorCaishen.webp",
       alt: "Emperor Caishen",
       name: "Emperor Caishen",
     },
     emeraldkingrainbowroad: {
       href: "/casino/pragmaticplay-emerald-king-rainbow-road",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EmeraldKingRainbowRoad.webp",
       alt: "Emerald King Rainbow Road",
       name: "Emerald King Rainbow Road",
     },
     emeraldking: {
       href: "/casino/pragmaticplay-emerald-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EmeraldKing.webp",
       alt: "Emerald King",
       name: "Emerald King",
     },
     elementalgemsmegaways: {
       href: "/casino/pragmaticplay-elemental-gems-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ElementalGemsMegaways.webp",
       alt: "Elemental Gems Megaways",
       name: "Elemental Gems Megaways",
     },
     eldoradothecityofgold: {
       href: "/casino/pragmaticplay-el-dorado-the-city-of-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ElDoradoTheCityofGold.webp",
       alt: "El Dorado The City of Gold",
       name: "El Dorado The City of Gold",
     },
     egyptianfortunes: {
       href: "/casino/pragmaticplay-egyptian-fortunes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EgyptianFortunes.webp",
       alt: "Egyptian Fortunes",
       name: "Egyptian Fortunes",
     },
     egyptbonanza: {
       href: "/casino/pragmaticplay-egypt-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EgyptBonanza.webp",
       alt: "Egypt Bonanza",
       name: "Egypt Bonanza",
     },
     eggrushjackpotplay: {
       href: "/casino/pragmaticplay-egg-rush-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/EggRushJackpotPlay.webp",
       alt: "Egg Rush Jackpot Play",
       name: "Egg Rush Jackpot Play",
     },
     dynamitediggindoug: {
       href: "/casino/pragmaticplay-dynamite-diggin-doug",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DynamiteDigginDoug.webp",
       alt: "Dynamite Diggin Doug",
       name: "Dynamite Diggin Doug",
     },
     dwarvengolddeluxe: {
       href: "/casino/pragmaticplay-dwarven-gold-deluxe",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DwarvenGoldDeluxe.webp",
       alt: "Dwarven Gold Deluxe",
       name: "Dwarven Gold Deluxe",
     },
     dwarfdragon: {
       href: "/casino/pragmaticplay-dwarf-and-dragon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Dwarf&Dragon.webp",
       alt: "Dwarf & Dragon",
       name: "Dwarf & Dragon",
     },
     drillthatgold: {
       href: "/casino/pragmaticplay-drill-that-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DrillthatGold.webp",
       alt: "Drill that Gold",
       name: "Drill that Gold",
     },
     dragonkingdomeyesoffire: {
       href: "/casino/pragmaticplay-dragon-kingdom-eyes-of-fire",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonKingdomEyesofFire.webp",
       alt: "Dragon Kingdom Eyes of Fire",
       name: "Dragon Kingdom Eyes of Fire",
     },
     dragonkingdom: {
       href: "/casino/pragmaticplay-dragon-kingdom",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonKingdom.webp",
       alt: "Dragon Kingdom",
       name: "Dragon Kingdom",
     },
     dragonkinghotpots: {
       href: "/casino/pragmaticplay-dragon-king-hot-pots",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonKingHotPots.webp",
       alt: "Dragon King Hot Pots",
       name: "Dragon King Hot Pots",
     },
     dragonhotholdandspin: {
       href: "/casino/pragmaticplay-dragon-hot-hold-and-spin",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonHotHoldandSpin.webp",
       alt: "Dragon Hot Hold and Spin",
       name: "Dragon Hot Hold and Spin",
     },
     dragonhero: {
       href: "/casino/pragmaticplay-dragon-hero",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonHero.webp",
       alt: "Dragon Hero",
       name: "Dragon Hero",
     },
     dragongold88: {
       href: "/casino/pragmaticplay-dragon-gold-88",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragonGold88.webp",
       alt: "Dragon Gold 88",
       name: "Dragon Gold 88",
     },
     dragojewelsoffortune: {
       href: "/casino/pragmaticplay-drago-jewels-of-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DragoJewelsofFortune.webp",
       alt: "Drago  Jewels of Fortune",
       name: "Drago  Jewels of Fortune",
     },
     downtherails: {
       href: "/casino/pragmaticplay-down-the-rails",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DowntheRails.webp",
       alt: "Down the Rails",
       name: "Down the Rails",
     },
     discolady: {
       href: "/casino/pragmaticplay-disco-lady",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DiscoLady.webp",
       alt: "Disco Lady",
       name: "Disco Lady",
     },
     dinodrop: {
       href: "/casino/pragmaticplay-dino-drop",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DinoDrop.webp",
       alt: "Dino Drop",
       name: "Dino Drop",
     },
     dingdongchristmasbells: {
       href: "/casino/pragmaticplay-ding-dong-christmas-bells",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DingDongChristmasBells.webp",
       alt: "Ding Dong Christmas Bells",
       name: "Ding Dong Christmas Bells",
     },
     diamondstrike: {
       href: "/casino/pragmaticplay-diamond-strike",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DiamondStrike.webp",
       alt: "Diamond Strike",
       name: "Diamond Strike",
     },
     diamondcascade: {
       href: "/casino/pragmaticplay-diamond-cascade",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DiamondCascade.webp",
       alt: "Diamond Cascade",
       name: "Diamond Cascade",
     },
     devilicious: {
       href: "/casino/pragmaticplay-devilicious",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Devilicious.webp",
       alt: "Devilicious",
       name: "Devilicious",
     },
     deviljoker: {
       href: "/casino/pragmaticplay-devil-joker",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DevilJoker.webp",
       alt: "Devil Joker",
       name: "Devil Joker",
     },
     demonpots: {
       href: "/casino/pragmaticplay-demon-pots",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DemonPots.webp",
       alt: "Demon Pots",
       name: "Demon Pots",
     },
     dayofdead: {
       href: "/casino/pragmaticplay-day-of-dead",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DayofDead.webp",
       alt: "Day of Dead",
       name: "Day of Dead",
     },
     danielnegreanusfishbuffet: {
       href: "/casino/pragmaticplay-daniel-negreanus-fish-buffet",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DanielNegreanusFishBuffet.webp",
       alt: "Daniel Negreanu's Fish Buffet",
       name: "Daniel Negreanu's Fish Buffet",
     },
     danceparty: {
       href: "/casino/pragmaticplay-dance-party",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DanceParty.webp",
       alt: "Dance Party",
       name: "Dance Party",
     },
     davincistreasure: {
       href: "/casino/pragmaticplay-da-vincis-treasure",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/DaVincisTreasure.webp",
       alt: "Da Vincis Treasure",
       name: "Da Vincis Treasure",
     },
     cyclopssmash: {
       href: "/casino/pragmaticplay-cyclops-smash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CyclopsSmash.webp",
       alt: "Cyclops Smash",
       name: "Cyclops Smash",
     },
     cyberheist: {
       href: "/casino/pragmaticplay-cyber-heist",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CyberHeist.webp",
       alt: "Cyber Heist",
       name: "Cyber Heist",
     },
     curseofthewerewolfmegaways: {
       href: "/casino/pragmaticplay-curse-of-the-werewolf-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CurseoftheWerewolfMegaways.webp",
       alt: "Curse of the Werewolf Megaways",
       name: "Curse of the Werewolf Megaways",
     },
     crystalcavernsmegaways: {
       href: "/casino/pragmaticplay-crystal-caverns-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CrystalCavernsMegaways.webp",
       alt: "Crystal Caverns Megaways",
       name: "Crystal Caverns Megaways",
     },
     crownoffirejackpotplay: {
       href: "/casino/pragmaticplay-crown-of-fire-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/crownoffirejackpotplays.webp",
       alt: "Crown of Fire Jackpot Play",
       name: "Crown of Fire Jackpot Play",
     },
     crownoffire: {
       href: "/casino/pragmaticplay-crown-of-fire",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CrownofFire.webp",
       alt: "Crown of Fire",
       name: "Crown of Fire",
     },
     crazy7s: {
       href: "/casino/pragmaticplay-crazy-7s",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Crazy7s.webp",
       alt: "Crazy 7s",
       name: "Crazy 7s",
     },
     crankitup: {
       href: "/casino/pragmaticplay-crank-it-up",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CrankItUp.webp",
       alt: "Crank It Up",
       name: "Crank It Up",
     },
     cowboysgold: {
       href: "/casino/pragmaticplay-cowboys-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CowboysGold.webp",
       alt: "Cowboys Gold",
       name: "Cowboys Gold",
     },
     cowboycoins: {
       href: "/casino/pragmaticplay-cowboy-coins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CowboyCoins.webp",
       alt: "Cowboy Coins",
       name: "Cowboy Coins",
     },
     countryfarming: {
       href: "/casino/pragmaticplay-country-farming",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CountryFarming.webp",
       alt: "Country Farming",
       name: "Country Farming",
     },
     cosmolotbonanza: {
       href: "/casino/pragmaticplay-cosmolot-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CosmolotBonanza.webp",
       alt: "Cosmolot Bonanza",
       name: "Cosmolot Bonanza",
     },
     cosmiccash: {
       href: "/casino/pragmaticplay-cosmic-cash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CosmicCash.webp",
       alt: "Cosmic Cash",
       name: "Cosmic Cash",
     },
     coralriches: {
       href: "/casino/pragmaticplay-coral-riches",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CoralRiches.webp",
       alt: "Coral Riches",
       name: "Coral Riches",
     },
     congocashxl: {
       href: "/casino/pragmaticplay-congo-cash-xl",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CongoCashXL.webp",
       alt: "Congo Cash XL",
       name: "Congo Cash XL",
     },
     congocash: {
       href: "/casino/pragmaticplay-congo-cash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CongoCash.webp",
       alt: "Congo Cash",
       name: "Congo Cash",
     },
     colossalcashzone: {
       href: "/casino/pragmaticplay-colossal-cash-zone",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ColossalCashZone.webp",
       alt: "Colossal Cash Zone",
       name: "Colossal Cash Zone",
     },
     coffeewild: {
       href: "/casino/pragmaticplay-coffee-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CoffeeWild.webp",
       alt: "Coffee Wild",
       name: "Coffee Wild",
     },
     clubtropicanahappyhour: {
       href: "/casino/pragmaticplay-club-tropicana-happy-hour",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ClubTropicanaHappyHour.webp",
       alt: "Club Tropicana Happy Hour",
       name: "Club Tropicana Happy Hour",
     },
     clubtropicana: {
       href: "/casino/pragmaticplay-club-tropicana",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ClubTropicana.webp",
       alt: "Club Tropicana",
       name: "Club Tropicana",
     },
     clovergold: {
       href: "/casino/pragmaticplay-clover-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CloverGold.webp",
       alt: "Clover Gold",
       name: "Clover Gold",
     },
     cleocatra: {
       href: "/casino/pragmaticplay-cleocatra",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Cleocatra.webp",
       alt: "Cleocatra",
       name: "Cleocatra",
     },
     christmascarolmegaways: {
       href: "/casino/pragmaticplay-christmas-carol-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChristmasCarolMegaways.webp",
       alt: "Christmas Carol Megaways",
       name: "Christmas Carol Megaways",
     },
     christmasbigbassbonanza: {
       href: "/casino/pragmaticplay-christmas-big-bass-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChristmasBigBassBonanza.webp",
       alt: "Christmas Big Bass Bonanza",
       name: "Christmas Big Bass Bonanza",
     },
     chilliheatspicyspins: {
       href: "/casino/pragmaticplay-chilli-heat-spicy-spins",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChilliHeatSpicySpins.webp",
       alt: "Chilli Heat Spicy Spins",
       name: "Chilli Heat Spicy Spins",
     },
     chilliheatmegaways: {
       href: "/casino/pragmaticplay-chilli-heat-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChilliHeatMegaways.webp",
       alt: "Chilli Heat Megaways",
       name: "Chilli Heat Megaways",
     },
     chilliheat: {
       href: "/casino/pragmaticplay-chilli-heat",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChilliHeat.webp",
       alt: "Chilli Heat",
       name: "Chilli Heat",
     },
     chickendrop: {
       href: "/casino/pragmaticplay-chicken-drop",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChickenDrop.webp",
       alt: "Chicken Drop",
       name: "Chicken Drop",
     },
     chickenchase: {
       href: "/casino/pragmaticplay-chicken-chase",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChickenChase.webp",
       alt: "Chicken Chase",
       name: "Chicken Chase",
     },
     chestsofcaishen: {
       href: "/casino/pragmaticplay-chests-of-cai-shen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/ChestsofCaiShen.webp",
       alt: "Chests of Cai Shen",
       name: "Chests of Cai Shen",
     },
     cheekyemperor: {
       href: "/casino/pragmaticplay-cheeky-emperor",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CheekyEmperor.webp",
       alt: "Cheeky Emperor",
       name: "Cheeky Emperor",
     },
     castleoffire: {
       href: "/casino/pragmaticplay-castle-of-fire",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CastleofFire.webp",
       alt: "Castle of Fire",
       name: "Castle of Fire",
     },
     cashpatrol: {
       href: "/casino/pragmaticplay-cash-patrol",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CashPatrol.webp",
       alt: "Cash Patrol",
       name: "Cash Patrol",
     },
     cashchips: {
       href: "/casino/pragmaticplay-cash-chips",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CashChips.webp",
       alt: "Cash Chips",
       name: "Cash Chips",
     },
     cashbox: {
       href: "/casino/pragmaticplay-cash-box",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CashBox.webp",
       alt: "Cash Box",
       name: "Cash Box",
     },
     cashbonanza: {
       href: "/casino/pragmaticplay-cash-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CashBonanza.webp",
       alt: "Cash Bonanza",
       name: "Cash Bonanza",
     },
     cappadocia: {
       href: "/casino/pragmaticplay-cappadocia",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Cappadocia.webp",
       alt: "Cappadocia",
       name: "Cappadocia",
     },
     candyvillage: {
       href: "/casino/pragmaticplay-candy-village",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyVillage.webp",
       alt: "Candy Village",
       name: "Candy Village",
     },
     candystars: {
       href: "/casino/pragmaticplay-candy-stars",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyStars.webp",
       alt: "Candy Stars",
       name: "Candy Stars",
     },
     candyjarclusters: {
       href: "/casino/pragmaticplay-candy-jar-clusters",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyJarClusters.webp",
       alt: "Candy Jar Clusters",
       name: "Candy Jar Clusters",
     },
     candycorner: {
       href: "/casino/pragmaticplay-candy-corner",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyCorner.webp",
       alt: "Candy Corner",
       name: "Candy Corner",
     },
     candyblitzbombs: {
       href: "/casino/pragmaticplay-candy-blitz-bombs",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyBlitzBombs.webp",
       alt: "Candy Blitz Bombs",
       name: "Candy Blitz Bombs",
     },
     candyblitz: {
       href: "/casino/pragmaticplay-candy-blitz",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CandyBlitz.webp",
       alt: "Candy Blitz",
       name: "Candy Blitz",
     },
     caishensgold: {
       href: "/casino/pragmaticplay-caishens-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CaishensGold.webp",
       alt: "Caishens Gold",
       name: "Caishens Gold",
     },
     caishensgemsjackpotplay: {
       href: "/casino/pragmaticplay-caishens-gems-jackpot-play",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CaishensGemsJackpotPlay.webp",
       alt: "Caishen's Gems Jackpot Play",
       name: "Caishen's Gems Jackpot Play",
     },
     caishenscash: {
       href: "/casino/pragmaticplay-caishens-cash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/CaishensCash.webp",
       alt: "Caishens Cash",
       name: "Caishens Cash",
     },
     busybees: {
       href: "/casino/pragmaticplay-busy-bees",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BusyBees.webp",
       alt: "Busy Bees",
       name: "Busy Bees",
     },
     bullfiesta: {
       href: "/casino/pragmaticplay-bull-fiesta",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BullFiesta.webp",
       alt: "Bull Fiesta",
       name: "Bull Fiesta",
     },
     buffalokinguntamedmegaways: {
       href: "/casino/pragmaticplay-buffalo-king-untamed-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BuffaloKingUntamedMegaway.webp",
       alt: "Buffalo King Untamed Megaways",
       name: "Buffalo King Untamed Megaways",
     },
     buffalokingmegaways: {
       href: "/casino/pragmaticplay-buffalo-king-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BuffaloKingMegaways.webp",
       alt: "Buffalo King Megaways",
       name: "Buffalo King Megaways",
     },
     buffaloking: {
       href: "/casino/pragmaticplay-buffalo-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BuffaloKing.webp",
       alt: "Buffalo King",
       name: "Buffalo King",
     },
     bubblewild2: {
       href: "/casino/pragmaticplay-bubble-wild-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BubbleWild2.webp",
       alt: "Bubble Wild 2",
       name: "Bubble Wild 2",
     },
     bubblewild: {
       href: "/casino/pragmaticplay-bubble-wild",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BubbleWild.webp",
       alt: "Bubble Wild",
       name: "Bubble Wild",
     },
     bubblepop: {
       href: "/casino/pragmaticplay-bubble-pop",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BubblePop.webp",
       alt: "Bubble Pop",
       name: "Bubble Pop",
     },
     brickhousebonanza: {
       href: "/casino/pragmaticplay-brick-house-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BrickHouseBonanza.webp",
       alt: "Brick House Bonanza",
       name: "Brick House Bonanza",
     },
     bowofartemis: {
       href: "/casino/pragmaticplay-bow-of-artemis",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BowofArtemis.webp",
       alt: "Bow of Artemis",
       name: "Bow of Artemis",
     },
     bountygold: {
       href: "/casino/pragmaticplay-bounty-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BountyGold.webp",
       alt: "Bounty Gold",
       name: "Bounty Gold",
     },
     bookofvikings: {
       href: "/casino/pragmaticplay-book-of-vikings",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookofVikings.webp",
       alt: "Book of Vikings",
       name: "Book of Vikings",
     },
     bookofthefallen: {
       href: "/casino/pragmaticplay-book-of-the-fallen",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookoftheFallen.webp",
       alt: "Book of the Fallen",
       name: "Book of the Fallen",
     },
     bookofsports: {
       href: "/casino/pragmaticplay-book-of-sports",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/bookofsports.webp",
       alt: "Book of Sports",
       name: "Book of Sports",
     },
     bookofkingdoms: {
       href: "/casino/pragmaticplay-book-of-kingdoms",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookofKingdoms.webp",
       alt: "Book of Kingdoms",
       name: "Book of Kingdoms",
     },
     bookofgoldensands: {
       href: "/casino/pragmaticplay-book-of-golden-sands",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookofGoldenSands.webp",
       alt: "Book of Golden Sands",
       name: "Book of Golden Sands",
     },
     bookofeldorado: {
       href: "/casino/pragmaticplay-book-of-el-dorado",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookofElDorado.webp",
       alt: "Book of El Dorado",
       name: "Book of El Dorado",
     },
     bookofaztecking: {
       href: "/casino/pragmaticplay-book-of-aztec-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BookofAztecKing.webp",
       alt: "Book of Aztec King",
       name: "Book of Aztec King",
     },
     bonanzagold: {
       href: "/casino/pragmaticplay-bonanza-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BonanzaGold.webp",
       alt: "Bonanza Gold",
       name: "Bonanza Gold",
     },
     bombbonanza: {
       href: "/casino/pragmaticplay-bomb-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BombBonanza.webp",
       alt: "Bomb Bonanza",
       name: "Bomb Bonanza",
     },
     blitzsuperwheel: {
       href: "/casino/pragmaticplay-blitz-super-wheel",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BlitzSuperWheel.webp",
       alt: "Blitz Super Wheel",
       name: "Blitz Super Wheel",
     },
     blazingwildsmegaways: {
       href: "/casino/pragmaticplay-blazing-wilds-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BlazingWildsMegaways.webp",
       alt: "Blazing Wilds Megaways",
       name: "Blazing Wilds Megaways",
     },
     bladefangs: {
       href: "/casino/pragmaticplay-blade-and-fangs",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BladeFangs.webp",
       alt: "Blade & Fangs",
       name: "Blade & Fangs",
     },
     blackbull: {
       href: "/casino/pragmaticplay-black-bull",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BlackBull.webp",
       alt: "Black Bull",
       name: "Black Bull",
     },
     bisonspirit: {
       href: "/casino/pragmaticplay-bison-spirit",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BisonSpirit.webp",
       alt: "Bison Spirit",
       name: "Bison Spirit",
     },
     bisonblaze: {
       href: "/casino/pragmaticplay-bison-blaze",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/bisonblaze.webp",
       alt: "Bison Blaze",
       name: "Bison Blaze",
     },
     biggerbasssplash: {
       href: "/casino/pragmaticplay-bigger-bass-splash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BiggerBassSplash.webp",
       alt: "Bigger Bass Splash",
       name: "Bigger Bass Splash",
     },
     biggerbassbonanza: {
       href: "/casino/pragmaticplay-bigger-bass-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BiggerBassBonanza.webp",
       alt: "Bigger Bass Bonanza",
       name: "Bigger Bass Bonanza",
     },
     biggerbassblizzardchristmascatch: {
       href: "/casino/pragmaticplay-bigger-bass-blizzard-christmas-catch",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BiggerBassBlizzardChristmasCatch.webp",
       alt: "Bigger Bass Blizzard  Christmas Catch",
       name: "Bigger Bass Blizzard  Christmas Catch",
     },
     bigjuan: {
       href: "/casino/pragmaticplay-big-juan",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigJuan.webp",
       alt: "Big Juan",
       name: "Big Juan",
     },
     bigburgerloaditupwithxtracheese: {
       href: "/casino/pragmaticplay-big-burger-load-it-up-with-xtra-cheese",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBurgerLoaditupwithXtraCheese.webp",
       alt: "Big Burger Load it up with Xtra Cheese",
       name: "Big Burger Load it up with Xtra Cheese",
     },
     bigbassxmasextreme: {
       href: "/casino/pragmaticplay-big-bass-xmas-extreme",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassXmasExtreme.webp",
       alt: "Big Bass Xmas Extreme",
       name: "Big Bass Xmas Extreme",
     },
     bigbassvegasdoubledowndeluxe: {
       href: "/casino/pragmaticplay-big-bass-vegas-double-down-deluxe",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassVegasDoubleDownDeluxe.webp",
       alt: "Big Bass Vegas Double Down Deluxe",
       name: "Big Bass Vegas Double Down Deluxe",
     },
 
     bigbassholdspinnermegaways: {
       href: "/casino/pragmaticplay-big-bass-hold-and-spinner-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassHold&SpinnerMegaways.webp",
       alt: "Big Bass Hold & Spinner Megaways",
       name: "Big Bass Hold & Spinner Megaways",
     },
     bigbasshalloween2: {
       href: "/casino/pragmaticplay-big-bass-halloween-2",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassHalloween2.webp",
       alt: "Big Bass Halloween 2",
       name: "Big Bass Halloween 2",
     },
 
     bigbassfloatsmyboat: {
       href: "/casino/pragmaticplay-big-bass-floats-my-boat",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassFloatsmyBoat.webp",
       alt: "Big Bass Floats my Boat",
       name: "Big Bass Floats my Boat",
     },
     bigbassdice: {
       href: "/casino/pragmaticplay-big-bass-dice",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassDice.webp",
       alt: "Big Bass Dice",
       name: "Big Bass Dice",
     },
     bigbassdayattheraces: {
       href: "/casino/pragmaticplay-big-bass-day-at-the-races",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassDayattheRaces.webp",
       alt: "Big Bass Day at the Races",
       name: "Big Bass Day at the Races",
     },
     bigbasschristmasbash: {
       href: "/casino/pragmaticplay-big-bass-christmas-bash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassChristmasBash.webp",
       alt: "Big Bass Christmas Bash",
       name: "Big Bass Christmas Bash",
     },
     bigbassboxingbonusround: {
       href: "/casino/pragmaticplay-big-bass-boxing-bonus-round",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBoxingBonusRound.webp",
       alt: "Big Bass Boxing Bonus Round",
       name: "Big Bass Boxing Bonus Round",
     },
     bigbassbonanzamegaways: {
       href: "/casino/pragmaticplay-big-bass-bonanza-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBonanzaMegaways.webp",
       alt: "Big Bass Bonanza Megaways",
       name: "Big Bass Bonanza Megaways",
     },
     bigbassbonanza3reeler: {
       href: "/casino/pragmaticplay-big-bass-bonanza-3-reeler",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBonanza3Reeler.webp",
       alt: "Big Bass Bonanza 3 Reeler",
       name: "Big Bass Bonanza 3 Reeler",
     },
     bigbassbonanza1000: {
       href: "/casino/pragmaticplay-big-bass-bonanza-1000",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBonanza1000.webp",
       alt: "Big Bass Bonanza 1000",
       name: "Big Bass Bonanza 1000",
     },
     bigbassbonanzareelaction: {
       href: "/casino/pragmaticplay-big-bass-bonanza-reel-action",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassBonanzaReelAction.webp",
       alt: "Big Bass Bonanza - Reel Action",
       name: "Big Bass Bonanza - Reel Action",
     },
 
     bigbassamazonxtreme: {
       href: "/casino/pragmaticplay-big-bass-amazon-xtreme",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassAmazonXtreme.webp",
       alt: "Big Bass Amazon Xtreme",
       name: "Big Bass Amazon Xtreme",
     },
     bigbasskeepingitreel: {
       href: "/casino/pragmaticplay-big-bass-keeping-it-reel",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassKeepingitReel.webp",
       alt: "Big Bass Keeping it Reel",
       name: "Big Bass Keeping it Reel",
     },
     bigbassholdspinner: {
       href: "/casino/pragmaticplay-big-bass-hold-and-spinner",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BigBassHold&Spinner.webp",
       alt: "Big Bass Hold & Spinner",
       name: "Big Bass Hold & Spinner",
     },
     beowulf: {
       href: "/casino/pragmaticplay-beowulf",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Beowulf.webp",
       alt: "Beowulf",
       name: "Beowulf",
     },
     barnyardmegahaysmegaways: {
       href: "/casino/pragmaticplay-barnyard-megahays-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BarnyardMegahaysMegaways.webp",
       alt: "Barnyard Megahays Megaways",
       name: "Barnyard Megahays Megaways",
     },
     barnfestival: {
       href: "/casino/pragmaticplay-barn-festival",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BarnFestival.webp",
       alt: "Barn Festival",
       name: "Barn Festival",
     },
     barbar: {
       href: "/casino/pragmaticplay-barbar",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Barbar.webp",
       alt: "Barbar",
       name: "Barbar",
     },
     banditmegaways: {
       href: "/casino/pragmaticplay-bandit-megawaystm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BanditMegaways.webp",
       alt: "Bandit Megaways",
       name: "Bandit Megaways",
     },
     balidragon: {
       href: "/casino/pragmaticplay-bali-dragon",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BaliDragon.webp",
       alt: "Bali Dragon",
       name: "Bali Dragon",
     },
     badgeblitz: {
       href: "/casino/pragmaticplay-badge-blitz",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/BadgeBlitz.webp",
       alt: "Badge Blitz",
       name: "Badge Blitz",
     },
     aztectreasurehunt: {
       href: "/casino/pragmaticplay-aztec-treasure-hunt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecTreasureHunt.webp",
       alt: "Aztec Treasure Hunt",
       name: "Aztec Treasure Hunt",
     },
     aztectreasure: {
       href: "/casino/pragmaticplay-aztec-treasure",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecTreasure.webp",
       alt: "Aztec Treasure",
       name: "Aztec Treasure",
     },
     aztecsmash: {
       href: "/casino/pragmaticplay-aztec-smash",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecSmash.webp",
       alt: "Aztec Smash",
       name: "Aztec Smash",
     },
     aztecpowernudge: {
       href: "/casino/pragmaticplay-aztec-powernudge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecPowernudge.webp",
       alt: "Aztec Powernudge",
       name: "Aztec Powernudge",
     },
     azteckingmegaways: {
       href: "/casino/pragmaticplay-aztec-king-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecKingMegaways.webp",
       alt: "Aztec King Megaways",
       name: "Aztec King Megaways",
     },
     aztecking: {
       href: "/casino/pragmaticplay-aztec-king",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecKing.webp",
       alt: "Aztec King",
       name: "Aztec King",
     },
     aztecgemsmegaways: {
       href: "/casino/pragmaticplay-aztec-gems-megawaystm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecGemsMegaways.webp",
       alt: "Aztec Gems Megaways",
       name: "Aztec Gems Megaways",
     },
     aztecgemsdeluxe: {
       href: "/casino/pragmaticplay-aztec-gems-deluxe",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecGemsDeluxe.webp",
       alt: "Aztec Gems Deluxe",
       name: "Aztec Gems Deluxe",
     },
     aztecgems: {
       href: "/casino/pragmaticplay-aztec-gems",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecGems.webp",
       alt: "Aztec Gems",
       name: "Aztec Gems",
     },
     aztecbonanza: {
       href: "/casino/pragmaticplay-aztec-bonanza",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecBonanza.webp",
       alt: "Aztec Bonanza",
       name: "Aztec Bonanza",
     },
     aztecblaze: {
       href: "/casino/pragmaticplay-aztec-blaze",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AztecBlaze.webp",
       alt: "Aztec Blaze",
       name: "Aztec Blaze",
     },
     atlanticmoneymouse: {
       href: "/casino/pragmaticplay-atlantic-money-mouse",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AtlanticMoneyMouse.webp",
       alt: "Atlantic Money Mouse",
       name: "Atlantic Money Mouse",
     },
     asgard: {
       href: "/casino/pragmaticplay-asgard",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Asgard.webp",
       alt: "Asgard",
       name: "Asgard",
     },
     argonauts: {
       href: "/casino/pragmaticplay-argonauts",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/Argonauts.webp",
       alt: "Argonauts",
       name: "Argonauts",
     },
     angelvssinner: {
       href: "/casino/pragmaticplay-angel-vs-sinner",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AngelvsSinner.webp",
       alt: "Angel vs Sinner",
       name: "Angel vs Sinner",
     },
     ancientislandmegaways: {
       href: "/casino/pragmaticplay-ancient-island-megawaystm",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AncientIslandMegaways.webp",
       alt: "Ancient Island Megaways",
       name: "Ancient Island Megaways",
     },
     ancientegyptclassic: {
       href: "/casino/pragmaticplay-ancient-egypt-classic",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AncientEgyptClassic.webp",
       alt: "Ancient Egypt Classic",
       name: "Ancient Egypt Classic",
     },
     ancientegypt: {
       href: "/casino/pragmaticplay-ancient-egypt",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AncientEgypt.webp",
       alt: "Ancient Egypt",
       name: "Ancient Egypt",
     },
     alieninvaders: {
       href: "/casino/pragmaticplay-alien-invaders",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AlienInvaders.webp",
       alt: "Alien Invaders",
       name: "Alien Invaders",
     },
     aladdinandthesorcerer: {
       href: "/casino/pragmaticplay-alien-invaders",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AladdinandtheSorcerer.webp",
       alt: "Aladdin and the Sorcerer",
       name: "Aladdin and the Sorcerer",
     },
     africanelephant: {
       href: "/casino/pragmaticplay-african-elephant",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/AfricanElephant.webp",
       alt: "African Elephant",
       name: "African Elephant",
     },
     gold888: {
       href: "/casino/pragmaticplay-888-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/888Gold.webp",
       alt: "888 Gold",
       name: "888 Gold",
     },
     dragons888: {
       href: "/casino/pragmaticplay-888-dragons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/888Dragons.webp",
       alt: "888 Dragons",
       name: "888 Dragons",
     },
     goldendragonchallenge8: {
       href: "/casino/pragmaticplay-8-golden-dragon-challenge",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/8GoldenDragonChallenge.webp",
       alt: "8 Golden Dragon Challenge",
       name: "8 Golden Dragon Challenge",
     },
     dragons8: {
       href: "/casino/pragmaticplay-8-dragons",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/8Dragons.webp",
       alt: "8 Dragons",
       name: "8 Dragons",
     },
     piggies7: {
       href: "/casino/pragmaticplay-7-piggies",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/7Piggies.webp",
       alt: "7 Piggies",
       name: "7 Piggies",
     },
     monkeys7: {
       href: "/casino/pragmaticplay-7-monkeys",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/7Monkeys.webp",
       alt: "7 Monkeys",
       name: "7 Monkeys",
     },
     cloversoffortune7: {
       href: "/casino/pragmaticplay-7-clovers-of-fortune",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/7CloversofFortune.webp",
       alt: "7 Clovers of Fortune",
       name: "7 Clovers of Fortune",
     },
     jokers6: {
       href: "/casino/pragmaticplay-6-jokers",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/6Jokers.webp",
       alt: "6 Jokers",
       name: "6 Jokers",
     },
     rabbitsmegaways5: {
       href: "/casino/pragmaticplay-5-rabbits-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/5RabbitsMegaways.webp",
       alt: "5 Rabbits Megaways",
       name: "5 Rabbits Megaways",
     },
     lionsmegaways5: {
       href: "/casino/pragmaticplay-5-lions-megaways",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/5LionsMegaways.webp",
       alt: "5 Lions Megaways",
       name: "5 Lions Megaways",
     },
     lionsdance5: {
       href: "/casino/pragmaticplay-5-lions-dance",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/5LionsDance.webp",
       alt: "5 Lions Dance",
       name: "5 Lions Dance",
     },
     lions5: {
       href: "/casino/pragmaticplay-5-lions",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/5Lions.webp",
       alt: "5 Lions",
       name: "5 Lions",
     },
     lionsgold5: {
       href: "/casino/pragmaticplay-5-lions-gold",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/5LionsGold.webp",
       alt: "5 Lions Gold",
       name: "5 Lions Gold",
     },
     geniewishes3: {
       href: "/casino/pragmaticplay-3-genie-wishes",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/3GenieWishes.webp",
       alt: "3 Genie Wishes",
       name: "3 Genie Wishes",
     },
     dancingmonkeys3: {
       href: "/casino/pragmaticplay-3-dancing-monkeys",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/3DancingMonkeys.webp",
       alt: "3 Dancing Monkeys",
       name: "3 Dancing Monkeys",
     },
     buzzingwilds3: {
       href: "/casino/pragmaticplay-3-buzzing-wilds",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/3BuzzingWilds.webp",
       alt: "3 Buzzing Wilds",
       name: "3 Buzzing Wilds",
     },
     nights1001: {
       href: "/casino/pragmaticplay-1001-nights",
       code: "",
       casino: "Slots",
       provider: "Pragmatic Play",
       homeUrl: pageUrlGenerator("/home"),
       imgUrl: "./images/pragmaticplay/1001Nights.webp",
       alt: "1001 Nights",
       name: "1001 Nights",
     },
 },
  // jiliGames: {
  //   Coin3Treasures: {
  //     redirectUrl: "/casino/qtechjili-3-coin-treasures",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-coin-treasures.webp",
  //     alt: "3 coin treasures",
  //     name: "3 coin treasures",
  //     providerName: "Jili",
  //   },
  //   Lucky3Piggy: {
  //     redirectUrl: "/casino/qtechjili-3-lucky-piggy",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-lucky-piggy.webp",
  //     alt: "3 lucky piggy",
  //     name: "3 lucky piggy",
  //     providerName: "Jili",
  //   },
  //   Pot3Dragons: {
  //     redirectUrl: "/casino/qtechjili-3-pot-dragons",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/3-pot-dragons.webp",
  //     alt: "3 pot dragons",
  //     name: "3 pot dragons",
  //     providerName: "Jili",
  //   },
  //   AgentAce: {
  //     redirectUrl: "/casino/qtechjili-agent-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/agent-ace.webp",
  //     alt: "agent ace",
  //     name: "agent ace",
  //     providerName: "Jili",
  //   },
  //   AliBaba: {
  //     redirectUrl: "/casino/qtechjili-ali-baba",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/ali-baba.webp",
  //     alt: "ali baba",
  //     name: "ali baba",
  //     providerName: "Jili",
  //   },
  //   ArenaFighter: {
  //     redirectUrl: "/casino/qtechjili-arena-fighter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/arena-fighter.webp",
  //     alt: "arena fighter",
  //     name: "arena fighter",
  //     providerName: "Jili",
  //   },
  //   AztecPriestess: {
  //     redirectUrl: "/casino/qtechjili-aztec-priestess",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/aztec-priestess.webp",
  //     alt: "aztec priestess",
  //     name: "aztec priestess",
  //     providerName: "Jili",
  //   },
  //   BanglaBeauty: {
  //     redirectUrl: "/casino/qtechjili-bangla-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bangla-beauty.webp",
  //     alt: "bangla beauty",
  //     name: "bangla beauty",
  //     providerName: "Jili",
  //   },
  //   BaoBoonChin: {
  //     redirectUrl: "/casino/qtechjili-bao-boon-chin",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bao-boon-chin.webp",
  //     alt: "bao boon chin",
  //     name: "bao boon chin",
  //     providerName: "Jili",
  //   },
  //   BoneFortune: {
  //     redirectUrl: "/casino/qtechjili-bone-fortune",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bone-fortune.webp",
  //     alt: "bone-fortune",
  //     name: "bone-fortune",
  //     providerName: "Jili",
  //   },
  //   BonusHunter: {
  //     redirectUrl: "/casino/qtechjili-bonus-hunter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bonus-hunter.webp",
  //     alt: "bonus-hunter",
  //     name: "bonus-hunter",
  //     providerName: "Jili",
  //   },
  //   BookOfGold: {
  //     redirectUrl: "/casino/qtechjili-book-of-gold",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/book-of-gold.webp",
  //     alt: "book of gold",
  //     name: "book of gold",
  //     providerName: "Jili",
  //   },
  //   BoxingKing: {
  //     redirectUrl: "/casino/qtechjili-boxing-king",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/boxing-king.webp",
  //     alt: "boxing king",
  //     name: "boxing king",
  //     providerName: "Jili",
  //   },
  //   BubbleBeauty: {
  //     redirectUrl: "/casino/qtechjili-bubble-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/bubble-beauty.webp",
  //     alt: "bubble beauty",
  //     name: "bubble beauty",
  //     providerName: "Jili",
  //   },
  //   CargeBuffalo: {
  //     redirectUrl: "/casino/qtechjili-charge-buffalo",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/charge-buffalo.webp",
  //     alt: "charge buffalo",
  //     name: "charge buffalo",
  //     providerName: "Jili",
  //   },
  //   ChargeBuffaloAscent: {
  //     redirectUrl: "/casino/qtechjili-charge-buffalo-ascent",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/charge-buffalo-ascent.webp",
  //     alt: "charge buffalo ascent",
  //     name: "charge buffalo ascent",
  //     providerName: "Jili",
  //   },
  //   Chinshihuang: {
  //     redirectUrl: "/casino/qtechjili-chin-shi-huang",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/chin-shi-huang.webp",
  //     alt: "",
  //     name: "Chin Shi Huang",
  //     providerName: "Jili",
  //   },
  //   CrazyFafafa: {
  //     redirectUrl: "/casino/qtechjili-crazy-fafafa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy-fafafa.webp",
  //     alt: "crazy fafafa",
  //     name: "crazy fafafa",
  //     providerName: "Jili",
  //   },
  //   CrazyHunter: {
  //     redirectUrl: "/casino/qtechjili-crazy-hunter",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy-hunter.webp",
  //     alt: "crazy hunter",
  //     name: "crazy hunter",
  //     providerName: "Jili",
  //   },
  //   Crazy777: {
  //     redirectUrl: "/casino/qtechjili-crazy777",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/crazy777.webp",
  //     alt: "",
  //     name: "Crazy777",
  //     providerName: "Jili",
  //   },
  //   CricketKing18: {
  //     redirectUrl: "/casino/qtechjili-cricket-king-18",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/cricket-king-18.webp",
  //     alt: "cricket king 18",
  //     name: "cricket king 18",
  //     providerName: "Jili",
  //   },
  //   CricketSah75: {
  //     redirectUrl: "/casino/qtechjili-cricket-sah-75",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/cricket-sah-75.webp",
  //     alt: "cricket sah 75",
  //     name: "cricket sah 75",
  //     providerName: "Jili",
  //   },
  //   Dabanggg: {
  //     redirectUrl: "/casino/qtechjili-dabanggg",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/dabanggg.webp",
  //     alt: "dabanggg",
  //     name: "dabanggg",
  //     providerName: "Jili",
  //   },
  //   DevilFire2: {
  //     redirectUrl: "/casino/qtechjili-devil-fire-2",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/devil-fire-2.webp",
  //     alt: "devil fire 2",
  //     name: "devil fire 2",
  //     providerName: "Jili",
  //   },
  //   DiamondParty: {
  //     redirectUrl: "/casino/qtechjili-diamond-party",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/diamond-party.webp",
  //     alt: "diamond party",
  //     name: "diamond party",
  //     providerName: "Jili",
  //   },
  //   DragonTreasure: {
  //     redirectUrl: "/casino/qtechjili-dragon-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/dragon-treasure.webp",
  //     alt: "dragon treasure",
  //     name: "dragon treasure",
  //     providerName: "Jili",
  //   },
  //   EgyptsGlow: {
  //     redirectUrl: "/casino/qtechjili-egypts-glow",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/egypts-glow.webp",
  //     alt: "egypt's glow",
  //     name: "egypt's glow",
  //     providerName: "Jili",
  //   },
  //   FaFaFa: {
  //     redirectUrl: "/casino/qtechjili-fa-fa-fa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fa-fa-fa.webp",
  //     alt: "fa fa fa",
  //     name: "fa fa fa",
  //     providerName: "Jili",
  //   },
  //   Fengshen: {
  //     redirectUrl: "/casino/qtechjili-fengshen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fengshen.webp",
  //     alt: "fengshen",
  //     name: "fengshen",
  //     providerName: "Jili",
  //   },
  //   FortuneGems: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems.webp",
  //     alt: "fortune gems",
  //     name: "fortune gems",
  //     providerName: "Jili",
  //   },
  //   FortuneGems2: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems-2",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems-2.webp",
  //     alt: "fortune gems 2",
  //     name: "fortune gems 2",
  //     providerName: "Jili",
  //   },
  //   FortuneGems3: {
  //     redirectUrl: "/casino/qtechjili-fortune-gems-3",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-gems-3.webp",
  //     alt: "fortune gems 3",
  //     name: "fortune gems 3",
  //     providerName: "Jili",
  //   },
  //   FortuneMonkey: {
  //     redirectUrl: "/casino/qtechjili-fortune-monkey",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-monkey.webp",
  //     alt: "fortune monkey",
  //     name: "fortune monkey",
  //     providerName: "Jili",
  //   },
  //   FortuneTree: {
  //     redirectUrl: "/casino/qtechjili-fortune-tree",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/fortune-tree.webp",
  //     alt: "",
  //     name: "Fortune Tree",
  //     providerName: "Jili",
  //   },
  //   GemParty: {
  //     redirectUrl: "/casino/qtechjili-gem-party",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/gem-party.webp",
  //     alt: "",
  //     name: "Gem Party",
  //     providerName: "Jili",
  //   },
  //   GodOfMartial: {
  //     redirectUrl: "/casino/qtechjili-god-of-martial",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/god-of-martial.webp",
  //     alt: "",
  //     name: "God Of Martial",
  //     providerName: "Jili",
  //   },
  //   GoldRush: {
  //     redirectUrl: "/casino/qtechjili-gold-rush",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/gold-rush.webp",
  //     alt: "gold rush",
  //     name: "gold rush",
  //     providerName: "Jili",
  //   },
  //   GoldenBank: {
  //     redirectUrl: "/casino/qtechjili-golden-bank",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-bank.webp",
  //     alt: "golden bank",
  //     name: "golden bank",
  //     providerName: "Jili",
  //   },
  //   GoldenEmpire: {
  //     redirectUrl: "/casino/qtechjili-golden-empire",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-empire.webp",
  //     alt: "golden empire",
  //     name: "golden empire",
  //     providerName: "Jili",
  //   },
  //   GoldenJoker: {
  //     redirectUrl: "/casino/qtechjili-golden-joker",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-joker.webp",
  //     alt: "golden joker",
  //     name: "golden joker",
  //     providerName: "Jili",
  //   },
  //   GoldenQueen: {
  //     redirectUrl: "/casino/qtechjili-golden-queen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-queen.webp",
  //     alt: "golden queen",
  //     name: "golden queen",
  //     providerName: "Jili",
  //   },
  //   GoldenTemple: {
  //     redirectUrl: "/casino/qtechjili-golden-temple",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/golden-temple.webp",
  //     alt: "golden temple",
  //     name: "golden temple",
  //     providerName: "Jili",
  //   },
  //   HappyTaxi: {
  //     redirectUrl: "/casino/qtechjili-happy-taxi",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/happy-taxi.webp",
  //     alt: "happy taxi",
  //     name: "happy taxi",
  //     providerName: "Jili",
  //   },
  //   HawaiiBeauty: {
  //     redirectUrl: "/casino/qtechjili-hawaii-beauty",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hawaii-beauty.webp",
  //     alt: "hawaii beauty",
  //     name: "hawaii beauty",
  //     providerName: "Jili",
  //   },
  //   HotChili: {
  //     redirectUrl: "/casino/qt-red-hot-chili-7s",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hot-chilli.webp",
  //     alt: "Hot Chilli",
  //     name: "Hot Chilli",
  //     providerName: "Jili",
  //   },
  //   HyperBrust: {
  //     redirectUrl: "/casino/qtechjili-hyper-burst",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/hyper-burst.webp",
  //     alt: "Hyper Burst",
  //     name: "Hyper Burst",
  //     providerName: "Jili",
  //   },
  //   JiliCaishen: {
  //     redirectUrl: "/casino/qtechjili-jili-caishen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/jili-caishen.webp",
  //     alt: "jili caishen",
  //     name: "jili caishen",
  //     providerName: "Jili",
  //   },
  //   JungleKing: {
  //     redirectUrl: "/casino/qtechjili-jungle-king",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/jungle-king.webp",
  //     alt: "jungle king",
  //     name: "jungle king",
  //     providerName: "Jili",
  //   },
  //   KingArthur: {
  //     redirectUrl: "/casino/qtechjili-king-arthur",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/king-arthur.webp",
  //     alt: "king arthur",
  //     name: "king arthur",
  //     providerName: "Jili",
  //   },
  //   LegacyOfEgypt: {
  //     redirectUrl: "/casino/qtechjili-legacy-of-egypt",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/legacy-of-egypt.webp",
  //     alt: "legacy of egypt",
  //     name: "legacy of egypt",
  //     providerName: "Jili",
  //   },
  //   LuckyBall: {
  //     redirectUrl: "/casino/qtechjili-lucky-ball",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/lucky-ball.webp",
  //     alt: "lucky ball",
  //     name: "lucky ball",
  //     providerName: "Jili",
  //   },
  //   LuckyComing: {
  //     redirectUrl: "/casino/qtechjili-lucky-coming",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/lucky-coming.webp",
  //     alt: "lucky coming",
  //     name: "lucky coming",
  //     providerName: "Jili",
  //   },
  //   MagicLamp: {
  //     redirectUrl: "/casino/qtechjili-magic-lamp",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/magic-lamp.webp",
  //     alt: "magic lamp",
  //     name: "magic lamp",
  //     providerName: "Jili",
  //   },
  //   MasterTiger: {
  //     redirectUrl: "/casino/qtechjili-master-tiger",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/master-tiger.webp",
  //     alt: "master tiger",
  //     name: "master tiger",
  //     providerName: "Jili",
  //   },
  //   MayanEmpire: {
  //     redirectUrl: "/casino/qtechjili-mayan-empire",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/mayan-empire.webp",
  //     alt: "mayan -empire",
  //     name: "mayan -empire",
  //     providerName: "Jili",
  //   },
  //   Medusa: {
  //     redirectUrl: "/casino/qtechjili-medusa",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/medusa.webp",
  //     alt: "medusa",
  //     name: "medusa",
  //     providerName: "Jili",
  //   },
  //   MegaAce: {
  //     redirectUrl: "/casino/qtechjili-mega-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/mega-ace.webp",
  //     alt: "mega ace",
  //     name: "mega ace",
  //     providerName: "Jili",
  //   },
  //   MoneyComing: {
  //     redirectUrl: "/casino/qtechjili-money-coming",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/money-coming.webp",
  //     alt: "money coming",
  //     name: "money coming",
  //     providerName: "Jili",
  //   },
  //   MoneyComingExpandedBets: {
  //     redirectUrl: "/casino/qtechjili-money-coming-expanded-bets",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/money-coming-expanded-bets.webp",
  //     alt: "money coming expanded bets",
  //     name: "money coming expanded bets",
  //     providerName: "Jili",
  //   },
  //   MonkeyParty: {
  //     redirectUrl: "/casino/qtechjili-monkey-party",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/monkey-party.webp",
  //     alt: "monkey party",
  //     name: "monkey party",
  //     providerName: "Jili",
  //   },
  //   NekoFortune: {
  //     redirectUrl: "/casino/qtechjili-neko-fortune",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/neko-fortune.webp",
  //     alt: "neko fortune",
  //     name: "neko fortune",
  //     providerName: "Jili",
  //   },
  //   NightCity: {
  //     redirectUrl: "/casino/qtechjili-night-city",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/night-city.webp",
  //     alt: "night city",
  //     name: "night city",
  //     providerName: "Jili",
  //   },
  //   PartyNight: {
  //     redirectUrl: "/casino/qtechjili-party-night",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/party-night.webp",
  //     alt: "party night",
  //     name: "party night",
  //     providerName: "Jili",
  //   },
  //   PartyStar: {
  //     redirectUrl: "/casino/qtechjili-party-star",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/party-star.webp",
  //     alt: "party star",
  //     name: "party star",
  //     providerName: "Jili",
  //   },
  //   PharaohTreasure: {
  //     redirectUrl: "/casino/qtechjili-pharaoh-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/pharaoh-treasure.webp",
  //     alt: "pharaoh treasure",
  //     name: "pharaoh treasure",
  //     providerName: "Jili",
  //   },
  //   PirateQueen: {
  //     redirectUrl: "/casino/qtechjili-pirate-queen",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/pirate-queen.webp",
  //     alt: "pirate queen",
  //     name: "pirate queen",
  //     providerName: "Jili",
  //   },
  //   Poseidon: {
  //     redirectUrl: "/casino/qtechjili-poseidon",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/poseidon.webp",
  //     alt: "poseidon",
  //     name: "poseidon",
  //     providerName: "Jili",
  //   },
  //   PotionWizard: {
  //     redirectUrl: "/casino/qtechjili-potion-wizard",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/potion-wizard.webp",
  //     alt: "potion wizard",
  //     name: "potion wizard",
  //     providerName: "Jili",
  //   },
  //   RomaX: {
  //     redirectUrl: "/casino/qtechjili-roma-x",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/roma-x.webp",
  //     alt: "roma x",
  //     name: "roma x",
  //     providerName: "Jili",
  //   },
  //   Samba: {
  //     redirectUrl: "/casino/qtechjili-samba",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/samba.webp",
  //     alt: "samba",
  //     name: "samba",
  //     providerName: "Jili",
  //   },
  //   SecretTreasure: {
  //     redirectUrl: "/casino/qtechjili-secret-treasure",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/secret-treasure.webp",
  //     alt: "secret treasure",
  //     name: "secret treasure",
  //     providerName: "Jili",
  //   },
  //   ShanghaiBeauty: {
  //     redirectUrl: "/casino/qtechjili-shanghai-beauty",
  //     code: "jili",
  //     casino: "spribe",
  //     provider: "aviator",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/shanghai-beauty.webp",
  //     alt: "ShanghaiBeauty",
  //     name: "Shanghai Beauty",
  //     providerName: "Jili",
  //   },
  //   SinCity: {
  //     redirectUrl: "/casino/qtechjili-sin-city",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/sin-city.webp",
  //     alt: "sin city",
  //     name: "sin city",
  //     providerName: "Jili",
  //   },
  //   SuperAce: {
  //     redirectUrl: "/casino/qtechjili-super-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-ace.webp",
  //     alt: "super ace",
  //     name: "super ace",
  //     providerName: "Jili",
  //   },
  //   SuperAceDeluxe: {
  //     redirectUrl: "/casino/qtechjili-super-ace-deluxe",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-ace-deluxe.webp",
  //     alt: "super ace deluxe",
  //     name: "super ace deluxe",
  //     providerName: "Jili",
  //   },
  //   SuperRich: {
  //     redirectUrl: "/casino/qtechjili-super-rich",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/super-rich.webp",
  //     alt: "super rich",
  //     name: "super rich",
  //     providerName: "Jili",
  //   },
  //   SweetLand: {
  //     redirectUrl: "/casino/qtechjili-sweet-land",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/sweet-land.webp",
  //     alt: "sweet land",
  //     name: "sweet land",
  //     providerName: "Jili",
  //   },
  //   ThorX: {
  //     redirectUrl: "/casino/qtechjili-thor-x",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/thor-x.webp",
  //     alt: "thor x",
  //     name: "thor x",
  //     providerName: "Jili",
  //   },
  //   TrialOfPhoenix: {
  //     redirectUrl: "/casino/qtechjili-trial-of-phoenix",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/trial-of-phoenix.webp",
  //     alt: "trial of phoenix",
  //     name: "trial of phoenix",
  //     providerName: "Jili",
  //   },
  //   TwinWins: {
  //     redirectUrl: "/casino/qtechjili-twin-wins",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/twin-wins.webp",
  //     alt: "twin wins",
  //     name: "twin wins",
  //     providerName: "Jili",
  //   },
  //   WarOfDragons: {
  //     redirectUrl: "/casino/qtechjili-war-of-dragons",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/war-of-dragons.webp",
  //     alt: "war of dragons",
  //     name: "war of dragons",
  //     providerName: "Jili",
  //   },
  //   WildAce: {
  //     redirectUrl: "/casino/qtechjili-wild-ace",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/wild-ace.webp",
  //     alt: "wild ace",
  //     name: "wild ace",
  //     providerName: "Jili",
  //   },
  //   WildRacer: {
  //     redirectUrl: "/casino/qtechjili-wild-racer",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/wild-racer.webp",
  //     alt: "wild racer",
  //     name: "wild racer",
  //     providerName: "Jili",
  //   },
  //   WitchesNight: {
  //     redirectUrl: "/casino/qtechjili-witches-night",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/witches-night.webp",
  //     alt: "witches' night",
  //     name: "witches' night",
  //     providerName: "Jili",
  //   },
  //   WorldCup: {
  //     redirectUrl: "/casino/qtechjili-world-cup",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/world-cup.webp",
  //     alt: "world cup",
  //     name: "world cup",
  //     providerName: "Jili",
  //   },
  //   Xiyangyang: {
  //     redirectUrl: "/casino/qtechjili-xiyangyang",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/xiyangyang.webp",
  //     alt: "xiyangyang",
  //     name: "xiyangyang",
  //     providerName: "Jili",
  //   },
  //   Zeus: {
  //     redirectUrl: "/casino/qtechjili-zeus",
  //     code: "jili",
  //     casino: "jili",
  //     provider: "QTECH",
  //     homeUrl: "http://localhost:3000/Casino",
  //     imgUrl: "./images/jili/zeus.webp",
  //     alt: "zeus",
  //     name: "zeus",
  //     providerName: "Jili",
  //   },
  // },

  // jiliGaming: {
  //   PirateQueen: {
  //     code: "98567",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Pirate Queen",
  //     name: "Pirate Queen",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-pirate-queen",
  //   },
  //   WildRacer: {
  //     code: "56768",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Wild Racer",
  //     name: "Wild Racer",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-wild-racer",
  //   },
  //   NekoFortune: {
  //     code: "98790",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Neko Fortune",
  //     name: "Neko Fortune",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-neko-fortune",
  //   },
  //   Samba: {
  //     code: "98789",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Samba",
  //     name: "Samba",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-samba",
  //   },
  //   WorldCup: {
  //     code: "56968",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "World Cup",
  //     name: "World Cup",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-world-cup",
  //   },
  //   BonusHunter: {
  //     code: "67660",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Bonus Hunter",
  //     name: "Bonus Hunter",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
  //   },
  //   JILICAISHEN: {
  //     code: "67580",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "JILI CAISHEN",
  //     name: "JILI CAISHEN",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-jili-caishen",
  //   },
  //   MayanEmpire: {
  //     code: "67600",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Mayan Empire",
  //     name: "Mayan Empire",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/mayanempire.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-mayan-empire",
  //   },
  //   BoneFortune: {
  //     code: "87564",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Bone Fortune",
  //     name: "Bone Fortune",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bonefortune.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-bone-fortune",
  //   },
  //   GoldRush: {
  //     code: "67620",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Gold Rush",
  //     name: "Gold Rush",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/goldrush.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-gold-rush",
  //   },
  //   HappyTaxi: {
  //     code: "67567",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Happy Taxi",
  //     name: "Happy Taxi",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-happy-taxi",
  //   },
  //   ThorX: {
  //     code: "67570",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Thor X",
  //     name: "Thor X",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-thor-x",
  //   },
  //   BookofGold: {
  //     code: "56767",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Book of Gold",
  //     name: "Book of Gold",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-book-of-gold",
  //   },
  //   Medusa: {
  //     code: "98788",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Medusa",
  //     name: "Medusa",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-medusa",
  //   },
  //   GoGoalBingo: {
  //     code: "98791",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Go Goal Bingo",
  //     name: "Go Goal Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
  //   },
  //   ColorGame: {
  //     code: "67630",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Color Game",
  //     name: "Color Game",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-color-game",
  //   },
  //   JackpotBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Jackpot Bingo",
  //     name: "Jackpot Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
  //   },
  //   LuckyBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Lucky Bingo",
  //     name: "Lucky Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
  //   },
  //   WinDrop: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Win Drop",
  //     name: "Win Drop",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-win-drop",
  //   },
  //   FortuneBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Fortune Bingo",
  //     name: "Fortune Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
  //   },
  //   Baccarat: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Baccarat",
  //     name: "Baccarat",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-baccarat",
  //   },
  //   iRichBingo: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "iRich Bingo",
  //     name: "iRich Bingo",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-irich-bingo",
  //   },
  //   DragonTiger: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Dragon & Tiger",
  //     name: "Dragon & Tiger",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
  //   },
  //   BigSmall: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Big Small",
  //     name: "Big Small",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Bigsmall.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-big-small",
  //   },
  //   GoldenJoker: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Golden Joker",
  //     name: "Golden Joker",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-golden-joker",
  //   },
  //   MasterTiger: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Master Tiger",
  //     name: "Master Tiger",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-master-tiger",
  //   },
  //   WildAce: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Wild Ace",
  //     name: "Wild Ace",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Wildace.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-wild-ace",
  //   },
  //   Crazy777: {
  //     code: "98566",
  //     casino: "aura",
  //     provider: "ALT_GAMING_GAP",
  //     homeUrl: "http://localhost:3000/Casino",
  //     alt: "Crazy 777",
  //     name: "Crazy 777",
  //     providerName: "Jili Gaming",
  //     imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
  //     redirectUrl: "/casino/aggapjiligaming-crazy777",
  //   },
  // },
};
